import * as Rr from "bootstrap";
import { defineComponent as te, createBlock as ie, openBlock as k, resolveDynamicComponent as Re, normalizeClass as R, withCtx as z, createElementVNode as M, resolveComponent as se, createElementBlock as P, renderSlot as $, Fragment as ae, createCommentVNode as U, toDisplayString as G, renderList as we, createTextVNode as Z, mergeProps as Zt, withDirectives as _e, vShow as $e, withModifiers as ue, withKeys as he, createVNode as pe, Transition as cu, normalizeStyle as ht, createSlots as eu, normalizeProps as Ue, guardReactiveProps as He, nextTick as Vr } from "vue";
import Sr from "vue-datepicker-next";
import oe from "moment";
let Fr = 0;
function de(e = "", t = "") {
  const i = Math.random().toString(16).substring(2);
  return `${e}${i}${Fr++}${t}`;
}
const jr = te({
  name: "DpsIconButton",
  props: {
    /**
     * Icon to be displayed in the button.
     */
    icon: {
      type: String,
      required: !0
    },
    /**
     * Applies the 'danger' styles to the button.
     * @default false
     */
    danger: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Show a loading spinner.
     * @default undefined
     */
    loading: {
      type: Boolean,
      default: void 0,
      required: !1
    },
    /**
     * The HTML button type attribute. If undefined
     * the type defaults to 'button'.
     * @default undefined
     */
    type: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The URL that the hyperlink points to.
     * If href is set an anchor
     * element is rendered instead of a button.
     * @default undefined
     */
    href: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the button gets clicked.
     */
    "click"
  ],
  computed: {
    typeAttribute() {
      if (!this.href)
        return this.type ? this.type : "button";
    }
  },
  methods: {
    handleClick(e) {
      this.disabled || this.loading ? e.preventDefault() : this.$emit("click", e);
    }
  }
}), W = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [s, l] of t)
    i[s] = l;
  return i;
}, Ur = ["role"];
function Hr(e, t, i, s, l, d) {
  return k(), ie(Re(e.href ? "a" : "button"), {
    class: R(["dps-icon-button", {
      "dps-icon-button--danger": e.danger,
      "dps-icon-button--disabled": e.disabled,
      "dps-icon-button--loading": e.loading
    }]),
    type: e.typeAttribute,
    href: e.href,
    disabled: e.disabled || e.loading,
    onClick: e.handleClick
  }, {
    default: z(() => [
      M("span", {
        class: R(["dps-icon", {
          "dps-icon--loading-circle": e.loading,
          ["dps-icon--" + e.icon]: !e.loading
        }]),
        role: e.loading ? "status" : void 0,
        "aria-hidden": "true"
      }, null, 10, Ur)
    ]),
    _: 1
  }, 8, ["class", "type", "href", "disabled", "onClick"]);
}
const xr = /* @__PURE__ */ W(jr, [["render", Hr]]), zr = te({
  name: "DpsActionMenu",
  components: { DpsIconButton: xr },
  props: {
    /**
     * The unique identifier for the menu.
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The HTML tag to be used for the menu container.
     * @default "ul"
     */
    tag: {
      type: String,
      default: "ul",
      required: !1
    },
    /**
     * The icon to be used for the trigger button.
     * @default "more"
     */
    icon: {
      type: String,
      default: "more",
      required: !1
    },
    /**
     * The label for the trigger button.
     * @default ""
     */
    label: {
      type: String,
      default: "",
      required: !1
    },
    /**
     * The title attribute for the trigger button.
     * @default "Aktions-Menu öffnen"
     */
    title: {
      type: String,
      default: "Aktions-Menu öffnen",
      required: !1
    },
    /**
     * Whether to show a close button in the menu.
     * @default false
     */
    showCloseButton: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Whether to show a chevron icon in the trigger button.
     * @default false
     */
    showTriggerChevron: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * The headline text for the menu.
     * @default undefined
     */
    headline: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Whether the menu should automatically close after an action is selected.
     * @default true
     */
    autoClose: {
      type: Boolean,
      default: !0,
      required: !1
    },
    /**
     * Whether the menu is disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: [
    /**
     * Emitted when the menu is hidden.
     * @event module:DpsActionMenu#hide
     */
    "hide",
    /**
     * Emitted when the menu is shown.
     * @event module:DpsActionMenu#show
     */
    "show"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-action-menu-");
    },
    dropdownElement() {
      return document.getElementById(this.uniqueId);
    },
    dropdownBootstrapElement() {
      if (this.dropdownElement)
        return new window.Bootstrap.Dropdown(this.dropdownElement);
    },
    isHeaderVisible() {
      return this.showCloseButton || this.headline;
    }
  },
  mounted() {
    this.dropdownElement && (this.dropdownElement.addEventListener("hide.bs.dropdown", (e) => {
      this.$emit("hide", e);
    }), this.dropdownElement.addEventListener("show.bs.dropdown", (e) => {
      this.$emit("show", e);
    }));
  }
}), Gr = { class: "dps-action-menu" }, Yr = ["id", "title", "disabled", "data-bs-auto-close"], Wr = { class: "dps-action-menu__trigger-button-label" }, Kr = {
  key: 0,
  class: "dps-icon dps-icon--chevron-down"
}, Jr = ["aria-labelledby"], Xr = {
  key: 0,
  class: "dps-action-menu__dropdown-header"
}, Qr = {
  key: 0,
  class: "dps-action-menu__dropdown-headline"
};
function Zr(e, t, i, s, l, d) {
  const n = se("DpsIconButton");
  return k(), P("div", Gr, [
    $(e.$slots, "trigger", {}, () => [
      M("button", {
        id: e.uniqueId,
        type: "button",
        class: R(["dps-action-menu__trigger-button", {
          "dps-action-menu__trigger-button--icon": !e.label,
          "dps-action-menu__trigger-button--text": e.label,
          "dps-action-menu__trigger-button--disabled": e.disabled
        }]),
        title: e.title,
        disabled: e.disabled,
        "aria-label": "Toggle dropdown",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        "data-bs-offset": "0,10",
        "data-bs-auto-close": e.autoClose ? "true" : "outside"
      }, [
        e.label ? (k(), P(ae, { key: 0 }, [
          M("span", Wr, G(e.label), 1),
          e.showTriggerChevron ? (k(), P("span", Kr)) : U("", !0)
        ], 64)) : (k(), P("span", {
          key: 1,
          class: R(["dps-icon", "dps-icon--" + e.icon])
        }, null, 2))
      ], 10, Yr)
    ]),
    M("div", {
      class: R(["dps-action-menu__dropdown dropdown-menu", { "dps-action-menu__dropdown--with-header": e.isHeaderVisible }]),
      "aria-labelledby": e.uniqueId
    }, [
      e.isHeaderVisible ? (k(), P("header", Xr, [
        e.headline ? (k(), P("div", Qr, G(e.headline), 1)) : U("", !0),
        e.showCloseButton ? (k(), ie(n, {
          key: 1,
          class: "dps-action-menu__dropdown-close-button",
          title: "Schließen",
          "aria-label": "Schließen",
          icon: "close",
          onClick: t[0] || (t[0] = (f) => {
            var h;
            return (h = e.dropdownBootstrapElement) == null ? void 0 : h.hide();
          })
        })) : U("", !0)
      ])) : U("", !0),
      (k(), ie(Re(e.tag), { class: "dps-action-menu__dropdown-list" }, {
        default: z(() => [
          $(e.$slots, "default")
        ]),
        _: 3
      }))
    ], 10, Jr)
  ]);
}
const Ha = /* @__PURE__ */ W(zr, [["render", Zr]]), ei = te({
  name: "DpsActionMenuItem",
  props: {
    /**
     * The icon displayed before the menu item
     * @default undefined
     */
    icon: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * The title attribute of the menu item
     * @default undefined
     */
    title: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Disables the menu item.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * The link target attribute.(e.g.: _blank)
     * @default undefined
     */
    target: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * The URL that the hyperlink points to.
     * @default undefined
     */
    href: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * The relationship of the linked URL as space-separated link types.
     * @default undefined
     */
    rel: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Applies the 'danger' styles (red on hover).
     * @default false
     */
    danger: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * HTML tag of the wrapper element.
     * @default 'li'
     */
    tag: {
      type: String,
      default: "li"
    }
  },
  emits: [
    /**
     * Emitted when the element is clicked.
     * @event module:DPSActionMenuItem#click
     */
    "click"
  ],
  methods: {
    handleClick(e) {
      this.disabled || this.$emit("click", e);
    }
  }
}), ti = { class: "dps-action-menu-item__text" };
function ui(e, t, i, s, l, d) {
  return k(), ie(Re(e.tag), { class: "dps-action-menu-item" }, {
    default: z(() => [
      (k(), ie(Re(e.href ? "a" : "button"), {
        type: e.href ? void 0 : "button",
        href: e.href,
        rel: e.rel,
        target: e.target,
        title: e.title,
        class: R(["dps-action-menu-item__element", {
          "dps-action-menu-item__element--danger": e.danger,
          "dps-action-menu-item__element--disabled": e.disabled
        }]),
        disabled: e.disabled,
        onClick: e.handleClick
      }, {
        default: z(() => [
          e.icon ? (k(), P("span", {
            key: 0,
            class: R(["dps-action-menu-item__icon dps-icon", "dps-icon--" + e.icon])
          }, null, 2)) : U("", !0),
          M("span", ti, [
            $(e.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["type", "href", "rel", "target", "title", "class", "disabled", "onClick"]))
    ]),
    _: 3
  });
}
const za = /* @__PURE__ */ W(ei, [["render", ui]]), ri = te({
  name: "DpsAlphabeticFilter",
  props: {
    /**
     * Array of available filter options.
     * @default ["A-G", "H-N", "O-U", "V-Z"]
     */
    options: {
      type: Array,
      default: () => ["A-G", "H-N", "O-U", "V-Z"],
      required: !1
    },
    /**
     * The modelValue
     * @default undefined
     */
    modelValue: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Requires some option to be active.
     * @default false
     */
    required: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsAlphabeticFilter#update:modelValue
     */
    "update:modelValue"
  ],
  methods: {
    selectOption(e) {
      let t = e;
      this.disabled || (this.required ? t !== this.modelValue && this.$emit("update:modelValue", t) : (t = t === this.modelValue ? void 0 : e, this.$emit("update:modelValue", t)));
    }
  }
}), ii = ["aria-selected", "disabled", "onClick"];
function ni(e, t, i, s, l, d) {
  return k(), P("ul", {
    role: "tablist",
    class: R(["dps-alphabetic-filter", { "dps-alphabetic-filter--disabled": e.disabled }])
  }, [
    (k(!0), P(ae, null, we(e.options, (n, f) => (k(), P("li", {
      key: "alphabetic-filter-" + f,
      class: "dps-alphabetic-filter__list-item",
      role: "presentation"
    }, [
      M("button", {
        class: R(["dps-alphabetic-filter__option-button", {
          "dps-alphabetic-filter__option-button--active": e.modelValue === n
        }]),
        type: "button",
        role: "tab",
        "aria-controls": "filter",
        "aria-selected": e.modelValue === n,
        disabled: e.disabled,
        onClick: (h) => e.selectOption(n)
      }, G(n), 11, ii)
    ]))), 128))
  ], 2);
}
const Ga = /* @__PURE__ */ W(ri, [["render", ni]]), si = te({
  name: "DpsBadge",
  props: {
    /**
     * Determines the styling of the badge.
     * @default undefined
     */
    variant: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Rounds the badge.
     * @default false
     */
    rounded: {
      type: Boolean,
      default: !1
    }
  }
});
function ai(e, t, i, s, l, d) {
  return k(), P("span", {
    class: R(["dps-badge", {
      ["dps-badge--" + e.variant]: e.variant,
      "dps-badge--rounded": e.rounded
    }])
  }, [
    $(e.$slots, "default")
  ], 2);
}
const li = /* @__PURE__ */ W(si, [["render", ai]]), oi = te({
  name: "DpsButton",
  props: {
    /**
     * The HTML button type (ignored when used as a link).
     * When not set defaults to 'button'.
     * @default undefined
     */
    type: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The URL that the hyperlink points to.
     * When set the component will be rendered as an anchor element.
     * @default undefined
     */
    href: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Determines the styling of the component.
     * @default undefined
     */
    variant: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Determines the size of the button.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Squared edges.
     * @default false
     */
    squared: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Optional icon displayed inside the button.
     * @default undefined
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Position of the icon.
     * @default 'start'
     */
    iconPosition: {
      type: String,
      required: !1,
      default: "start"
    },
    /**
     * Removes the padding.
     * @default false
     */
    noPadding: {
      type: Boolean,
      required: !1,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the button gets clicked.
     * @event module:DpsButton#click
     */
    "click"
  ],
  computed: {
    typeAttribute() {
      if (!this.href)
        return this.type ? this.type : "button";
    }
  },
  methods: {
    handleClick(e) {
      this.disabled || this.loading ? e.preventDefault() : this.$emit("click", e);
    }
  }
}), di = ["role"], ci = {
  key: 1,
  class: "dps-button__text"
}, fi = ["role"], hi = {
  key: 1,
  class: "dps-button__text"
};
function pi(e, t, i, s, l, d) {
  return k(), ie(Re(e.href ? "a" : "button"), {
    class: R(["dps-button", {
      "dps-button--squared": e.squared,
      ["dps-button--size-" + e.size]: e.size,
      ["dps-button--" + e.variant]: e.variant,
      "dps-button--disabled": e.disabled,
      "dps-button--loading": e.loading,
      "dps-button--no-padding": e.noPadding
    }]),
    type: e.typeAttribute,
    href: e.href,
    disabled: e.disabled || e.loading,
    onClick: e.handleClick
  }, {
    default: z(() => [
      e.icon || e.loading ? (k(), P(ae, { key: 0 }, [
        e.iconPosition === "start" ? (k(), P("span", {
          key: 0,
          class: R(["dps-icon", {
            "dps-icon--loading-circle": e.loading,
            ["dps-icon--" + e.icon]: !e.loading
          }]),
          role: e.loading ? "status" : void 0,
          "aria-hidden": "true"
        }, null, 10, di)) : U("", !0),
        e.$slots.default ? (k(), P("span", ci, [
          $(e.$slots, "default")
        ])) : U("", !0),
        e.iconPosition === "end" ? (k(), P("span", {
          key: 2,
          class: R(["dps-icon", {
            "dps-icon--loading-circle": e.loading,
            ["dps-icon--" + e.icon]: !e.loading
          }]),
          role: e.loading ? "status" : void 0,
          "aria-hidden": "true"
        }, null, 10, fi)) : U("", !0)
      ], 64)) : e.variant === "link" || e.variant === "link-darker" ? (k(), P("span", hi, [
        $(e.$slots, "default")
      ])) : $(e.$slots, "default", { key: 2 })
    ]),
    _: 3
  }, 8, ["class", "type", "href", "disabled", "onClick"]);
}
const it = /* @__PURE__ */ W(oi, [["render", pi]]), bi = te({
  name: "DpsCollapsible",
  props: {
    /**
     * The unique identifier for the menu (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Collapsible expanded.
     * @default false
     */
    expanded: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether the collapsible can not be interacted with.
     * @default false
     */
    locked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Size of the collapsible.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Styling of the collapsible.
     * @default undefined
     */
    variant: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Headline text when collapsible is expanded.
     * @default undefined
     */
    toggleTextExpanded: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Headline text when collapsible is not expanded.
     * @default undefined
     */
    toggleText: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Custom icon class for the trigger button.
     * @default undefined
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted immediately when collapsible content gets hidden.
     * @event module:DpsCollapsible#hide-collapsible
     */
    "hide-collapsible",
    /**
     * Emitted when collapsible content has been hidden (after CSS transitions).
     * @event module:DpsCollapsible#hidden-collapsible
     */
    "hidden-collapsible",
    /**
     * Emitted immediately when collapsible content gets shown.
     * @event module:DpsCollapsible#show-collapsible
     */
    "show-collapsible",
    /**
     * Emitted when collapsible content has been made visible (after CSS transitions).
     * @event module:DpsCollapsible#shown-collapsible
     */
    "shown-collapsible"
  ],
  data() {
    return {
      isExpanded: !1
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-collapsible-");
    }
  },
  watch: {
    expanded(e) {
      this.isExpanded = e;
    }
  },
  mounted() {
    const e = this.$refs.collapsible;
    this.isExpanded = this.expanded, e && (e.addEventListener("hide.bs.collapse", (t) => {
      t.target === t.currentTarget && (t.stopPropagation(), this.isExpanded = !1, this.$emit("hide-collapsible", t));
    }), e.addEventListener("hidden.bs.collapse", (t) => {
      t.target === t.currentTarget && (t.stopPropagation(), this.$emit("hidden-collapsible", t));
    }), e.addEventListener("show.bs.collapse", (t) => {
      t.target === t.currentTarget && (t.stopPropagation(), this.isExpanded = !0, this.$emit("show-collapsible", t));
    }), e.addEventListener("shown.bs.collapse", (t) => {
      t.target === t.currentTarget && (t.stopPropagation(), this.$emit("shown-collapsible", t));
    }));
  }
}), mi = { class: "dps-collapsible__header" }, gi = ["data-bs-target", "aria-expanded", "aria-controls"], yi = ["id"], vi = { class: "dps-collapsible__body" };
function wi(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-collapsible", {
      "dps-collapsible--expanded": e.isExpanded,
      ["dps-collapsible--" + e.variant]: e.variant,
      ["dps-collapsible--size-" + e.size]: e.size
    }])
  }, [
    M("div", mi, [
      e.locked ? $(e.$slots, "header", { key: 0 }, () => [
        Z(G(e.isExpanded && e.toggleTextExpanded || e.toggleText), 1)
      ]) : (k(), P("button", {
        key: 1,
        class: "dps-collapsible__trigger-button",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#" + e.uniqueId,
        "aria-expanded": e.expanded,
        "aria-controls": e.uniqueId
      }, [
        M("span", {
          class: R([
            "dps-icon",
            e.icon ? "dps-icon--" + e.icon : {
              "dps-icon--chevron-down": e.size === "lg" && e.variant !== "tertiary",
              "dps-icon--chevron-down-small": e.size !== "lg" && e.variant !== "tertiary",
              "dps-icon--plus": e.variant === "tertiary" && !e.isExpanded,
              "dps-icon--minus": e.variant === "tertiary" && e.isExpanded
            }
          ])
        }, null, 2),
        $(e.$slots, "header", {}, () => [
          Z(G(e.isExpanded && e.toggleTextExpanded || e.toggleText), 1)
        ])
      ], 8, gi))
    ]),
    M("div", {
      id: e.locked ? void 0 : e.uniqueId,
      ref: "collapsible",
      class: R(["dps-collapsible__collapsible collapse", { show: e.expanded }])
    }, [
      M("div", vi, [
        $(e.$slots, "default")
      ])
    ], 10, yi)
  ], 2);
}
const Ya = /* @__PURE__ */ W(bi, [["render", wi]]), Si = te({
  name: "DpsFilterButton",
  props: {
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Makes the button readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Title attribute of the button.
     * @default undefined
     */
    title: {
      type: String,
      default: void 0,
      required: !1
    }
  },
  emits: [
    /**
     * Emitted when the button is clicked.
     * @event module:DpsFilterButton#click
     */
    "click"
  ],
  computed: {
    titleAttribute() {
      return this.title ? this.title : "Filter entfernen";
    }
  },
  methods: {
    handleClick(e) {
      this.disabled || this.$emit("click", e);
    }
  }
}), xi = ["title", "disabled"];
function Ei(e, t, i, s, l, d) {
  return k(), P("button", {
    class: R(["dps-filter-button", {
      "dps-filter-button--disabled": e.disabled,
      "dps-filter-button--readonly": e.readonly
    }]),
    type: "button",
    title: e.titleAttribute,
    disabled: e.disabled || e.readonly,
    onClick: t[0] || (t[0] = (...n) => e.handleClick && e.handleClick(...n))
  }, [
    M("span", null, [
      $(e.$slots, "default")
    ]),
    t[1] || (t[1] = M("span", { class: "dps-icon dps-icon--close" }, null, -1))
  ], 10, xi);
}
const qi = /* @__PURE__ */ W(Si, [["render", Ei]]), Ai = te({
  name: "DpsFormCheckbox",
  inheritAttrs: !1,
  props: {
    /**
     * The unique identifier for the checkbox (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * modelValue of the checkbox.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number, Array],
      required: !1,
      default: void 0
    },
    /**
     * Name attribute of the input.
     * @default undefined
     */
    name: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Value attribute of the input.
     * @default true
     */
    value: {
      type: [String, Boolean, Number],
      required: !1,
      default: !0
    },
    /**
     * Title attribute of the component.
     * @default undefined
     */
    tooltip: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Disables the checkbox.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Checkbox is displayed as block.
     * @default false
     */
    block: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Truncates the label.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The size of the component.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: !1,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     * @event module:DpsFormCheckbox#update:modelValue
     */
    "update:modelValue"
  ],
  computed: {
    outerClass() {
      return this.class;
    },
    uniqueId() {
      return this.id ? this.id : de("dps-form-checkbox-");
    },
    isChecked() {
      return Array.isArray(this.modelValue) ? this.modelValue.includes(this.value) : this.modelValue === this.value;
    }
  },
  methods: {
    handleChange(e) {
      const i = e.target.value;
      let s;
      Array.isArray(this.modelValue) ? (s = [...this.modelValue], this.modelValue.includes(i) ? s = s.filter((l) => l !== i) : s = [...s, i]) : typeof this.modelValue == "boolean" ? (s = !1, this.modelValue !== !!i && (s = !!i)) : typeof this.modelValue == "number" ? (s = 0, this.modelValue !== Number(i) && (s = Number(i))) : (s = "", this.modelValue !== i && (s = i)), this.$emit("update:modelValue", s);
    }
  }
}), ki = ["id", "name", "value", "checked", "disabled", "readonly"], Ti = ["for", "title"], Di = {
  key: 0,
  class: "sr-only"
};
function Ci(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-form-checkbox dps-input-wrapper", {
      ["dps-form-checkbox--size-" + e.size]: e.size,
      "dps-form-checkbox--block": e.block || e.truncate,
      [e.outerClass]: !0
    }])
  }, [
    M("input", Zt(e.$attrs, {
      id: e.uniqueId,
      class: ["dps-form-checkbox__input dps-checkbox", {
        ["dps-checkbox--size-" + e.size]: e.size,
        "dps-checkbox--error": e.error
      }],
      type: "checkbox",
      name: e.name,
      value: e.value,
      checked: e.isChecked,
      disabled: e.disabled || e.readonly,
      readonly: e.readonly,
      onChange: t[0] || (t[0] = (...n) => e.handleChange && e.handleChange(...n))
    }), null, 16, ki),
    M("label", {
      for: e.uniqueId,
      title: e.tooltip,
      class: R(["dps-form-checkbox__label dps-label", {
        "dps-form-checkbox__label--input-only": e.hideLabel,
        "dps-text--ellipse": e.truncate
      }])
    }, [
      e.hideLabel ? (k(), P("span", Di, [
        $(e.$slots, "default")
      ])) : $(e.$slots, "default", { key: 1 })
    ], 10, Ti)
  ], 2);
}
const tu = /* @__PURE__ */ W(Ai, [["render", Ci]]);
function Oi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Pi(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var i = function s() {
      return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(s) {
    var l = Object.getOwnPropertyDescriptor(e, s);
    Object.defineProperty(i, s, l.get ? l : {
      enumerable: !0,
      get: function() {
        return e[s];
      }
    });
  }), i;
}
var me = {}, ge = {}, pt = {}, ye = {}, Ke = {}, fu;
function Li() {
  return fu || (fu = 1, Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Ke;
}
var Je = {}, hu;
function Ii() {
  return hu || (hu = 1, Object.defineProperty(Je, "__esModule", { value: !0 }), Je.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Je;
}
var bt = {}, pu;
function bu() {
  return pu || (pu = 1, function(e) {
    var t;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
    var i = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(d) {
      var n = "";
      return d > 65535 && (d -= 65536, n += String.fromCharCode(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), n += String.fromCharCode(d), n;
    };
    function s(d) {
      var n;
      return d >= 55296 && d <= 57343 || d > 1114111 ? 65533 : (n = i.get(d)) !== null && n !== void 0 ? n : d;
    }
    e.replaceCodePoint = s;
    function l(d) {
      return (0, e.fromCodePoint)(s(d));
    }
    e.default = l;
  }(bt)), bt;
}
var mu;
function rt() {
  return mu || (mu = 1, function(e) {
    var t = ye && ye.__createBinding || (Object.create ? function(q, T, N, _) {
      _ === void 0 && (_ = N);
      var D = Object.getOwnPropertyDescriptor(T, N);
      (!D || ("get" in D ? !T.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
        return T[N];
      } }), Object.defineProperty(q, _, D);
    } : function(q, T, N, _) {
      _ === void 0 && (_ = N), q[_] = T[N];
    }), i = ye && ye.__setModuleDefault || (Object.create ? function(q, T) {
      Object.defineProperty(q, "default", { enumerable: !0, value: T });
    } : function(q, T) {
      q.default = T;
    }), s = ye && ye.__importStar || function(q) {
      if (q && q.__esModule) return q;
      var T = {};
      if (q != null) for (var N in q) N !== "default" && Object.prototype.hasOwnProperty.call(q, N) && t(T, q, N);
      return i(T, q), T;
    }, l = ye && ye.__importDefault || function(q) {
      return q && q.__esModule ? q : { default: q };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
    var d = l(/* @__PURE__ */ Li());
    e.htmlDecodeTree = d.default;
    var n = l(/* @__PURE__ */ Ii());
    e.xmlDecodeTree = n.default;
    var f = s(/* @__PURE__ */ bu());
    e.decodeCodePoint = f.default;
    var h = /* @__PURE__ */ bu();
    Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
      return h.replaceCodePoint;
    } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
      return h.fromCodePoint;
    } });
    var a;
    (function(q) {
      q[q.NUM = 35] = "NUM", q[q.SEMI = 59] = "SEMI", q[q.EQUALS = 61] = "EQUALS", q[q.ZERO = 48] = "ZERO", q[q.NINE = 57] = "NINE", q[q.LOWER_A = 97] = "LOWER_A", q[q.LOWER_F = 102] = "LOWER_F", q[q.LOWER_X = 120] = "LOWER_X", q[q.LOWER_Z = 122] = "LOWER_Z", q[q.UPPER_A = 65] = "UPPER_A", q[q.UPPER_F = 70] = "UPPER_F", q[q.UPPER_Z = 90] = "UPPER_Z";
    })(a || (a = {}));
    var o = 32, m;
    (function(q) {
      q[q.VALUE_LENGTH = 49152] = "VALUE_LENGTH", q[q.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", q[q.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(m = e.BinTrieFlags || (e.BinTrieFlags = {}));
    function u(q) {
      return q >= a.ZERO && q <= a.NINE;
    }
    function r(q) {
      return q >= a.UPPER_A && q <= a.UPPER_F || q >= a.LOWER_A && q <= a.LOWER_F;
    }
    function b(q) {
      return q >= a.UPPER_A && q <= a.UPPER_Z || q >= a.LOWER_A && q <= a.LOWER_Z || u(q);
    }
    function g(q) {
      return q === a.EQUALS || b(q);
    }
    var v;
    (function(q) {
      q[q.EntityStart = 0] = "EntityStart", q[q.NumericStart = 1] = "NumericStart", q[q.NumericDecimal = 2] = "NumericDecimal", q[q.NumericHex = 3] = "NumericHex", q[q.NamedEntity = 4] = "NamedEntity";
    })(v || (v = {}));
    var c;
    (function(q) {
      q[q.Legacy = 0] = "Legacy", q[q.Strict = 1] = "Strict", q[q.Attribute = 2] = "Attribute";
    })(c = e.DecodingMode || (e.DecodingMode = {}));
    var y = (
      /** @class */
      function() {
        function q(T, N, _) {
          this.decodeTree = T, this.emitCodePoint = N, this.errors = _, this.state = v.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = c.Strict;
        }
        return q.prototype.startEntity = function(T) {
          this.decodeMode = T, this.state = v.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, q.prototype.write = function(T, N) {
          switch (this.state) {
            case v.EntityStart:
              return T.charCodeAt(N) === a.NUM ? (this.state = v.NumericStart, this.consumed += 1, this.stateNumericStart(T, N + 1)) : (this.state = v.NamedEntity, this.stateNamedEntity(T, N));
            case v.NumericStart:
              return this.stateNumericStart(T, N);
            case v.NumericDecimal:
              return this.stateNumericDecimal(T, N);
            case v.NumericHex:
              return this.stateNumericHex(T, N);
            case v.NamedEntity:
              return this.stateNamedEntity(T, N);
          }
        }, q.prototype.stateNumericStart = function(T, N) {
          return N >= T.length ? -1 : (T.charCodeAt(N) | o) === a.LOWER_X ? (this.state = v.NumericHex, this.consumed += 1, this.stateNumericHex(T, N + 1)) : (this.state = v.NumericDecimal, this.stateNumericDecimal(T, N));
        }, q.prototype.addToNumericResult = function(T, N, _, D) {
          if (N !== _) {
            var H = _ - N;
            this.result = this.result * Math.pow(D, H) + parseInt(T.substr(N, H), D), this.consumed += H;
          }
        }, q.prototype.stateNumericHex = function(T, N) {
          for (var _ = N; N < T.length; ) {
            var D = T.charCodeAt(N);
            if (u(D) || r(D))
              N += 1;
            else
              return this.addToNumericResult(T, _, N, 16), this.emitNumericEntity(D, 3);
          }
          return this.addToNumericResult(T, _, N, 16), -1;
        }, q.prototype.stateNumericDecimal = function(T, N) {
          for (var _ = N; N < T.length; ) {
            var D = T.charCodeAt(N);
            if (u(D))
              N += 1;
            else
              return this.addToNumericResult(T, _, N, 10), this.emitNumericEntity(D, 2);
          }
          return this.addToNumericResult(T, _, N, 10), -1;
        }, q.prototype.emitNumericEntity = function(T, N) {
          var _;
          if (this.consumed <= N)
            return (_ = this.errors) === null || _ === void 0 || _.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (T === a.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === c.Strict)
            return 0;
          return this.emitCodePoint((0, f.replaceCodePoint)(this.result), this.consumed), this.errors && (T !== a.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, q.prototype.stateNamedEntity = function(T, N) {
          for (var _ = this.decodeTree, D = _[this.treeIndex], H = (D & m.VALUE_LENGTH) >> 14; N < T.length; N++, this.excess++) {
            var Y = T.charCodeAt(N);
            if (this.treeIndex = x(_, D, this.treeIndex + Math.max(1, H), Y), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === c.Attribute && // We shouldn't have consumed any characters after the entity,
              (H === 0 || // And there should be no invalid characters.
              g(Y)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (D = _[this.treeIndex], H = (D & m.VALUE_LENGTH) >> 14, H !== 0) {
              if (Y === a.SEMI)
                return this.emitNamedEntityData(this.treeIndex, H, this.consumed + this.excess);
              this.decodeMode !== c.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, q.prototype.emitNotTerminatedNamedEntity = function() {
          var T, N = this, _ = N.result, D = N.decodeTree, H = (D[_] & m.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(_, H, this.consumed), (T = this.errors) === null || T === void 0 || T.missingSemicolonAfterCharacterReference(), this.consumed;
        }, q.prototype.emitNamedEntityData = function(T, N, _) {
          var D = this.decodeTree;
          return this.emitCodePoint(N === 1 ? D[T] & ~m.VALUE_LENGTH : D[T + 1], _), N === 3 && this.emitCodePoint(D[T + 2], _), _;
        }, q.prototype.end = function() {
          var T;
          switch (this.state) {
            case v.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case v.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case v.NumericHex:
              return this.emitNumericEntity(0, 3);
            case v.NumericStart:
              return (T = this.errors) === null || T === void 0 || T.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case v.EntityStart:
              return 0;
          }
        }, q;
      }()
    );
    e.EntityDecoder = y;
    function w(q) {
      var T = "", N = new y(q, function(_) {
        return T += (0, f.fromCodePoint)(_);
      });
      return function(D, H) {
        for (var Y = 0, X = 0; (X = D.indexOf("&", X)) >= 0; ) {
          T += D.slice(Y, X), N.startEntity(H);
          var re = N.write(
            D,
            // Skip the "&"
            X + 1
          );
          if (re < 0) {
            Y = X + N.end();
            break;
          }
          Y = X + re, X = re === 0 ? Y + 1 : Y;
        }
        var ne = T + D.slice(Y);
        return T = "", ne;
      };
    }
    function x(q, T, N, _) {
      var D = (T & m.BRANCH_LENGTH) >> 7, H = T & m.JUMP_TABLE;
      if (D === 0)
        return H !== 0 && _ === H ? N : -1;
      if (H) {
        var Y = _ - H;
        return Y < 0 || Y >= D ? -1 : q[N + Y] - 1;
      }
      for (var X = N, re = X + D - 1; X <= re; ) {
        var ne = X + re >>> 1, xe = q[ne];
        if (xe < _)
          X = ne + 1;
        else if (xe > _)
          re = ne - 1;
        else
          return q[ne + D];
      }
      return -1;
    }
    e.determineBranch = x;
    var p = w(d.default), S = w(n.default);
    function E(q, T) {
      return T === void 0 && (T = c.Legacy), p(q, T);
    }
    e.decodeHTML = E;
    function A(q) {
      return p(q, c.Attribute);
    }
    e.decodeHTMLAttribute = A;
    function O(q) {
      return p(q, c.Strict);
    }
    e.decodeHTMLStrict = O;
    function L(q) {
      return S(q, c.Strict);
    }
    e.decodeXML = L;
  }(ye)), ye;
}
var gu;
function Er() {
  return gu || (gu = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
    var t = /* @__PURE__ */ rt(), i;
    (function(u) {
      u[u.Tab = 9] = "Tab", u[u.NewLine = 10] = "NewLine", u[u.FormFeed = 12] = "FormFeed", u[u.CarriageReturn = 13] = "CarriageReturn", u[u.Space = 32] = "Space", u[u.ExclamationMark = 33] = "ExclamationMark", u[u.Number = 35] = "Number", u[u.Amp = 38] = "Amp", u[u.SingleQuote = 39] = "SingleQuote", u[u.DoubleQuote = 34] = "DoubleQuote", u[u.Dash = 45] = "Dash", u[u.Slash = 47] = "Slash", u[u.Zero = 48] = "Zero", u[u.Nine = 57] = "Nine", u[u.Semi = 59] = "Semi", u[u.Lt = 60] = "Lt", u[u.Eq = 61] = "Eq", u[u.Gt = 62] = "Gt", u[u.Questionmark = 63] = "Questionmark", u[u.UpperA = 65] = "UpperA", u[u.LowerA = 97] = "LowerA", u[u.UpperF = 70] = "UpperF", u[u.LowerF = 102] = "LowerF", u[u.UpperZ = 90] = "UpperZ", u[u.LowerZ = 122] = "LowerZ", u[u.LowerX = 120] = "LowerX", u[u.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(i || (i = {}));
    var s;
    (function(u) {
      u[u.Text = 1] = "Text", u[u.BeforeTagName = 2] = "BeforeTagName", u[u.InTagName = 3] = "InTagName", u[u.InSelfClosingTag = 4] = "InSelfClosingTag", u[u.BeforeClosingTagName = 5] = "BeforeClosingTagName", u[u.InClosingTagName = 6] = "InClosingTagName", u[u.AfterClosingTagName = 7] = "AfterClosingTagName", u[u.BeforeAttributeName = 8] = "BeforeAttributeName", u[u.InAttributeName = 9] = "InAttributeName", u[u.AfterAttributeName = 10] = "AfterAttributeName", u[u.BeforeAttributeValue = 11] = "BeforeAttributeValue", u[u.InAttributeValueDq = 12] = "InAttributeValueDq", u[u.InAttributeValueSq = 13] = "InAttributeValueSq", u[u.InAttributeValueNq = 14] = "InAttributeValueNq", u[u.BeforeDeclaration = 15] = "BeforeDeclaration", u[u.InDeclaration = 16] = "InDeclaration", u[u.InProcessingInstruction = 17] = "InProcessingInstruction", u[u.BeforeComment = 18] = "BeforeComment", u[u.CDATASequence = 19] = "CDATASequence", u[u.InSpecialComment = 20] = "InSpecialComment", u[u.InCommentLike = 21] = "InCommentLike", u[u.BeforeSpecialS = 22] = "BeforeSpecialS", u[u.SpecialStartSequence = 23] = "SpecialStartSequence", u[u.InSpecialTag = 24] = "InSpecialTag", u[u.BeforeEntity = 25] = "BeforeEntity", u[u.BeforeNumericEntity = 26] = "BeforeNumericEntity", u[u.InNamedEntity = 27] = "InNamedEntity", u[u.InNumericEntity = 28] = "InNumericEntity", u[u.InHexEntity = 29] = "InHexEntity";
    })(s || (s = {}));
    function l(u) {
      return u === i.Space || u === i.NewLine || u === i.Tab || u === i.FormFeed || u === i.CarriageReturn;
    }
    function d(u) {
      return u === i.Slash || u === i.Gt || l(u);
    }
    function n(u) {
      return u >= i.Zero && u <= i.Nine;
    }
    function f(u) {
      return u >= i.LowerA && u <= i.LowerZ || u >= i.UpperA && u <= i.UpperZ;
    }
    function h(u) {
      return u >= i.UpperA && u <= i.UpperF || u >= i.LowerA && u <= i.LowerF;
    }
    var a;
    (function(u) {
      u[u.NoValue = 0] = "NoValue", u[u.Unquoted = 1] = "Unquoted", u[u.Single = 2] = "Single", u[u.Double = 3] = "Double";
    })(a = e.QuoteType || (e.QuoteType = {}));
    var o = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, m = (
      /** @class */
      function() {
        function u(r, b) {
          var g = r.xmlMode, v = g === void 0 ? !1 : g, c = r.decodeEntities, y = c === void 0 ? !0 : c;
          this.cbs = b, this.state = s.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = s.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = v, this.decodeEntities = y, this.entityTrie = v ? t.xmlDecodeTree : t.htmlDecodeTree;
        }
        return u.prototype.reset = function() {
          this.state = s.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = s.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, u.prototype.write = function(r) {
          this.offset += this.buffer.length, this.buffer = r, this.parse();
        }, u.prototype.end = function() {
          this.running && this.finish();
        }, u.prototype.pause = function() {
          this.running = !1;
        }, u.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, u.prototype.getIndex = function() {
          return this.index;
        }, u.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, u.prototype.stateText = function(r) {
          r === i.Lt || !this.decodeEntities && this.fastForwardTo(i.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = s.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && r === i.Amp && (this.state = s.BeforeEntity);
        }, u.prototype.stateSpecialStartSequence = function(r) {
          var b = this.sequenceIndex === this.currentSequence.length, g = b ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            d(r)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (r | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!g)
            this.isSpecial = !1;
          else if (!b) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = s.InTagName, this.stateInTagName(r);
        }, u.prototype.stateInSpecialTag = function(r) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (r === i.Gt || l(r)) {
              var b = this.index - this.currentSequence.length;
              if (this.sectionStart < b) {
                var g = this.index;
                this.index = b, this.cbs.ontext(this.sectionStart, b), this.index = g;
              }
              this.isSpecial = !1, this.sectionStart = b + 2, this.stateInClosingTagName(r);
              return;
            }
            this.sequenceIndex = 0;
          }
          (r | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === o.TitleEnd ? this.decodeEntities && r === i.Amp && (this.state = s.BeforeEntity) : this.fastForwardTo(i.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(r === i.Lt);
        }, u.prototype.stateCDATASequence = function(r) {
          r === o.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === o.Cdata.length && (this.state = s.InCommentLike, this.currentSequence = o.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = s.InDeclaration, this.stateInDeclaration(r));
        }, u.prototype.fastForwardTo = function(r) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === r)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, u.prototype.stateInCommentLike = function(r) {
          r === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === o.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = s.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : r !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, u.prototype.isTagStartChar = function(r) {
          return this.xmlMode ? !d(r) : f(r);
        }, u.prototype.startSpecial = function(r, b) {
          this.isSpecial = !0, this.currentSequence = r, this.sequenceIndex = b, this.state = s.SpecialStartSequence;
        }, u.prototype.stateBeforeTagName = function(r) {
          if (r === i.ExclamationMark)
            this.state = s.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (r === i.Questionmark)
            this.state = s.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(r)) {
            var b = r | 32;
            this.sectionStart = this.index, !this.xmlMode && b === o.TitleEnd[2] ? this.startSpecial(o.TitleEnd, 3) : this.state = !this.xmlMode && b === o.ScriptEnd[2] ? s.BeforeSpecialS : s.InTagName;
          } else r === i.Slash ? this.state = s.BeforeClosingTagName : (this.state = s.Text, this.stateText(r));
        }, u.prototype.stateInTagName = function(r) {
          d(r) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = s.BeforeAttributeName, this.stateBeforeAttributeName(r));
        }, u.prototype.stateBeforeClosingTagName = function(r) {
          l(r) || (r === i.Gt ? this.state = s.Text : (this.state = this.isTagStartChar(r) ? s.InClosingTagName : s.InSpecialComment, this.sectionStart = this.index));
        }, u.prototype.stateInClosingTagName = function(r) {
          (r === i.Gt || l(r)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = s.AfterClosingTagName, this.stateAfterClosingTagName(r));
        }, u.prototype.stateAfterClosingTagName = function(r) {
          (r === i.Gt || this.fastForwardTo(i.Gt)) && (this.state = s.Text, this.baseState = s.Text, this.sectionStart = this.index + 1);
        }, u.prototype.stateBeforeAttributeName = function(r) {
          r === i.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = s.InSpecialTag, this.sequenceIndex = 0) : this.state = s.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : r === i.Slash ? this.state = s.InSelfClosingTag : l(r) || (this.state = s.InAttributeName, this.sectionStart = this.index);
        }, u.prototype.stateInSelfClosingTag = function(r) {
          r === i.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = s.Text, this.baseState = s.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : l(r) || (this.state = s.BeforeAttributeName, this.stateBeforeAttributeName(r));
        }, u.prototype.stateInAttributeName = function(r) {
          (r === i.Eq || d(r)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = s.AfterAttributeName, this.stateAfterAttributeName(r));
        }, u.prototype.stateAfterAttributeName = function(r) {
          r === i.Eq ? this.state = s.BeforeAttributeValue : r === i.Slash || r === i.Gt ? (this.cbs.onattribend(a.NoValue, this.index), this.state = s.BeforeAttributeName, this.stateBeforeAttributeName(r)) : l(r) || (this.cbs.onattribend(a.NoValue, this.index), this.state = s.InAttributeName, this.sectionStart = this.index);
        }, u.prototype.stateBeforeAttributeValue = function(r) {
          r === i.DoubleQuote ? (this.state = s.InAttributeValueDq, this.sectionStart = this.index + 1) : r === i.SingleQuote ? (this.state = s.InAttributeValueSq, this.sectionStart = this.index + 1) : l(r) || (this.sectionStart = this.index, this.state = s.InAttributeValueNq, this.stateInAttributeValueNoQuotes(r));
        }, u.prototype.handleInAttributeValue = function(r, b) {
          r === b || !this.decodeEntities && this.fastForwardTo(b) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(b === i.DoubleQuote ? a.Double : a.Single, this.index), this.state = s.BeforeAttributeName) : this.decodeEntities && r === i.Amp && (this.baseState = this.state, this.state = s.BeforeEntity);
        }, u.prototype.stateInAttributeValueDoubleQuotes = function(r) {
          this.handleInAttributeValue(r, i.DoubleQuote);
        }, u.prototype.stateInAttributeValueSingleQuotes = function(r) {
          this.handleInAttributeValue(r, i.SingleQuote);
        }, u.prototype.stateInAttributeValueNoQuotes = function(r) {
          l(r) || r === i.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(a.Unquoted, this.index), this.state = s.BeforeAttributeName, this.stateBeforeAttributeName(r)) : this.decodeEntities && r === i.Amp && (this.baseState = this.state, this.state = s.BeforeEntity);
        }, u.prototype.stateBeforeDeclaration = function(r) {
          r === i.OpeningSquareBracket ? (this.state = s.CDATASequence, this.sequenceIndex = 0) : this.state = r === i.Dash ? s.BeforeComment : s.InDeclaration;
        }, u.prototype.stateInDeclaration = function(r) {
          (r === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = s.Text, this.sectionStart = this.index + 1);
        }, u.prototype.stateInProcessingInstruction = function(r) {
          (r === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = s.Text, this.sectionStart = this.index + 1);
        }, u.prototype.stateBeforeComment = function(r) {
          r === i.Dash ? (this.state = s.InCommentLike, this.currentSequence = o.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = s.InDeclaration;
        }, u.prototype.stateInSpecialComment = function(r) {
          (r === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = s.Text, this.sectionStart = this.index + 1);
        }, u.prototype.stateBeforeSpecialS = function(r) {
          var b = r | 32;
          b === o.ScriptEnd[3] ? this.startSpecial(o.ScriptEnd, 4) : b === o.StyleEnd[3] ? this.startSpecial(o.StyleEnd, 4) : (this.state = s.InTagName, this.stateInTagName(r));
        }, u.prototype.stateBeforeEntity = function(r) {
          this.entityExcess = 1, this.entityResult = 0, r === i.Number ? this.state = s.BeforeNumericEntity : r === i.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = s.InNamedEntity, this.stateInNamedEntity(r));
        }, u.prototype.stateInNamedEntity = function(r) {
          if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, r), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var b = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
          if (b) {
            var g = (b >> 14) - 1;
            if (!this.allowLegacyEntity() && r !== i.Semi)
              this.trieIndex += g;
            else {
              var v = this.index - this.entityExcess + 1;
              v > this.sectionStart && this.emitPartial(this.sectionStart, v), this.entityResult = this.trieIndex, this.trieIndex += g, this.entityExcess = 0, this.sectionStart = this.index + 1, g === 0 && this.emitNamedEntity();
            }
          }
        }, u.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var r = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (r) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, u.prototype.stateBeforeNumericEntity = function(r) {
          (r | 32) === i.LowerX ? (this.entityExcess++, this.state = s.InHexEntity) : (this.state = s.InNumericEntity, this.stateInNumericEntity(r));
        }, u.prototype.emitNumericEntity = function(r) {
          var b = this.index - this.entityExcess - 1, g = b + 2 + +(this.state === s.InHexEntity);
          g !== this.index && (b > this.sectionStart && this.emitPartial(this.sectionStart, b), this.sectionStart = this.index + Number(r), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, u.prototype.stateInNumericEntity = function(r) {
          r === i.Semi ? this.emitNumericEntity(!0) : n(r) ? (this.entityResult = this.entityResult * 10 + (r - i.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, u.prototype.stateInHexEntity = function(r) {
          r === i.Semi ? this.emitNumericEntity(!0) : n(r) ? (this.entityResult = this.entityResult * 16 + (r - i.Zero), this.entityExcess++) : h(r) ? (this.entityResult = this.entityResult * 16 + ((r | 32) - i.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, u.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === s.Text || this.baseState === s.InSpecialTag);
        }, u.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === s.Text || this.state === s.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === s.InAttributeValueDq || this.state === s.InAttributeValueSq || this.state === s.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, u.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, u.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var r = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case s.Text: {
                this.stateText(r);
                break;
              }
              case s.SpecialStartSequence: {
                this.stateSpecialStartSequence(r);
                break;
              }
              case s.InSpecialTag: {
                this.stateInSpecialTag(r);
                break;
              }
              case s.CDATASequence: {
                this.stateCDATASequence(r);
                break;
              }
              case s.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(r);
                break;
              }
              case s.InAttributeName: {
                this.stateInAttributeName(r);
                break;
              }
              case s.InCommentLike: {
                this.stateInCommentLike(r);
                break;
              }
              case s.InSpecialComment: {
                this.stateInSpecialComment(r);
                break;
              }
              case s.BeforeAttributeName: {
                this.stateBeforeAttributeName(r);
                break;
              }
              case s.InTagName: {
                this.stateInTagName(r);
                break;
              }
              case s.InClosingTagName: {
                this.stateInClosingTagName(r);
                break;
              }
              case s.BeforeTagName: {
                this.stateBeforeTagName(r);
                break;
              }
              case s.AfterAttributeName: {
                this.stateAfterAttributeName(r);
                break;
              }
              case s.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(r);
                break;
              }
              case s.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(r);
                break;
              }
              case s.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(r);
                break;
              }
              case s.AfterClosingTagName: {
                this.stateAfterClosingTagName(r);
                break;
              }
              case s.BeforeSpecialS: {
                this.stateBeforeSpecialS(r);
                break;
              }
              case s.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(r);
                break;
              }
              case s.InSelfClosingTag: {
                this.stateInSelfClosingTag(r);
                break;
              }
              case s.InDeclaration: {
                this.stateInDeclaration(r);
                break;
              }
              case s.BeforeDeclaration: {
                this.stateBeforeDeclaration(r);
                break;
              }
              case s.BeforeComment: {
                this.stateBeforeComment(r);
                break;
              }
              case s.InProcessingInstruction: {
                this.stateInProcessingInstruction(r);
                break;
              }
              case s.InNamedEntity: {
                this.stateInNamedEntity(r);
                break;
              }
              case s.BeforeEntity: {
                this.stateBeforeEntity(r);
                break;
              }
              case s.InHexEntity: {
                this.stateInHexEntity(r);
                break;
              }
              case s.InNumericEntity: {
                this.stateInNumericEntity(r);
                break;
              }
              default:
                this.stateBeforeNumericEntity(r);
            }
            this.index++;
          }
          this.cleanup();
        }, u.prototype.finish = function() {
          this.state === s.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, u.prototype.handleTrailingData = function() {
          var r = this.buffer.length + this.offset;
          this.state === s.InCommentLike ? this.currentSequence === o.CdataEnd ? this.cbs.oncdata(this.sectionStart, r, 0) : this.cbs.oncomment(this.sectionStart, r, 0) : this.state === s.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === s.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === s.InTagName || this.state === s.BeforeAttributeName || this.state === s.BeforeAttributeValue || this.state === s.AfterAttributeName || this.state === s.InAttributeName || this.state === s.InAttributeValueSq || this.state === s.InAttributeValueDq || this.state === s.InAttributeValueNq || this.state === s.InClosingTagName || this.cbs.ontext(this.sectionStart, r);
        }, u.prototype.emitPartial = function(r, b) {
          this.baseState !== s.Text && this.baseState !== s.InSpecialTag ? this.cbs.onattribdata(r, b) : this.cbs.ontext(r, b);
        }, u.prototype.emitCodePoint = function(r) {
          this.baseState !== s.Text && this.baseState !== s.InSpecialTag ? this.cbs.onattribentity(r) : this.cbs.ontextentity(r);
        }, u;
      }()
    );
    e.default = m;
  }(pt)), pt;
}
var yu;
function vu() {
  if (yu) return ge;
  yu = 1;
  var e = ge && ge.__createBinding || (Object.create ? function(v, c, y, w) {
    w === void 0 && (w = y);
    var x = Object.getOwnPropertyDescriptor(c, y);
    (!x || ("get" in x ? !c.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return c[y];
    } }), Object.defineProperty(v, w, x);
  } : function(v, c, y, w) {
    w === void 0 && (w = y), v[w] = c[y];
  }), t = ge && ge.__setModuleDefault || (Object.create ? function(v, c) {
    Object.defineProperty(v, "default", { enumerable: !0, value: c });
  } : function(v, c) {
    v.default = c;
  }), i = ge && ge.__importStar || function(v) {
    if (v && v.__esModule) return v;
    var c = {};
    if (v != null) for (var y in v) y !== "default" && Object.prototype.hasOwnProperty.call(v, y) && e(c, v, y);
    return t(c, v), c;
  };
  Object.defineProperty(ge, "__esModule", { value: !0 }), ge.Parser = void 0;
  var s = i(/* @__PURE__ */ Er()), l = /* @__PURE__ */ rt(), d = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), n = /* @__PURE__ */ new Set(["p"]), f = /* @__PURE__ */ new Set(["thead", "tbody"]), h = /* @__PURE__ */ new Set(["dd", "dt"]), a = /* @__PURE__ */ new Set(["rt", "rp"]), o = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", n],
    ["h1", n],
    ["h2", n],
    ["h3", n],
    ["h4", n],
    ["h5", n],
    ["h6", n],
    ["select", d],
    ["input", d],
    ["output", d],
    ["button", d],
    ["datalist", d],
    ["textarea", d],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", h],
    ["dt", h],
    ["address", n],
    ["article", n],
    ["aside", n],
    ["blockquote", n],
    ["details", n],
    ["div", n],
    ["dl", n],
    ["fieldset", n],
    ["figcaption", n],
    ["figure", n],
    ["footer", n],
    ["form", n],
    ["header", n],
    ["hr", n],
    ["main", n],
    ["nav", n],
    ["ol", n],
    ["pre", n],
    ["section", n],
    ["table", n],
    ["ul", n],
    ["rt", a],
    ["rp", a],
    ["tbody", f],
    ["tfoot", f]
  ]), m = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), u = /* @__PURE__ */ new Set(["math", "svg"]), r = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), b = /\s|\//, g = (
    /** @class */
    function() {
      function v(c, y) {
        y === void 0 && (y = {});
        var w, x, p, S, E;
        this.options = y, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = c ?? {}, this.lowerCaseTagNames = (w = y.lowerCaseTags) !== null && w !== void 0 ? w : !y.xmlMode, this.lowerCaseAttributeNames = (x = y.lowerCaseAttributeNames) !== null && x !== void 0 ? x : !y.xmlMode, this.tokenizer = new ((p = y.Tokenizer) !== null && p !== void 0 ? p : s.default)(this.options, this), (E = (S = this.cbs).onparserinit) === null || E === void 0 || E.call(S, this);
      }
      return v.prototype.ontext = function(c, y) {
        var w, x, p = this.getSlice(c, y);
        this.endIndex = y - 1, (x = (w = this.cbs).ontext) === null || x === void 0 || x.call(w, p), this.startIndex = y;
      }, v.prototype.ontextentity = function(c) {
        var y, w, x = this.tokenizer.getSectionStart();
        this.endIndex = x - 1, (w = (y = this.cbs).ontext) === null || w === void 0 || w.call(y, (0, l.fromCodePoint)(c)), this.startIndex = x;
      }, v.prototype.isVoidElement = function(c) {
        return !this.options.xmlMode && m.has(c);
      }, v.prototype.onopentagname = function(c, y) {
        this.endIndex = y;
        var w = this.getSlice(c, y);
        this.lowerCaseTagNames && (w = w.toLowerCase()), this.emitOpenTag(w);
      }, v.prototype.emitOpenTag = function(c) {
        var y, w, x, p;
        this.openTagStart = this.startIndex, this.tagname = c;
        var S = !this.options.xmlMode && o.get(c);
        if (S)
          for (; this.stack.length > 0 && S.has(this.stack[this.stack.length - 1]); ) {
            var E = this.stack.pop();
            (w = (y = this.cbs).onclosetag) === null || w === void 0 || w.call(y, E, !0);
          }
        this.isVoidElement(c) || (this.stack.push(c), u.has(c) ? this.foreignContext.push(!0) : r.has(c) && this.foreignContext.push(!1)), (p = (x = this.cbs).onopentagname) === null || p === void 0 || p.call(x, c), this.cbs.onopentag && (this.attribs = {});
      }, v.prototype.endOpenTag = function(c) {
        var y, w;
        this.startIndex = this.openTagStart, this.attribs && ((w = (y = this.cbs).onopentag) === null || w === void 0 || w.call(y, this.tagname, this.attribs, c), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, v.prototype.onopentagend = function(c) {
        this.endIndex = c, this.endOpenTag(!1), this.startIndex = c + 1;
      }, v.prototype.onclosetag = function(c, y) {
        var w, x, p, S, E, A;
        this.endIndex = y;
        var O = this.getSlice(c, y);
        if (this.lowerCaseTagNames && (O = O.toLowerCase()), (u.has(O) || r.has(O)) && this.foreignContext.pop(), this.isVoidElement(O))
          !this.options.xmlMode && O === "br" && ((x = (w = this.cbs).onopentagname) === null || x === void 0 || x.call(w, "br"), (S = (p = this.cbs).onopentag) === null || S === void 0 || S.call(p, "br", {}, !0), (A = (E = this.cbs).onclosetag) === null || A === void 0 || A.call(E, "br", !1));
        else {
          var L = this.stack.lastIndexOf(O);
          if (L !== -1)
            if (this.cbs.onclosetag)
              for (var q = this.stack.length - L; q--; )
                this.cbs.onclosetag(this.stack.pop(), q !== 0);
            else
              this.stack.length = L;
          else !this.options.xmlMode && O === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = y + 1;
      }, v.prototype.onselfclosingtag = function(c) {
        this.endIndex = c, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = c + 1) : this.onopentagend(c);
      }, v.prototype.closeCurrentTag = function(c) {
        var y, w, x = this.tagname;
        this.endOpenTag(c), this.stack[this.stack.length - 1] === x && ((w = (y = this.cbs).onclosetag) === null || w === void 0 || w.call(y, x, !c), this.stack.pop());
      }, v.prototype.onattribname = function(c, y) {
        this.startIndex = c;
        var w = this.getSlice(c, y);
        this.attribname = this.lowerCaseAttributeNames ? w.toLowerCase() : w;
      }, v.prototype.onattribdata = function(c, y) {
        this.attribvalue += this.getSlice(c, y);
      }, v.prototype.onattribentity = function(c) {
        this.attribvalue += (0, l.fromCodePoint)(c);
      }, v.prototype.onattribend = function(c, y) {
        var w, x;
        this.endIndex = y, (x = (w = this.cbs).onattribute) === null || x === void 0 || x.call(w, this.attribname, this.attribvalue, c === s.QuoteType.Double ? '"' : c === s.QuoteType.Single ? "'" : c === s.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, v.prototype.getInstructionName = function(c) {
        var y = c.search(b), w = y < 0 ? c : c.substr(0, y);
        return this.lowerCaseTagNames && (w = w.toLowerCase()), w;
      }, v.prototype.ondeclaration = function(c, y) {
        this.endIndex = y;
        var w = this.getSlice(c, y);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(w);
          this.cbs.onprocessinginstruction("!".concat(x), "!".concat(w));
        }
        this.startIndex = y + 1;
      }, v.prototype.onprocessinginstruction = function(c, y) {
        this.endIndex = y;
        var w = this.getSlice(c, y);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(w);
          this.cbs.onprocessinginstruction("?".concat(x), "?".concat(w));
        }
        this.startIndex = y + 1;
      }, v.prototype.oncomment = function(c, y, w) {
        var x, p, S, E;
        this.endIndex = y, (p = (x = this.cbs).oncomment) === null || p === void 0 || p.call(x, this.getSlice(c, y - w)), (E = (S = this.cbs).oncommentend) === null || E === void 0 || E.call(S), this.startIndex = y + 1;
      }, v.prototype.oncdata = function(c, y, w) {
        var x, p, S, E, A, O, L, q, T, N;
        this.endIndex = y;
        var _ = this.getSlice(c, y - w);
        this.options.xmlMode || this.options.recognizeCDATA ? ((p = (x = this.cbs).oncdatastart) === null || p === void 0 || p.call(x), (E = (S = this.cbs).ontext) === null || E === void 0 || E.call(S, _), (O = (A = this.cbs).oncdataend) === null || O === void 0 || O.call(A)) : ((q = (L = this.cbs).oncomment) === null || q === void 0 || q.call(L, "[CDATA[".concat(_, "]]")), (N = (T = this.cbs).oncommentend) === null || N === void 0 || N.call(T)), this.startIndex = y + 1;
      }, v.prototype.onend = function() {
        var c, y;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var w = this.stack.length; w > 0; this.cbs.onclosetag(this.stack[--w], !0))
            ;
        }
        (y = (c = this.cbs).onend) === null || y === void 0 || y.call(c);
      }, v.prototype.reset = function() {
        var c, y, w, x;
        (y = (c = this.cbs).onreset) === null || y === void 0 || y.call(c), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (x = (w = this.cbs).onparserinit) === null || x === void 0 || x.call(w, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, v.prototype.parseComplete = function(c) {
        this.reset(), this.end(c);
      }, v.prototype.getSlice = function(c, y) {
        for (; c - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var w = this.buffers[0].slice(c - this.bufferOffset, y - this.bufferOffset); y - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), w += this.buffers[0].slice(0, y - this.bufferOffset);
        return w;
      }, v.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, v.prototype.write = function(c) {
        var y, w;
        if (this.ended) {
          (w = (y = this.cbs).onerror) === null || w === void 0 || w.call(y, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(c), this.tokenizer.running && (this.tokenizer.write(c), this.writeIndex++);
      }, v.prototype.end = function(c) {
        var y, w;
        if (this.ended) {
          (w = (y = this.cbs).onerror) === null || w === void 0 || w.call(y, new Error(".end() after done!"));
          return;
        }
        c && this.write(c), this.ended = !0, this.tokenizer.end();
      }, v.prototype.pause = function() {
        this.tokenizer.pause();
      }, v.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, v.prototype.parseChunk = function(c) {
        this.write(c);
      }, v.prototype.done = function(c) {
        this.end(c);
      }, v;
    }()
  );
  return ge.Parser = g, ge;
}
var Ne = {}, mt = {}, wu;
function ze() {
  return wu || (wu = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
    var t;
    (function(s) {
      s.Root = "root", s.Text = "text", s.Directive = "directive", s.Comment = "comment", s.Script = "script", s.Style = "style", s.Tag = "tag", s.CDATA = "cdata", s.Doctype = "doctype";
    })(t = e.ElementType || (e.ElementType = {}));
    function i(s) {
      return s.type === t.Tag || s.type === t.Script || s.type === t.Style;
    }
    e.isTag = i, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
  }(mt)), mt;
}
var j = {}, Su;
function xu() {
  if (Su) return j;
  Su = 1;
  var e = j && j.__extends || /* @__PURE__ */ function() {
    var p = function(S, E) {
      return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, O) {
        A.__proto__ = O;
      } || function(A, O) {
        for (var L in O) Object.prototype.hasOwnProperty.call(O, L) && (A[L] = O[L]);
      }, p(S, E);
    };
    return function(S, E) {
      if (typeof E != "function" && E !== null)
        throw new TypeError("Class extends value " + String(E) + " is not a constructor or null");
      p(S, E);
      function A() {
        this.constructor = S;
      }
      S.prototype = E === null ? Object.create(E) : (A.prototype = E.prototype, new A());
    };
  }(), t = j && j.__assign || function() {
    return t = Object.assign || function(p) {
      for (var S, E = 1, A = arguments.length; E < A; E++) {
        S = arguments[E];
        for (var O in S) Object.prototype.hasOwnProperty.call(S, O) && (p[O] = S[O]);
      }
      return p;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(j, "__esModule", { value: !0 }), j.cloneNode = j.hasChildren = j.isDocument = j.isDirective = j.isComment = j.isText = j.isCDATA = j.isTag = j.Element = j.Document = j.CDATA = j.NodeWithChildren = j.ProcessingInstruction = j.Comment = j.Text = j.DataNode = j.Node = void 0;
  var i = /* @__PURE__ */ ze(), s = (
    /** @class */
    function() {
      function p() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(p.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(S) {
          this.parent = S;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(S) {
          this.prev = S;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(S) {
          this.next = S;
        },
        enumerable: !1,
        configurable: !0
      }), p.prototype.cloneNode = function(S) {
        return S === void 0 && (S = !1), w(this, S);
      }, p;
    }()
  );
  j.Node = s;
  var l = (
    /** @class */
    function(p) {
      e(S, p);
      function S(E) {
        var A = p.call(this) || this;
        return A.data = E, A;
      }
      return Object.defineProperty(S.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(E) {
          this.data = E;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(s)
  );
  j.DataNode = l;
  var d = (
    /** @class */
    function(p) {
      e(S, p);
      function S() {
        var E = p !== null && p.apply(this, arguments) || this;
        return E.type = i.ElementType.Text, E;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(l)
  );
  j.Text = d;
  var n = (
    /** @class */
    function(p) {
      e(S, p);
      function S() {
        var E = p !== null && p.apply(this, arguments) || this;
        return E.type = i.ElementType.Comment, E;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(l)
  );
  j.Comment = n;
  var f = (
    /** @class */
    function(p) {
      e(S, p);
      function S(E, A) {
        var O = p.call(this, A) || this;
        return O.name = E, O.type = i.ElementType.Directive, O;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(l)
  );
  j.ProcessingInstruction = f;
  var h = (
    /** @class */
    function(p) {
      e(S, p);
      function S(E) {
        var A = p.call(this) || this;
        return A.children = E, A;
      }
      return Object.defineProperty(S.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var E;
          return (E = this.children[0]) !== null && E !== void 0 ? E : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(S.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(S.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(E) {
          this.children = E;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(s)
  );
  j.NodeWithChildren = h;
  var a = (
    /** @class */
    function(p) {
      e(S, p);
      function S() {
        var E = p !== null && p.apply(this, arguments) || this;
        return E.type = i.ElementType.CDATA, E;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(h)
  );
  j.CDATA = a;
  var o = (
    /** @class */
    function(p) {
      e(S, p);
      function S() {
        var E = p !== null && p.apply(this, arguments) || this;
        return E.type = i.ElementType.Root, E;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(h)
  );
  j.Document = o;
  var m = (
    /** @class */
    function(p) {
      e(S, p);
      function S(E, A, O, L) {
        O === void 0 && (O = []), L === void 0 && (L = E === "script" ? i.ElementType.Script : E === "style" ? i.ElementType.Style : i.ElementType.Tag);
        var q = p.call(this, O) || this;
        return q.name = E, q.attribs = A, q.type = L, q;
      }
      return Object.defineProperty(S.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(S.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(E) {
          this.name = E;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(S.prototype, "attributes", {
        get: function() {
          var E = this;
          return Object.keys(this.attribs).map(function(A) {
            var O, L;
            return {
              name: A,
              value: E.attribs[A],
              namespace: (O = E["x-attribsNamespace"]) === null || O === void 0 ? void 0 : O[A],
              prefix: (L = E["x-attribsPrefix"]) === null || L === void 0 ? void 0 : L[A]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), S;
    }(h)
  );
  j.Element = m;
  function u(p) {
    return (0, i.isTag)(p);
  }
  j.isTag = u;
  function r(p) {
    return p.type === i.ElementType.CDATA;
  }
  j.isCDATA = r;
  function b(p) {
    return p.type === i.ElementType.Text;
  }
  j.isText = b;
  function g(p) {
    return p.type === i.ElementType.Comment;
  }
  j.isComment = g;
  function v(p) {
    return p.type === i.ElementType.Directive;
  }
  j.isDirective = v;
  function c(p) {
    return p.type === i.ElementType.Root;
  }
  j.isDocument = c;
  function y(p) {
    return Object.prototype.hasOwnProperty.call(p, "children");
  }
  j.hasChildren = y;
  function w(p, S) {
    S === void 0 && (S = !1);
    var E;
    if (b(p))
      E = new d(p.data);
    else if (g(p))
      E = new n(p.data);
    else if (u(p)) {
      var A = S ? x(p.children) : [], O = new m(p.name, t({}, p.attribs), A);
      A.forEach(function(N) {
        return N.parent = O;
      }), p.namespace != null && (O.namespace = p.namespace), p["x-attribsNamespace"] && (O["x-attribsNamespace"] = t({}, p["x-attribsNamespace"])), p["x-attribsPrefix"] && (O["x-attribsPrefix"] = t({}, p["x-attribsPrefix"])), E = O;
    } else if (r(p)) {
      var A = S ? x(p.children) : [], L = new a(A);
      A.forEach(function(_) {
        return _.parent = L;
      }), E = L;
    } else if (c(p)) {
      var A = S ? x(p.children) : [], q = new o(A);
      A.forEach(function(_) {
        return _.parent = q;
      }), p["x-mode"] && (q["x-mode"] = p["x-mode"]), E = q;
    } else if (v(p)) {
      var T = new f(p.name, p.data);
      p["x-name"] != null && (T["x-name"] = p["x-name"], T["x-publicId"] = p["x-publicId"], T["x-systemId"] = p["x-systemId"]), E = T;
    } else
      throw new Error("Not implemented yet: ".concat(p.type));
    return E.startIndex = p.startIndex, E.endIndex = p.endIndex, p.sourceCodeLocation != null && (E.sourceCodeLocation = p.sourceCodeLocation), E;
  }
  j.cloneNode = w;
  function x(p) {
    for (var S = p.map(function(A) {
      return w(A, !0);
    }), E = 1; E < S.length; E++)
      S[E].prev = S[E - 1], S[E - 1].next = S[E];
    return S;
  }
  return j;
}
var Eu;
function Pe() {
  return Eu || (Eu = 1, function(e) {
    var t = Ne && Ne.__createBinding || (Object.create ? function(f, h, a, o) {
      o === void 0 && (o = a);
      var m = Object.getOwnPropertyDescriptor(h, a);
      (!m || ("get" in m ? !h.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
        return h[a];
      } }), Object.defineProperty(f, o, m);
    } : function(f, h, a, o) {
      o === void 0 && (o = a), f[o] = h[a];
    }), i = Ne && Ne.__exportStar || function(f, h) {
      for (var a in f) a !== "default" && !Object.prototype.hasOwnProperty.call(h, a) && t(h, f, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
    var s = /* @__PURE__ */ ze(), l = /* @__PURE__ */ xu();
    i(/* @__PURE__ */ xu(), e);
    var d = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, n = (
      /** @class */
      function() {
        function f(h, a, o) {
          this.dom = [], this.root = new l.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof a == "function" && (o = a, a = d), typeof h == "object" && (a = h, h = void 0), this.callback = h ?? null, this.options = a ?? d, this.elementCB = o ?? null;
        }
        return f.prototype.onparserinit = function(h) {
          this.parser = h;
        }, f.prototype.onreset = function() {
          this.dom = [], this.root = new l.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, f.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, f.prototype.onerror = function(h) {
          this.handleCallback(h);
        }, f.prototype.onclosetag = function() {
          this.lastNode = null;
          var h = this.tagStack.pop();
          this.options.withEndIndices && (h.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(h);
        }, f.prototype.onopentag = function(h, a) {
          var o = this.options.xmlMode ? s.ElementType.Tag : void 0, m = new l.Element(h, a, void 0, o);
          this.addNode(m), this.tagStack.push(m);
        }, f.prototype.ontext = function(h) {
          var a = this.lastNode;
          if (a && a.type === s.ElementType.Text)
            a.data += h, this.options.withEndIndices && (a.endIndex = this.parser.endIndex);
          else {
            var o = new l.Text(h);
            this.addNode(o), this.lastNode = o;
          }
        }, f.prototype.oncomment = function(h) {
          if (this.lastNode && this.lastNode.type === s.ElementType.Comment) {
            this.lastNode.data += h;
            return;
          }
          var a = new l.Comment(h);
          this.addNode(a), this.lastNode = a;
        }, f.prototype.oncommentend = function() {
          this.lastNode = null;
        }, f.prototype.oncdatastart = function() {
          var h = new l.Text(""), a = new l.CDATA([h]);
          this.addNode(a), h.parent = a, this.lastNode = h;
        }, f.prototype.oncdataend = function() {
          this.lastNode = null;
        }, f.prototype.onprocessinginstruction = function(h, a) {
          var o = new l.ProcessingInstruction(h, a);
          this.addNode(o);
        }, f.prototype.handleCallback = function(h) {
          if (typeof this.callback == "function")
            this.callback(h, this.dom);
          else if (h)
            throw h;
        }, f.prototype.addNode = function(h) {
          var a = this.tagStack[this.tagStack.length - 1], o = a.children[a.children.length - 1];
          this.options.withStartIndices && (h.startIndex = this.parser.startIndex), this.options.withEndIndices && (h.endIndex = this.parser.endIndex), a.children.push(h), o && (h.prev = o, o.next = h), h.parent = a, this.lastNode = null;
        }, f;
      }()
    );
    e.DomHandler = n, e.default = n;
  }(Ne)), Ne;
}
var Me = {}, qe = {}, fe = {}, gt = {}, ke = {}, Xe = {}, qu;
function Ni() {
  if (qu) return Xe;
  qu = 1, Object.defineProperty(Xe, "__esModule", { value: !0 });
  function e(t) {
    for (var i = 1; i < t.length; i++)
      t[i][0] += t[i - 1][0] + 1;
    return t;
  }
  return Xe.default = new Map(/* @__PURE__ */ e([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ e([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ e([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ e([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Xe;
}
var yt = {}, Au;
function Qt() {
  return Au || (Au = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var t = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(l, d) {
      return l.codePointAt(d);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(l, d) {
        return (l.charCodeAt(d) & 64512) === 55296 ? (l.charCodeAt(d) - 55296) * 1024 + l.charCodeAt(d + 1) - 56320 + 65536 : l.charCodeAt(d);
      }
    );
    function i(l) {
      for (var d = "", n = 0, f; (f = e.xmlReplacer.exec(l)) !== null; ) {
        var h = f.index, a = l.charCodeAt(h), o = t.get(a);
        o !== void 0 ? (d += l.substring(n, h) + o, n = h + 1) : (d += "".concat(l.substring(n, h), "&#x").concat((0, e.getCodePoint)(l, h).toString(16), ";"), n = e.xmlReplacer.lastIndex += +((a & 64512) === 55296));
      }
      return d + l.substr(n);
    }
    e.encodeXML = i, e.escape = i;
    function s(l, d) {
      return function(f) {
        for (var h, a = 0, o = ""; h = l.exec(f); )
          a !== h.index && (o += f.substring(a, h.index)), o += d.get(h[0].charCodeAt(0)), a = h.index + 1;
        return o + f.substring(a);
      };
    }
    e.escapeUTF8 = s(/[&<>'"]/g, t), e.escapeAttribute = s(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), e.escapeText = s(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }(yt)), yt;
}
var ku;
function Tu() {
  if (ku) return ke;
  ku = 1;
  var e = ke && ke.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(ke, "__esModule", { value: !0 }), ke.encodeNonAsciiHTML = ke.encodeHTML = void 0;
  var t = e(/* @__PURE__ */ Ni()), i = /* @__PURE__ */ Qt(), s = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function l(f) {
    return n(s, f);
  }
  ke.encodeHTML = l;
  function d(f) {
    return n(i.xmlReplacer, f);
  }
  ke.encodeNonAsciiHTML = d;
  function n(f, h) {
    for (var a = "", o = 0, m; (m = f.exec(h)) !== null; ) {
      var u = m.index;
      a += h.substring(o, u);
      var r = h.charCodeAt(u), b = t.default.get(r);
      if (typeof b == "object") {
        if (u + 1 < h.length) {
          var g = h.charCodeAt(u + 1), v = typeof b.n == "number" ? b.n === g ? b.o : void 0 : b.n.get(g);
          if (v !== void 0) {
            a += v, o = f.lastIndex += 1;
            continue;
          }
        }
        b = b.v;
      }
      if (b !== void 0)
        a += b, o = u + 1;
      else {
        var c = (0, i.getCodePoint)(h, u);
        a += "&#x".concat(c.toString(16), ";"), o = f.lastIndex += +(c !== r);
      }
    }
    return a + h.substr(o);
  }
  return ke;
}
var Du;
function Mi() {
  return Du || (Du = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
    var t = /* @__PURE__ */ rt(), i = /* @__PURE__ */ Tu(), s = /* @__PURE__ */ Qt(), l;
    (function(u) {
      u[u.XML = 0] = "XML", u[u.HTML = 1] = "HTML";
    })(l = e.EntityLevel || (e.EntityLevel = {}));
    var d;
    (function(u) {
      u[u.UTF8 = 0] = "UTF8", u[u.ASCII = 1] = "ASCII", u[u.Extensive = 2] = "Extensive", u[u.Attribute = 3] = "Attribute", u[u.Text = 4] = "Text";
    })(d = e.EncodingMode || (e.EncodingMode = {}));
    function n(u, r) {
      r === void 0 && (r = l.XML);
      var b = typeof r == "number" ? r : r.level;
      if (b === l.HTML) {
        var g = typeof r == "object" ? r.mode : void 0;
        return (0, t.decodeHTML)(u, g);
      }
      return (0, t.decodeXML)(u);
    }
    e.decode = n;
    function f(u, r) {
      var b;
      r === void 0 && (r = l.XML);
      var g = typeof r == "number" ? { level: r } : r;
      return (b = g.mode) !== null && b !== void 0 || (g.mode = t.DecodingMode.Strict), n(u, g);
    }
    e.decodeStrict = f;
    function h(u, r) {
      r === void 0 && (r = l.XML);
      var b = typeof r == "number" ? { level: r } : r;
      return b.mode === d.UTF8 ? (0, s.escapeUTF8)(u) : b.mode === d.Attribute ? (0, s.escapeAttribute)(u) : b.mode === d.Text ? (0, s.escapeText)(u) : b.level === l.HTML ? b.mode === d.ASCII ? (0, i.encodeNonAsciiHTML)(u) : (0, i.encodeHTML)(u) : (0, s.encodeXML)(u);
    }
    e.encode = h;
    var a = /* @__PURE__ */ Qt();
    Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
      return a.encodeXML;
    } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
      return a.escape;
    } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
      return a.escapeUTF8;
    } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
      return a.escapeAttribute;
    } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
      return a.escapeText;
    } });
    var o = /* @__PURE__ */ Tu();
    Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
      return o.encodeHTML;
    } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return o.encodeNonAsciiHTML;
    } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
      return o.encodeHTML;
    } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
      return o.encodeHTML;
    } });
    var m = /* @__PURE__ */ rt();
    Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
      return m.EntityDecoder;
    } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
      return m.DecodingMode;
    } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
      return m.decodeXML;
    } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
      return m.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return m.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return m.decodeHTMLAttribute;
    } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
      return m.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
      return m.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return m.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return m.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
      return m.decodeXML;
    } });
  }(gt)), gt;
}
var Be = {}, Cu;
function Bi() {
  return Cu || (Cu = 1, Object.defineProperty(Be, "__esModule", { value: !0 }), Be.attributeNames = Be.elementNames = void 0, Be.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  })), Be.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  }))), Be;
}
var Ou;
function _i() {
  if (Ou) return fe;
  Ou = 1;
  var e = fe && fe.__assign || function() {
    return e = Object.assign || function(x) {
      for (var p, S = 1, E = arguments.length; S < E; S++) {
        p = arguments[S];
        for (var A in p) Object.prototype.hasOwnProperty.call(p, A) && (x[A] = p[A]);
      }
      return x;
    }, e.apply(this, arguments);
  }, t = fe && fe.__createBinding || (Object.create ? function(x, p, S, E) {
    E === void 0 && (E = S);
    var A = Object.getOwnPropertyDescriptor(p, S);
    (!A || ("get" in A ? !p.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
      return p[S];
    } }), Object.defineProperty(x, E, A);
  } : function(x, p, S, E) {
    E === void 0 && (E = S), x[E] = p[S];
  }), i = fe && fe.__setModuleDefault || (Object.create ? function(x, p) {
    Object.defineProperty(x, "default", { enumerable: !0, value: p });
  } : function(x, p) {
    x.default = p;
  }), s = fe && fe.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var p = {};
    if (x != null) for (var S in x) S !== "default" && Object.prototype.hasOwnProperty.call(x, S) && t(p, x, S);
    return i(p, x), p;
  };
  Object.defineProperty(fe, "__esModule", { value: !0 }), fe.render = void 0;
  var l = s(/* @__PURE__ */ ze()), d = /* @__PURE__ */ Mi(), n = /* @__PURE__ */ Bi(), f = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function h(x) {
    return x.replace(/"/g, "&quot;");
  }
  function a(x, p) {
    var S;
    if (x) {
      var E = ((S = p.encodeEntities) !== null && S !== void 0 ? S : p.decodeEntities) === !1 ? h : p.xmlMode || p.encodeEntities !== "utf8" ? d.encodeXML : d.escapeAttribute;
      return Object.keys(x).map(function(A) {
        var O, L, q = (O = x[A]) !== null && O !== void 0 ? O : "";
        return p.xmlMode === "foreign" && (A = (L = n.attributeNames.get(A)) !== null && L !== void 0 ? L : A), !p.emptyAttrs && !p.xmlMode && q === "" ? A : "".concat(A, '="').concat(E(q), '"');
      }).join(" ");
    }
  }
  var o = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function m(x, p) {
    p === void 0 && (p = {});
    for (var S = ("length" in x) ? x : [x], E = "", A = 0; A < S.length; A++)
      E += u(S[A], p);
    return E;
  }
  fe.render = m, fe.default = m;
  function u(x, p) {
    switch (x.type) {
      case l.Root:
        return m(x.children, p);
      // @ts-expect-error We don't use `Doctype` yet
      case l.Doctype:
      case l.Directive:
        return v(x);
      case l.Comment:
        return w(x);
      case l.CDATA:
        return y(x);
      case l.Script:
      case l.Style:
      case l.Tag:
        return g(x, p);
      case l.Text:
        return c(x, p);
    }
  }
  var r = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), b = /* @__PURE__ */ new Set(["svg", "math"]);
  function g(x, p) {
    var S;
    p.xmlMode === "foreign" && (x.name = (S = n.elementNames.get(x.name)) !== null && S !== void 0 ? S : x.name, x.parent && r.has(x.parent.name) && (p = e(e({}, p), { xmlMode: !1 }))), !p.xmlMode && b.has(x.name) && (p = e(e({}, p), { xmlMode: "foreign" }));
    var E = "<".concat(x.name), A = a(x.attribs, p);
    return A && (E += " ".concat(A)), x.children.length === 0 && (p.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      p.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      p.selfClosingTags && o.has(x.name)
    )) ? (p.xmlMode || (E += " "), E += "/>") : (E += ">", x.children.length > 0 && (E += m(x.children, p)), (p.xmlMode || !o.has(x.name)) && (E += "</".concat(x.name, ">"))), E;
  }
  function v(x) {
    return "<".concat(x.data, ">");
  }
  function c(x, p) {
    var S, E = x.data || "";
    return ((S = p.encodeEntities) !== null && S !== void 0 ? S : p.decodeEntities) !== !1 && !(!p.xmlMode && x.parent && f.has(x.parent.name)) && (E = p.xmlMode || p.encodeEntities !== "utf8" ? (0, d.encodeXML)(E) : (0, d.escapeText)(E)), E;
  }
  function y(x) {
    return "<![CDATA[".concat(x.children[0].data, "]]>");
  }
  function w(x) {
    return "<!--".concat(x.data, "-->");
  }
  return fe;
}
var Pu;
function qr() {
  if (Pu) return qe;
  Pu = 1;
  var e = qe && qe.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(qe, "__esModule", { value: !0 }), qe.getOuterHTML = l, qe.getInnerHTML = d, qe.getText = n, qe.textContent = f, qe.innerText = h;
  var t = /* @__PURE__ */ Pe(), i = e(/* @__PURE__ */ _i()), s = /* @__PURE__ */ ze();
  function l(a, o) {
    return (0, i.default)(a, o);
  }
  function d(a, o) {
    return (0, t.hasChildren)(a) ? a.children.map(function(m) {
      return l(m, o);
    }).join("") : "";
  }
  function n(a) {
    return Array.isArray(a) ? a.map(n).join("") : (0, t.isTag)(a) ? a.name === "br" ? `
` : n(a.children) : (0, t.isCDATA)(a) ? n(a.children) : (0, t.isText)(a) ? a.data : "";
  }
  function f(a) {
    return Array.isArray(a) ? a.map(f).join("") : (0, t.hasChildren)(a) && !(0, t.isComment)(a) ? f(a.children) : (0, t.isText)(a) ? a.data : "";
  }
  function h(a) {
    return Array.isArray(a) ? a.map(h).join("") : (0, t.hasChildren)(a) && (a.type === s.ElementType.Tag || (0, t.isCDATA)(a)) ? h(a.children) : (0, t.isText)(a) ? a.data : "";
  }
  return qe;
}
var ve = {}, Lu;
function $i() {
  if (Lu) return ve;
  Lu = 1, Object.defineProperty(ve, "__esModule", { value: !0 }), ve.getChildren = t, ve.getParent = i, ve.getSiblings = s, ve.getAttributeValue = l, ve.hasAttrib = d, ve.getName = n, ve.nextElementSibling = f, ve.prevElementSibling = h;
  var e = /* @__PURE__ */ Pe();
  function t(a) {
    return (0, e.hasChildren)(a) ? a.children : [];
  }
  function i(a) {
    return a.parent || null;
  }
  function s(a) {
    var o, m, u = i(a);
    if (u != null)
      return t(u);
    for (var r = [a], b = a.prev, g = a.next; b != null; )
      r.unshift(b), o = b, b = o.prev;
    for (; g != null; )
      r.push(g), m = g, g = m.next;
    return r;
  }
  function l(a, o) {
    var m;
    return (m = a.attribs) === null || m === void 0 ? void 0 : m[o];
  }
  function d(a, o) {
    return a.attribs != null && Object.prototype.hasOwnProperty.call(a.attribs, o) && a.attribs[o] != null;
  }
  function n(a) {
    return a.name;
  }
  function f(a) {
    for (var o, m = a.next; m !== null && !(0, e.isTag)(m); )
      o = m, m = o.next;
    return m;
  }
  function h(a) {
    for (var o, m = a.prev; m !== null && !(0, e.isTag)(m); )
      o = m, m = o.prev;
    return m;
  }
  return ve;
}
var Te = {}, Iu;
function Ri() {
  if (Iu) return Te;
  Iu = 1, Object.defineProperty(Te, "__esModule", { value: !0 }), Te.removeElement = e, Te.replaceElement = t, Te.appendChild = i, Te.append = s, Te.prependChild = l, Te.prepend = d;
  function e(n) {
    if (n.prev && (n.prev.next = n.next), n.next && (n.next.prev = n.prev), n.parent) {
      var f = n.parent.children, h = f.lastIndexOf(n);
      h >= 0 && f.splice(h, 1);
    }
    n.next = null, n.prev = null, n.parent = null;
  }
  function t(n, f) {
    var h = f.prev = n.prev;
    h && (h.next = f);
    var a = f.next = n.next;
    a && (a.prev = f);
    var o = f.parent = n.parent;
    if (o) {
      var m = o.children;
      m[m.lastIndexOf(n)] = f, n.parent = null;
    }
  }
  function i(n, f) {
    if (e(f), f.next = null, f.parent = n, n.children.push(f) > 1) {
      var h = n.children[n.children.length - 2];
      h.next = f, f.prev = h;
    } else
      f.prev = null;
  }
  function s(n, f) {
    e(f);
    var h = n.parent, a = n.next;
    if (f.next = a, f.prev = n, n.next = f, f.parent = h, a) {
      if (a.prev = f, h) {
        var o = h.children;
        o.splice(o.lastIndexOf(a), 0, f);
      }
    } else h && h.children.push(f);
  }
  function l(n, f) {
    if (e(f), f.parent = n, f.prev = null, n.children.unshift(f) !== 1) {
      var h = n.children[1];
      h.prev = f, f.next = h;
    } else
      f.next = null;
  }
  function d(n, f) {
    e(f);
    var h = n.parent;
    if (h) {
      var a = h.children;
      a.splice(a.indexOf(n), 0, f);
    }
    n.prev && (n.prev.next = f), f.parent = h, f.prev = n.prev, f.next = n, n.prev = f;
  }
  return Te;
}
var De = {}, Nu;
function Ar() {
  if (Nu) return De;
  Nu = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.filter = t, De.find = i, De.findOneChild = s, De.findOne = l, De.existsOne = d, De.findAll = n;
  var e = /* @__PURE__ */ Pe();
  function t(f, h, a, o) {
    return a === void 0 && (a = !0), o === void 0 && (o = 1 / 0), i(f, Array.isArray(h) ? h : [h], a, o);
  }
  function i(f, h, a, o) {
    for (var m = [], u = [Array.isArray(h) ? h : [h]], r = [0]; ; ) {
      if (r[0] >= u[0].length) {
        if (r.length === 1)
          return m;
        u.shift(), r.shift();
        continue;
      }
      var b = u[0][r[0]++];
      if (f(b) && (m.push(b), --o <= 0))
        return m;
      a && (0, e.hasChildren)(b) && b.children.length > 0 && (r.unshift(0), u.unshift(b.children));
    }
  }
  function s(f, h) {
    return h.find(f);
  }
  function l(f, h, a) {
    a === void 0 && (a = !0);
    for (var o = Array.isArray(h) ? h : [h], m = 0; m < o.length; m++) {
      var u = o[m];
      if ((0, e.isTag)(u) && f(u))
        return u;
      if (a && (0, e.hasChildren)(u) && u.children.length > 0) {
        var r = l(f, u.children, !0);
        if (r)
          return r;
      }
    }
    return null;
  }
  function d(f, h) {
    return (Array.isArray(h) ? h : [h]).some(function(a) {
      return (0, e.isTag)(a) && f(a) || (0, e.hasChildren)(a) && d(f, a.children);
    });
  }
  function n(f, h) {
    for (var a = [], o = [Array.isArray(h) ? h : [h]], m = [0]; ; ) {
      if (m[0] >= o[0].length) {
        if (o.length === 1)
          return a;
        o.shift(), m.shift();
        continue;
      }
      var u = o[0][m[0]++];
      (0, e.isTag)(u) && f(u) && a.push(u), (0, e.hasChildren)(u) && u.children.length > 0 && (m.unshift(0), o.unshift(u.children));
    }
  }
  return De;
}
var Ce = {}, Mu;
function kr() {
  if (Mu) return Ce;
  Mu = 1, Object.defineProperty(Ce, "__esModule", { value: !0 }), Ce.testElement = n, Ce.getElements = f, Ce.getElementById = h, Ce.getElementsByTagName = a, Ce.getElementsByClassName = o, Ce.getElementsByTagType = m;
  var e = /* @__PURE__ */ Pe(), t = /* @__PURE__ */ Ar(), i = {
    tag_name: function(u) {
      return typeof u == "function" ? function(r) {
        return (0, e.isTag)(r) && u(r.name);
      } : u === "*" ? e.isTag : function(r) {
        return (0, e.isTag)(r) && r.name === u;
      };
    },
    tag_type: function(u) {
      return typeof u == "function" ? function(r) {
        return u(r.type);
      } : function(r) {
        return r.type === u;
      };
    },
    tag_contains: function(u) {
      return typeof u == "function" ? function(r) {
        return (0, e.isText)(r) && u(r.data);
      } : function(r) {
        return (0, e.isText)(r) && r.data === u;
      };
    }
  };
  function s(u, r) {
    return typeof r == "function" ? function(b) {
      return (0, e.isTag)(b) && r(b.attribs[u]);
    } : function(b) {
      return (0, e.isTag)(b) && b.attribs[u] === r;
    };
  }
  function l(u, r) {
    return function(b) {
      return u(b) || r(b);
    };
  }
  function d(u) {
    var r = Object.keys(u).map(function(b) {
      var g = u[b];
      return Object.prototype.hasOwnProperty.call(i, b) ? i[b](g) : s(b, g);
    });
    return r.length === 0 ? null : r.reduce(l);
  }
  function n(u, r) {
    var b = d(u);
    return b ? b(r) : !0;
  }
  function f(u, r, b, g) {
    g === void 0 && (g = 1 / 0);
    var v = d(u);
    return v ? (0, t.filter)(v, r, b, g) : [];
  }
  function h(u, r, b) {
    return b === void 0 && (b = !0), Array.isArray(r) || (r = [r]), (0, t.findOne)(s("id", u), r, b);
  }
  function a(u, r, b, g) {
    return b === void 0 && (b = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(i.tag_name(u), r, b, g);
  }
  function o(u, r, b, g) {
    return b === void 0 && (b = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(s("class", u), r, b, g);
  }
  function m(u, r, b, g) {
    return b === void 0 && (b = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(i.tag_type(u), r, b, g);
  }
  return Ce;
}
var Oe = {}, Bu;
function Vi() {
  if (Bu) return Oe;
  Bu = 1, Object.defineProperty(Oe, "__esModule", { value: !0 }), Oe.DocumentPosition = void 0, Oe.removeSubsets = t, Oe.compareDocumentPosition = s, Oe.uniqueSort = l;
  var e = /* @__PURE__ */ Pe();
  function t(d) {
    for (var n = d.length; --n >= 0; ) {
      var f = d[n];
      if (n > 0 && d.lastIndexOf(f, n - 1) >= 0) {
        d.splice(n, 1);
        continue;
      }
      for (var h = f.parent; h; h = h.parent)
        if (d.includes(h)) {
          d.splice(n, 1);
          break;
        }
    }
    return d;
  }
  var i;
  (function(d) {
    d[d.DISCONNECTED = 1] = "DISCONNECTED", d[d.PRECEDING = 2] = "PRECEDING", d[d.FOLLOWING = 4] = "FOLLOWING", d[d.CONTAINS = 8] = "CONTAINS", d[d.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(i || (Oe.DocumentPosition = i = {}));
  function s(d, n) {
    var f = [], h = [];
    if (d === n)
      return 0;
    for (var a = (0, e.hasChildren)(d) ? d : d.parent; a; )
      f.unshift(a), a = a.parent;
    for (a = (0, e.hasChildren)(n) ? n : n.parent; a; )
      h.unshift(a), a = a.parent;
    for (var o = Math.min(f.length, h.length), m = 0; m < o && f[m] === h[m]; )
      m++;
    if (m === 0)
      return i.DISCONNECTED;
    var u = f[m - 1], r = u.children, b = f[m], g = h[m];
    return r.indexOf(b) > r.indexOf(g) ? u === n ? i.FOLLOWING | i.CONTAINED_BY : i.FOLLOWING : u === d ? i.PRECEDING | i.CONTAINS : i.PRECEDING;
  }
  function l(d) {
    return d = d.filter(function(n, f, h) {
      return !h.includes(n, f + 1);
    }), d.sort(function(n, f) {
      var h = s(n, f);
      return h & i.PRECEDING ? -1 : h & i.FOLLOWING ? 1 : 0;
    }), d;
  }
  return Oe;
}
var Qe = {}, _u;
function Fi() {
  if (_u) return Qe;
  _u = 1, Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.getFeed = i;
  var e = /* @__PURE__ */ qr(), t = /* @__PURE__ */ kr();
  function i(u) {
    var r = h(m, u);
    return r ? r.name === "feed" ? s(r) : l(r) : null;
  }
  function s(u) {
    var r, b = u.children, g = {
      type: "atom",
      items: (0, t.getElementsByTagName)("entry", b).map(function(y) {
        var w, x = y.children, p = { media: f(x) };
        o(p, "id", "id", x), o(p, "title", "title", x);
        var S = (w = h("link", x)) === null || w === void 0 ? void 0 : w.attribs.href;
        S && (p.link = S);
        var E = a("summary", x) || a("content", x);
        E && (p.description = E);
        var A = a("updated", x);
        return A && (p.pubDate = new Date(A)), p;
      })
    };
    o(g, "id", "id", b), o(g, "title", "title", b);
    var v = (r = h("link", b)) === null || r === void 0 ? void 0 : r.attribs.href;
    v && (g.link = v), o(g, "description", "subtitle", b);
    var c = a("updated", b);
    return c && (g.updated = new Date(c)), o(g, "author", "email", b, !0), g;
  }
  function l(u) {
    var r, b, g = (b = (r = h("channel", u.children)) === null || r === void 0 ? void 0 : r.children) !== null && b !== void 0 ? b : [], v = {
      type: u.name.substr(0, 3),
      id: "",
      items: (0, t.getElementsByTagName)("item", u.children).map(function(y) {
        var w = y.children, x = { media: f(w) };
        o(x, "id", "guid", w), o(x, "title", "title", w), o(x, "link", "link", w), o(x, "description", "description", w);
        var p = a("pubDate", w) || a("dc:date", w);
        return p && (x.pubDate = new Date(p)), x;
      })
    };
    o(v, "title", "title", g), o(v, "link", "link", g), o(v, "description", "description", g);
    var c = a("lastBuildDate", g);
    return c && (v.updated = new Date(c)), o(v, "author", "managingEditor", g, !0), v;
  }
  var d = ["url", "type", "lang"], n = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function f(u) {
    return (0, t.getElementsByTagName)("media:content", u).map(function(r) {
      for (var b = r.attribs, g = {
        medium: b.medium,
        isDefault: !!b.isDefault
      }, v = 0, c = d; v < c.length; v++) {
        var y = c[v];
        b[y] && (g[y] = b[y]);
      }
      for (var w = 0, x = n; w < x.length; w++) {
        var y = x[w];
        b[y] && (g[y] = parseInt(b[y], 10));
      }
      return b.expression && (g.expression = b.expression), g;
    });
  }
  function h(u, r) {
    return (0, t.getElementsByTagName)(u, r, !0, 1)[0];
  }
  function a(u, r, b) {
    return b === void 0 && (b = !1), (0, e.textContent)((0, t.getElementsByTagName)(u, r, b, 1)).trim();
  }
  function o(u, r, b, g, v) {
    v === void 0 && (v = !1);
    var c = a(b, g, v);
    c && (u[r] = c);
  }
  function m(u) {
    return u === "rss" || u === "feed" || u === "rdf:RDF";
  }
  return Qe;
}
var $u;
function vt() {
  return $u || ($u = 1, function(e) {
    var t = Me && Me.__createBinding || (Object.create ? function(l, d, n, f) {
      f === void 0 && (f = n);
      var h = Object.getOwnPropertyDescriptor(d, n);
      (!h || ("get" in h ? !d.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return d[n];
      } }), Object.defineProperty(l, f, h);
    } : function(l, d, n, f) {
      f === void 0 && (f = n), l[f] = d[n];
    }), i = Me && Me.__exportStar || function(l, d) {
      for (var n in l) n !== "default" && !Object.prototype.hasOwnProperty.call(d, n) && t(d, l, n);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, i(/* @__PURE__ */ qr(), e), i(/* @__PURE__ */ $i(), e), i(/* @__PURE__ */ Ri(), e), i(/* @__PURE__ */ Ar(), e), i(/* @__PURE__ */ kr(), e), i(/* @__PURE__ */ Vi(), e), i(/* @__PURE__ */ Fi(), e);
    var s = /* @__PURE__ */ Pe();
    Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
      return s.isTag;
    } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
      return s.isCDATA;
    } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
      return s.isText;
    } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
      return s.isComment;
    } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
      return s.isDocument;
    } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
      return s.hasChildren;
    } });
  }(Me)), Me;
}
var Ru;
function ji() {
  return Ru || (Ru = 1, function(e) {
    var t = me && me.__createBinding || (Object.create ? function(c, y, w, x) {
      x === void 0 && (x = w);
      var p = Object.getOwnPropertyDescriptor(y, w);
      (!p || ("get" in p ? !y.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return y[w];
      } }), Object.defineProperty(c, x, p);
    } : function(c, y, w, x) {
      x === void 0 && (x = w), c[x] = y[w];
    }), i = me && me.__setModuleDefault || (Object.create ? function(c, y) {
      Object.defineProperty(c, "default", { enumerable: !0, value: y });
    } : function(c, y) {
      c.default = y;
    }), s = me && me.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var y = {};
      if (c != null) for (var w in c) w !== "default" && Object.prototype.hasOwnProperty.call(c, w) && t(y, c, w);
      return i(y, c), y;
    }, l = me && me.__importDefault || function(c) {
      return c && c.__esModule ? c : { default: c };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
    var d = /* @__PURE__ */ vu(), n = /* @__PURE__ */ vu();
    Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
      return n.Parser;
    } });
    var f = /* @__PURE__ */ Pe(), h = /* @__PURE__ */ Pe();
    Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
      return h.DomHandler;
    } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
      return h.DomHandler;
    } });
    function a(c, y) {
      var w = new f.DomHandler(void 0, y);
      return new d.Parser(w, y).end(c), w.root;
    }
    e.parseDocument = a;
    function o(c, y) {
      return a(c, y).children;
    }
    e.parseDOM = o;
    function m(c, y, w) {
      var x = new f.DomHandler(c, y, w);
      return new d.Parser(x, y);
    }
    e.createDomStream = m;
    var u = /* @__PURE__ */ Er();
    Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
      return l(u).default;
    } }), e.ElementType = s(/* @__PURE__ */ ze());
    var r = /* @__PURE__ */ vt(), b = /* @__PURE__ */ vt();
    Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
      return b.getFeed;
    } });
    var g = { xmlMode: !0 };
    function v(c, y) {
      return y === void 0 && (y = g), (0, r.getFeed)(o(c, y));
    }
    e.parseFeed = v, e.DomUtils = s(/* @__PURE__ */ vt());
  }(me)), me;
}
var wt, Vu;
function Ui() {
  return Vu || (Vu = 1, wt = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), wt;
}
var Ze = {}, Fu;
function Hi() {
  if (Fu) return Ze;
  Fu = 1, Object.defineProperty(Ze, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(i) {
    return Object.prototype.toString.call(i) === "[object Object]";
  }
  function t(i) {
    var s, l;
    return e(i) === !1 ? !1 : (s = i.constructor, s === void 0 ? !0 : (l = s.prototype, !(e(l) === !1 || l.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Ze.isPlainObject = t, Ze;
}
var St, ju;
function zi() {
  if (ju) return St;
  ju = 1;
  var e = function(y) {
    return t(y) && !i(y);
  };
  function t(c) {
    return !!c && typeof c == "object";
  }
  function i(c) {
    var y = Object.prototype.toString.call(c);
    return y === "[object RegExp]" || y === "[object Date]" || d(c);
  }
  var s = typeof Symbol == "function" && Symbol.for, l = s ? Symbol.for("react.element") : 60103;
  function d(c) {
    return c.$$typeof === l;
  }
  function n(c) {
    return Array.isArray(c) ? [] : {};
  }
  function f(c, y) {
    return y.clone !== !1 && y.isMergeableObject(c) ? g(n(c), c, y) : c;
  }
  function h(c, y, w) {
    return c.concat(y).map(function(x) {
      return f(x, w);
    });
  }
  function a(c, y) {
    if (!y.customMerge)
      return g;
    var w = y.customMerge(c);
    return typeof w == "function" ? w : g;
  }
  function o(c) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(c).filter(function(y) {
      return Object.propertyIsEnumerable.call(c, y);
    }) : [];
  }
  function m(c) {
    return Object.keys(c).concat(o(c));
  }
  function u(c, y) {
    try {
      return y in c;
    } catch {
      return !1;
    }
  }
  function r(c, y) {
    return u(c, y) && !(Object.hasOwnProperty.call(c, y) && Object.propertyIsEnumerable.call(c, y));
  }
  function b(c, y, w) {
    var x = {};
    return w.isMergeableObject(c) && m(c).forEach(function(p) {
      x[p] = f(c[p], w);
    }), m(y).forEach(function(p) {
      r(c, p) || (u(c, p) && w.isMergeableObject(y[p]) ? x[p] = a(p, w)(c[p], y[p], w) : x[p] = f(y[p], w));
    }), x;
  }
  function g(c, y, w) {
    w = w || {}, w.arrayMerge = w.arrayMerge || h, w.isMergeableObject = w.isMergeableObject || e, w.cloneUnlessOtherwiseSpecified = f;
    var x = Array.isArray(y), p = Array.isArray(c), S = x === p;
    return S ? x ? w.arrayMerge(c, y, w) : b(c, y, w) : f(y, w);
  }
  g.all = function(y, w) {
    if (!Array.isArray(y))
      throw new Error("first argument should be an array");
    return y.reduce(function(x, p) {
      return g(x, p, w);
    }, {});
  };
  var v = g;
  return St = v, St;
}
var ut = { exports: {} }, Gi = ut.exports, Uu;
function Yi() {
  return Uu || (Uu = 1, function(e) {
    (function(t, i) {
      e.exports ? e.exports = i() : t.parseSrcset = i();
    })(Gi, function() {
      return function(t) {
        function i(x) {
          return x === " " || // space
          x === "	" || // horizontal tab
          x === `
` || // new line
          x === "\f" || // form feed
          x === "\r";
        }
        function s(x) {
          var p, S = x.exec(t.substring(v));
          if (S)
            return p = S[0], v += p.length, p;
        }
        for (var l = t.length, d = /^[ \t\n\r\u000c]+/, n = /^[, \t\n\r\u000c]+/, f = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, a = /^\d+$/, o = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, m, u, r, b, g, v = 0, c = []; ; ) {
          if (s(n), v >= l)
            return c;
          m = s(f), u = [], m.slice(-1) === "," ? (m = m.replace(h, ""), w()) : y();
        }
        function y() {
          for (s(d), r = "", b = "in descriptor"; ; ) {
            if (g = t.charAt(v), b === "in descriptor")
              if (i(g))
                r && (u.push(r), r = "", b = "after descriptor");
              else if (g === ",") {
                v += 1, r && u.push(r), w();
                return;
              } else if (g === "(")
                r = r + g, b = "in parens";
              else if (g === "") {
                r && u.push(r), w();
                return;
              } else
                r = r + g;
            else if (b === "in parens")
              if (g === ")")
                r = r + g, b = "in descriptor";
              else if (g === "") {
                u.push(r), w();
                return;
              } else
                r = r + g;
            else if (b === "after descriptor" && !i(g))
              if (g === "") {
                w();
                return;
              } else
                b = "in descriptor", v -= 1;
            v += 1;
          }
        }
        function w() {
          var x = !1, p, S, E, A, O = {}, L, q, T, N, _;
          for (A = 0; A < u.length; A++)
            L = u[A], q = L[L.length - 1], T = L.substring(0, L.length - 1), N = parseInt(T, 10), _ = parseFloat(T), a.test(T) && q === "w" ? ((p || S) && (x = !0), N === 0 ? x = !0 : p = N) : o.test(T) && q === "x" ? ((p || S || E) && (x = !0), _ < 0 ? x = !0 : S = _) : a.test(T) && q === "h" ? ((E || S) && (x = !0), N === 0 ? x = !0 : E = N) : x = !0;
          x ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + L + "'.") : (O.url = m, p && (O.w = p), S && (O.d = S), E && (O.h = E), c.push(O));
        }
      };
    });
  }(ut)), ut.exports;
}
var et = { exports: {} }, Hu;
function Wi() {
  if (Hu) return et.exports;
  Hu = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return et.exports = t(), et.exports.createColors = t, et.exports;
}
const Ki = {}, Ji = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ki
}, Symbol.toStringTag, { value: "Module" })), Se = /* @__PURE__ */ Pi(Ji);
var xt, zu;
function uu() {
  if (zu) return xt;
  zu = 1;
  let e = /* @__PURE__ */ Wi(), t = Se;
  class i extends Error {
    constructor(l, d, n, f, h, a) {
      super(l), this.name = "CssSyntaxError", this.reason = l, h && (this.file = h), f && (this.source = f), a && (this.plugin = a), typeof d < "u" && typeof n < "u" && (typeof d == "number" ? (this.line = d, this.column = n) : (this.line = d.line, this.column = d.column, this.endLine = n.line, this.endColumn = n.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, i);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(l) {
      if (!this.source) return "";
      let d = this.source;
      l == null && (l = e.isColorSupported);
      let n = (r) => r, f = (r) => r, h = (r) => r;
      if (l) {
        let { bold: r, gray: b, red: g } = e.createColors(!0);
        f = (v) => r(g(v)), n = (v) => b(v), t && (h = (v) => t(v));
      }
      let a = d.split(/\r?\n/), o = Math.max(this.line - 3, 0), m = Math.min(this.line + 2, a.length), u = String(m).length;
      return a.slice(o, m).map((r, b) => {
        let g = o + 1 + b, v = " " + (" " + g).slice(-u) + " | ";
        if (g === this.line) {
          if (r.length > 160) {
            let y = 20, w = Math.max(0, this.column - y), x = Math.max(
              this.column + y,
              this.endColumn + y
            ), p = r.slice(w, x), S = n(v.replace(/\d/g, " ")) + r.slice(0, Math.min(this.column - 1, y - 1)).replace(/[^\t]/g, " ");
            return f(">") + n(v) + h(p) + `
 ` + S + f("^");
          }
          let c = n(v.replace(/\d/g, " ")) + r.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return f(">") + n(v) + h(r) + `
 ` + c + f("^");
        }
        return " " + n(v) + h(r);
      }).join(`
`);
    }
    toString() {
      let l = this.showSourceCode();
      return l && (l = `

` + l + `
`), this.name + ": " + this.message + l;
    }
  }
  return xt = i, i.default = i, xt;
}
var Et, Gu;
function Tr() {
  if (Gu) return Et;
  Gu = 1;
  const e = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function t(s) {
    return s[0].toUpperCase() + s.slice(1);
  }
  class i {
    constructor(l) {
      this.builder = l;
    }
    atrule(l, d) {
      let n = "@" + l.name, f = l.params ? this.rawValue(l, "params") : "";
      if (typeof l.raws.afterName < "u" ? n += l.raws.afterName : f && (n += " "), l.nodes)
        this.block(l, n + f);
      else {
        let h = (l.raws.between || "") + (d ? ";" : "");
        this.builder(n + f + h, l);
      }
    }
    beforeAfter(l, d) {
      let n;
      l.type === "decl" ? n = this.raw(l, null, "beforeDecl") : l.type === "comment" ? n = this.raw(l, null, "beforeComment") : d === "before" ? n = this.raw(l, null, "beforeRule") : n = this.raw(l, null, "beforeClose");
      let f = l.parent, h = 0;
      for (; f && f.type !== "root"; )
        h += 1, f = f.parent;
      if (n.includes(`
`)) {
        let a = this.raw(l, null, "indent");
        if (a.length)
          for (let o = 0; o < h; o++) n += a;
      }
      return n;
    }
    block(l, d) {
      let n = this.raw(l, "between", "beforeOpen");
      this.builder(d + n + "{", l, "start");
      let f;
      l.nodes && l.nodes.length ? (this.body(l), f = this.raw(l, "after")) : f = this.raw(l, "after", "emptyBody"), f && this.builder(f), this.builder("}", l, "end");
    }
    body(l) {
      let d = l.nodes.length - 1;
      for (; d > 0 && l.nodes[d].type === "comment"; )
        d -= 1;
      let n = this.raw(l, "semicolon");
      for (let f = 0; f < l.nodes.length; f++) {
        let h = l.nodes[f], a = this.raw(h, "before");
        a && this.builder(a), this.stringify(h, d !== f || n);
      }
    }
    comment(l) {
      let d = this.raw(l, "left", "commentLeft"), n = this.raw(l, "right", "commentRight");
      this.builder("/*" + d + l.text + n + "*/", l);
    }
    decl(l, d) {
      let n = this.raw(l, "between", "colon"), f = l.prop + n + this.rawValue(l, "value");
      l.important && (f += l.raws.important || " !important"), d && (f += ";"), this.builder(f, l);
    }
    document(l) {
      this.body(l);
    }
    raw(l, d, n) {
      let f;
      if (n || (n = d), d && (f = l.raws[d], typeof f < "u"))
        return f;
      let h = l.parent;
      if (n === "before" && (!h || h.type === "root" && h.first === l || h && h.type === "document"))
        return "";
      if (!h) return e[n];
      let a = l.root();
      if (a.rawCache || (a.rawCache = {}), typeof a.rawCache[n] < "u")
        return a.rawCache[n];
      if (n === "before" || n === "after")
        return this.beforeAfter(l, n);
      {
        let o = "raw" + t(n);
        this[o] ? f = this[o](a, l) : a.walk((m) => {
          if (f = m.raws[d], typeof f < "u") return !1;
        });
      }
      return typeof f > "u" && (f = e[n]), a.rawCache[n] = f, f;
    }
    rawBeforeClose(l) {
      let d;
      return l.walk((n) => {
        if (n.nodes && n.nodes.length > 0 && typeof n.raws.after < "u")
          return d = n.raws.after, d.includes(`
`) && (d = d.replace(/[^\n]+$/, "")), !1;
      }), d && (d = d.replace(/\S/g, "")), d;
    }
    rawBeforeComment(l, d) {
      let n;
      return l.walkComments((f) => {
        if (typeof f.raws.before < "u")
          return n = f.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), typeof n > "u" ? n = this.raw(d, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
    }
    rawBeforeDecl(l, d) {
      let n;
      return l.walkDecls((f) => {
        if (typeof f.raws.before < "u")
          return n = f.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), typeof n > "u" ? n = this.raw(d, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
    }
    rawBeforeOpen(l) {
      let d;
      return l.walk((n) => {
        if (n.type !== "decl" && (d = n.raws.between, typeof d < "u"))
          return !1;
      }), d;
    }
    rawBeforeRule(l) {
      let d;
      return l.walk((n) => {
        if (n.nodes && (n.parent !== l || l.first !== n) && typeof n.raws.before < "u")
          return d = n.raws.before, d.includes(`
`) && (d = d.replace(/[^\n]+$/, "")), !1;
      }), d && (d = d.replace(/\S/g, "")), d;
    }
    rawColon(l) {
      let d;
      return l.walkDecls((n) => {
        if (typeof n.raws.between < "u")
          return d = n.raws.between.replace(/[^\s:]/g, ""), !1;
      }), d;
    }
    rawEmptyBody(l) {
      let d;
      return l.walk((n) => {
        if (n.nodes && n.nodes.length === 0 && (d = n.raws.after, typeof d < "u"))
          return !1;
      }), d;
    }
    rawIndent(l) {
      if (l.raws.indent) return l.raws.indent;
      let d;
      return l.walk((n) => {
        let f = n.parent;
        if (f && f !== l && f.parent && f.parent === l && typeof n.raws.before < "u") {
          let h = n.raws.before.split(`
`);
          return d = h[h.length - 1], d = d.replace(/\S/g, ""), !1;
        }
      }), d;
    }
    rawSemicolon(l) {
      let d;
      return l.walk((n) => {
        if (n.nodes && n.nodes.length && n.last.type === "decl" && (d = n.raws.semicolon, typeof d < "u"))
          return !1;
      }), d;
    }
    rawValue(l, d) {
      let n = l[d], f = l.raws[d];
      return f && f.value === n ? f.raw : n;
    }
    root(l) {
      this.body(l), l.raws.after && this.builder(l.raws.after);
    }
    rule(l) {
      this.block(l, this.rawValue(l, "selector")), l.raws.ownSemicolon && this.builder(l.raws.ownSemicolon, l, "end");
    }
    stringify(l, d) {
      if (!this[l.type])
        throw new Error(
          "Unknown AST node type " + l.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[l.type](l, d);
    }
  }
  return Et = i, i.default = i, Et;
}
var qt, Yu;
function nt() {
  if (Yu) return qt;
  Yu = 1;
  let e = Tr();
  function t(i, s) {
    new e(s).stringify(i);
  }
  return qt = t, t.default = t, qt;
}
var tt = {}, Wu;
function ru() {
  return Wu || (Wu = 1, tt.isClean = Symbol("isClean"), tt.my = Symbol("my")), tt;
}
var At, Ku;
function st() {
  if (Ku) return At;
  Ku = 1;
  let e = uu(), t = Tr(), i = nt(), { isClean: s, my: l } = ru();
  function d(h, a) {
    let o = new h.constructor();
    for (let m in h) {
      if (!Object.prototype.hasOwnProperty.call(h, m) || m === "proxyCache") continue;
      let u = h[m], r = typeof u;
      m === "parent" && r === "object" ? a && (o[m] = a) : m === "source" ? o[m] = u : Array.isArray(u) ? o[m] = u.map((b) => d(b, o)) : (r === "object" && u !== null && (u = d(u)), o[m] = u);
    }
    return o;
  }
  function n(h, a) {
    if (a && typeof a.offset < "u")
      return a.offset;
    let o = 1, m = 1, u = 0;
    for (let r = 0; r < h.length; r++) {
      if (m === a.line && o === a.column) {
        u = r;
        break;
      }
      h[r] === `
` ? (o = 1, m += 1) : o += 1;
    }
    return u;
  }
  class f {
    get proxyOf() {
      return this;
    }
    constructor(a = {}) {
      this.raws = {}, this[s] = !1, this[l] = !0;
      for (let o in a)
        if (o === "nodes") {
          this.nodes = [];
          for (let m of a[o])
            typeof m.clone == "function" ? this.append(m.clone()) : this.append(m);
        } else
          this[o] = a[o];
    }
    addToError(a) {
      if (a.postcssNode = this, a.stack && this.source && /\n\s{4}at /.test(a.stack)) {
        let o = this.source;
        a.stack = a.stack.replace(
          /\n\s{4}at /,
          `$&${o.input.from}:${o.start.line}:${o.start.column}$&`
        );
      }
      return a;
    }
    after(a) {
      return this.parent.insertAfter(this, a), this;
    }
    assign(a = {}) {
      for (let o in a)
        this[o] = a[o];
      return this;
    }
    before(a) {
      return this.parent.insertBefore(this, a), this;
    }
    cleanRaws(a) {
      delete this.raws.before, delete this.raws.after, a || delete this.raws.between;
    }
    clone(a = {}) {
      let o = d(this);
      for (let m in a)
        o[m] = a[m];
      return o;
    }
    cloneAfter(a = {}) {
      let o = this.clone(a);
      return this.parent.insertAfter(this, o), o;
    }
    cloneBefore(a = {}) {
      let o = this.clone(a);
      return this.parent.insertBefore(this, o), o;
    }
    error(a, o = {}) {
      if (this.source) {
        let { end: m, start: u } = this.rangeBy(o);
        return this.source.input.error(
          a,
          { column: u.column, line: u.line },
          { column: m.column, line: m.line },
          o
        );
      }
      return new e(a);
    }
    getProxyProcessor() {
      return {
        get(a, o) {
          return o === "proxyOf" ? a : o === "root" ? () => a.root().toProxy() : a[o];
        },
        set(a, o, m) {
          return a[o] === m || (a[o] = m, (o === "prop" || o === "value" || o === "name" || o === "params" || o === "important" || /* c8 ignore next */
          o === "text") && a.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[s] = !0;
    }
    markDirty() {
      if (this[s]) {
        this[s] = !1;
        let a = this;
        for (; a = a.parent; )
          a[s] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let a = this.parent.index(this);
      return this.parent.nodes[a + 1];
    }
    positionBy(a) {
      let o = this.source.start;
      if (a.index)
        o = this.positionInside(a.index);
      else if (a.word) {
        let m = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = m.slice(
          n(m, this.source.start),
          n(m, this.source.end)
        ).indexOf(a.word);
        r !== -1 && (o = this.positionInside(r));
      }
      return o;
    }
    positionInside(a) {
      let o = this.source.start.column, m = this.source.start.line, u = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = n(u, this.source.start), b = r + a;
      for (let g = r; g < b; g++)
        u[g] === `
` ? (o = 1, m += 1) : o += 1;
      return { column: o, line: m };
    }
    prev() {
      if (!this.parent) return;
      let a = this.parent.index(this);
      return this.parent.nodes[a - 1];
    }
    rangeBy(a) {
      let o = {
        column: this.source.start.column,
        line: this.source.start.line
      }, m = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: o.column + 1,
        line: o.line
      };
      if (a.word) {
        let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, b = u.slice(
          n(u, this.source.start),
          n(u, this.source.end)
        ).indexOf(a.word);
        b !== -1 && (o = this.positionInside(b), m = this.positionInside(
          b + a.word.length
        ));
      } else
        a.start ? o = {
          column: a.start.column,
          line: a.start.line
        } : a.index && (o = this.positionInside(a.index)), a.end ? m = {
          column: a.end.column,
          line: a.end.line
        } : typeof a.endIndex == "number" ? m = this.positionInside(a.endIndex) : a.index && (m = this.positionInside(a.index + 1));
      return (m.line < o.line || m.line === o.line && m.column <= o.column) && (m = { column: o.column + 1, line: o.line }), { end: m, start: o };
    }
    raw(a, o) {
      return new t().raw(this, a, o);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...a) {
      if (this.parent) {
        let o = this, m = !1;
        for (let u of a)
          u === this ? m = !0 : m ? (this.parent.insertAfter(o, u), o = u) : this.parent.insertBefore(o, u);
        m || this.remove();
      }
      return this;
    }
    root() {
      let a = this;
      for (; a.parent && a.parent.type !== "document"; )
        a = a.parent;
      return a;
    }
    toJSON(a, o) {
      let m = {}, u = o == null;
      o = o || /* @__PURE__ */ new Map();
      let r = 0;
      for (let b in this) {
        if (!Object.prototype.hasOwnProperty.call(this, b) || b === "parent" || b === "proxyCache") continue;
        let g = this[b];
        if (Array.isArray(g))
          m[b] = g.map((v) => typeof v == "object" && v.toJSON ? v.toJSON(null, o) : v);
        else if (typeof g == "object" && g.toJSON)
          m[b] = g.toJSON(null, o);
        else if (b === "source") {
          let v = o.get(g.input);
          v == null && (v = r, o.set(g.input, r), r++), m[b] = {
            end: g.end,
            inputId: v,
            start: g.start
          };
        } else
          m[b] = g;
      }
      return u && (m.inputs = [...o.keys()].map((b) => b.toJSON())), m;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(a = i) {
      a.stringify && (a = a.stringify);
      let o = "";
      return a(this, (m) => {
        o += m;
      }), o;
    }
    warn(a, o, m) {
      let u = { node: this };
      for (let r in m) u[r] = m[r];
      return a.warn(o, u);
    }
  }
  return At = f, f.default = f, At;
}
var kt, Ju;
function at() {
  if (Ju) return kt;
  Ju = 1;
  let e = st();
  class t extends e {
    constructor(s) {
      super(s), this.type = "comment";
    }
  }
  return kt = t, t.default = t, kt;
}
var Tt, Xu;
function lt() {
  if (Xu) return Tt;
  Xu = 1;
  let e = st();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(s) {
      s && typeof s.value < "u" && typeof s.value != "string" && (s = { ...s, value: String(s.value) }), super(s), this.type = "decl";
    }
  }
  return Tt = t, t.default = t, Tt;
}
var Dt, Qu;
function Ve() {
  if (Qu) return Dt;
  Qu = 1;
  let e = at(), t = lt(), i = st(), { isClean: s, my: l } = ru(), d, n, f, h;
  function a(u) {
    return u.map((r) => (r.nodes && (r.nodes = a(r.nodes)), delete r.source, r));
  }
  function o(u) {
    if (u[s] = !1, u.proxyOf.nodes)
      for (let r of u.proxyOf.nodes)
        o(r);
  }
  class m extends i {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...r) {
      for (let b of r) {
        let g = this.normalize(b, this.last);
        for (let v of g) this.proxyOf.nodes.push(v);
      }
      return this.markDirty(), this;
    }
    cleanRaws(r) {
      if (super.cleanRaws(r), this.nodes)
        for (let b of this.nodes) b.cleanRaws(r);
    }
    each(r) {
      if (!this.proxyOf.nodes) return;
      let b = this.getIterator(), g, v;
      for (; this.indexes[b] < this.proxyOf.nodes.length && (g = this.indexes[b], v = r(this.proxyOf.nodes[g], g), v !== !1); )
        this.indexes[b] += 1;
      return delete this.indexes[b], v;
    }
    every(r) {
      return this.nodes.every(r);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let r = this.lastEach;
      return this.indexes[r] = 0, r;
    }
    getProxyProcessor() {
      return {
        get(r, b) {
          return b === "proxyOf" ? r : r[b] ? b === "each" || typeof b == "string" && b.startsWith("walk") ? (...g) => r[b](
            ...g.map((v) => typeof v == "function" ? (c, y) => v(c.toProxy(), y) : v)
          ) : b === "every" || b === "some" ? (g) => r[b](
            (v, ...c) => g(v.toProxy(), ...c)
          ) : b === "root" ? () => r.root().toProxy() : b === "nodes" ? r.nodes.map((g) => g.toProxy()) : b === "first" || b === "last" ? r[b].toProxy() : r[b] : r[b];
        },
        set(r, b, g) {
          return r[b] === g || (r[b] = g, (b === "name" || b === "params" || b === "selector") && r.markDirty()), !0;
        }
      };
    }
    index(r) {
      return typeof r == "number" ? r : (r.proxyOf && (r = r.proxyOf), this.proxyOf.nodes.indexOf(r));
    }
    insertAfter(r, b) {
      let g = this.index(r), v = this.normalize(b, this.proxyOf.nodes[g]).reverse();
      g = this.index(r);
      for (let y of v) this.proxyOf.nodes.splice(g + 1, 0, y);
      let c;
      for (let y in this.indexes)
        c = this.indexes[y], g < c && (this.indexes[y] = c + v.length);
      return this.markDirty(), this;
    }
    insertBefore(r, b) {
      let g = this.index(r), v = g === 0 ? "prepend" : !1, c = this.normalize(
        b,
        this.proxyOf.nodes[g],
        v
      ).reverse();
      g = this.index(r);
      for (let w of c) this.proxyOf.nodes.splice(g, 0, w);
      let y;
      for (let w in this.indexes)
        y = this.indexes[w], g <= y && (this.indexes[w] = y + c.length);
      return this.markDirty(), this;
    }
    normalize(r, b) {
      if (typeof r == "string")
        r = a(n(r).nodes);
      else if (typeof r > "u")
        r = [];
      else if (Array.isArray(r)) {
        r = r.slice(0);
        for (let v of r)
          v.parent && v.parent.removeChild(v, "ignore");
      } else if (r.type === "root" && this.type !== "document") {
        r = r.nodes.slice(0);
        for (let v of r)
          v.parent && v.parent.removeChild(v, "ignore");
      } else if (r.type)
        r = [r];
      else if (r.prop) {
        if (typeof r.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof r.value != "string" && (r.value = String(r.value)), r = [new t(r)];
      } else if (r.selector || r.selectors)
        r = [new h(r)];
      else if (r.name)
        r = [new d(r)];
      else if (r.text)
        r = [new e(r)];
      else
        throw new Error("Unknown node type in node creation");
      return r.map((v) => (v[l] || m.rebuild(v), v = v.proxyOf, v.parent && v.parent.removeChild(v), v[s] && o(v), v.raws || (v.raws = {}), typeof v.raws.before > "u" && b && typeof b.raws.before < "u" && (v.raws.before = b.raws.before.replace(/\S/g, "")), v.parent = this.proxyOf, v));
    }
    prepend(...r) {
      r = r.reverse();
      for (let b of r) {
        let g = this.normalize(b, this.first, "prepend").reverse();
        for (let v of g) this.proxyOf.nodes.unshift(v);
        for (let v in this.indexes)
          this.indexes[v] = this.indexes[v] + g.length;
      }
      return this.markDirty(), this;
    }
    push(r) {
      return r.parent = this, this.proxyOf.nodes.push(r), this;
    }
    removeAll() {
      for (let r of this.proxyOf.nodes) r.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(r) {
      r = this.index(r), this.proxyOf.nodes[r].parent = void 0, this.proxyOf.nodes.splice(r, 1);
      let b;
      for (let g in this.indexes)
        b = this.indexes[g], b >= r && (this.indexes[g] = b - 1);
      return this.markDirty(), this;
    }
    replaceValues(r, b, g) {
      return g || (g = b, b = {}), this.walkDecls((v) => {
        b.props && !b.props.includes(v.prop) || b.fast && !v.value.includes(b.fast) || (v.value = v.value.replace(r, g));
      }), this.markDirty(), this;
    }
    some(r) {
      return this.nodes.some(r);
    }
    walk(r) {
      return this.each((b, g) => {
        let v;
        try {
          v = r(b, g);
        } catch (c) {
          throw b.addToError(c);
        }
        return v !== !1 && b.walk && (v = b.walk(r)), v;
      });
    }
    walkAtRules(r, b) {
      return b ? r instanceof RegExp ? this.walk((g, v) => {
        if (g.type === "atrule" && r.test(g.name))
          return b(g, v);
      }) : this.walk((g, v) => {
        if (g.type === "atrule" && g.name === r)
          return b(g, v);
      }) : (b = r, this.walk((g, v) => {
        if (g.type === "atrule")
          return b(g, v);
      }));
    }
    walkComments(r) {
      return this.walk((b, g) => {
        if (b.type === "comment")
          return r(b, g);
      });
    }
    walkDecls(r, b) {
      return b ? r instanceof RegExp ? this.walk((g, v) => {
        if (g.type === "decl" && r.test(g.prop))
          return b(g, v);
      }) : this.walk((g, v) => {
        if (g.type === "decl" && g.prop === r)
          return b(g, v);
      }) : (b = r, this.walk((g, v) => {
        if (g.type === "decl")
          return b(g, v);
      }));
    }
    walkRules(r, b) {
      return b ? r instanceof RegExp ? this.walk((g, v) => {
        if (g.type === "rule" && r.test(g.selector))
          return b(g, v);
      }) : this.walk((g, v) => {
        if (g.type === "rule" && g.selector === r)
          return b(g, v);
      }) : (b = r, this.walk((g, v) => {
        if (g.type === "rule")
          return b(g, v);
      }));
    }
  }
  return m.registerParse = (u) => {
    n = u;
  }, m.registerRule = (u) => {
    h = u;
  }, m.registerAtRule = (u) => {
    d = u;
  }, m.registerRoot = (u) => {
    f = u;
  }, Dt = m, m.default = m, m.rebuild = (u) => {
    u.type === "atrule" ? Object.setPrototypeOf(u, d.prototype) : u.type === "rule" ? Object.setPrototypeOf(u, h.prototype) : u.type === "decl" ? Object.setPrototypeOf(u, t.prototype) : u.type === "comment" ? Object.setPrototypeOf(u, e.prototype) : u.type === "root" && Object.setPrototypeOf(u, f.prototype), u[l] = !0, u.nodes && u.nodes.forEach((r) => {
      m.rebuild(r);
    });
  }, Dt;
}
var Ct, Zu;
function iu() {
  if (Zu) return Ct;
  Zu = 1;
  let e = Ve();
  class t extends e {
    constructor(s) {
      super(s), this.type = "atrule";
    }
    append(...s) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...s);
    }
    prepend(...s) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...s);
    }
  }
  return Ct = t, t.default = t, e.registerAtRule(t), Ct;
}
var Ot, er;
function nu() {
  if (er) return Ot;
  er = 1;
  let e = Ve(), t, i;
  class s extends e {
    constructor(d) {
      super({ type: "document", ...d }), this.nodes || (this.nodes = []);
    }
    toResult(d = {}) {
      return new t(new i(), this, d).stringify();
    }
  }
  return s.registerLazyResult = (l) => {
    t = l;
  }, s.registerProcessor = (l) => {
    i = l;
  }, Ot = s, s.default = s, Ot;
}
var Pt, tr;
function Xi() {
  if (tr) return Pt;
  tr = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return Pt = { nanoid: (s = 21) => {
    let l = "", d = s | 0;
    for (; d--; )
      l += e[Math.random() * 64 | 0];
    return l;
  }, customAlphabet: (s, l = 21) => (d = l) => {
    let n = "", f = d | 0;
    for (; f--; )
      n += s[Math.random() * s.length | 0];
    return n;
  } }, Pt;
}
var Lt, ur;
function Dr() {
  if (ur) return Lt;
  ur = 1;
  let { existsSync: e, readFileSync: t } = Se, { dirname: i, join: s } = Se, { SourceMapConsumer: l, SourceMapGenerator: d } = Se;
  function n(h) {
    return Buffer ? Buffer.from(h, "base64").toString() : window.atob(h);
  }
  class f {
    constructor(a, o) {
      if (o.map === !1) return;
      this.loadAnnotation(a), this.inline = this.startWith(this.annotation, "data:");
      let m = o.map ? o.map.prev : void 0, u = this.loadMap(o.from, m);
      !this.mapFile && o.from && (this.mapFile = o.from), this.mapFile && (this.root = i(this.mapFile)), u && (this.text = u);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new l(this.text)), this.consumerCache;
    }
    decodeInline(a) {
      let o = /^data:application\/json;charset=utf-?8;base64,/, m = /^data:application\/json;base64,/, u = /^data:application\/json;charset=utf-?8,/, r = /^data:application\/json,/, b = a.match(u) || a.match(r);
      if (b)
        return decodeURIComponent(a.substr(b[0].length));
      let g = a.match(o) || a.match(m);
      if (g)
        return n(a.substr(g[0].length));
      let v = a.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + v);
    }
    getAnnotationURL(a) {
      return a.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(a) {
      return typeof a != "object" ? !1 : typeof a.mappings == "string" || typeof a._mappings == "string" || Array.isArray(a.sections);
    }
    loadAnnotation(a) {
      let o = a.match(/\/\*\s*# sourceMappingURL=/g);
      if (!o) return;
      let m = a.lastIndexOf(o.pop()), u = a.indexOf("*/", m);
      m > -1 && u > -1 && (this.annotation = this.getAnnotationURL(a.substring(m, u)));
    }
    loadFile(a) {
      if (this.root = i(a), e(a))
        return this.mapFile = a, t(a, "utf-8").toString().trim();
    }
    loadMap(a, o) {
      if (o === !1) return !1;
      if (o) {
        if (typeof o == "string")
          return o;
        if (typeof o == "function") {
          let m = o(a);
          if (m) {
            let u = this.loadFile(m);
            if (!u)
              throw new Error(
                "Unable to load previous source map: " + m.toString()
              );
            return u;
          }
        } else {
          if (o instanceof l)
            return d.fromSourceMap(o).toString();
          if (o instanceof d)
            return o.toString();
          if (this.isMap(o))
            return JSON.stringify(o);
          throw new Error(
            "Unsupported previous source map format: " + o.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let m = this.annotation;
          return a && (m = s(i(a), m)), this.loadFile(m);
        }
      }
    }
    startWith(a, o) {
      return a ? a.substr(0, o.length) === o : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Lt = f, f.default = f, Lt;
}
var It, rr;
function ot() {
  if (rr) return It;
  rr = 1;
  let { nanoid: e } = /* @__PURE__ */ Xi(), { isAbsolute: t, resolve: i } = Se, { SourceMapConsumer: s, SourceMapGenerator: l } = Se, { fileURLToPath: d, pathToFileURL: n } = Se, f = uu(), h = Dr(), a = Se, o = Symbol("fromOffsetCache"), m = !!(s && l), u = !!(i && t);
  class r {
    get from() {
      return this.file || this.id;
    }
    constructor(g, v = {}) {
      if (g === null || typeof g > "u" || typeof g == "object" && !g.toString)
        throw new Error(`PostCSS received ${g} instead of CSS string`);
      if (this.css = g.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, v.document && (this.document = v.document.toString()), v.from && (!u || /^\w+:\/\//.test(v.from) || t(v.from) ? this.file = v.from : this.file = i(v.from)), u && m) {
        let c = new h(this.css, v);
        if (c.text) {
          this.map = c;
          let y = c.consumer().file;
          !this.file && y && (this.file = this.mapResolve(y));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(g, v, c, y = {}) {
      let w, x, p;
      if (v && typeof v == "object") {
        let E = v, A = c;
        if (typeof E.offset == "number") {
          let O = this.fromOffset(E.offset);
          v = O.line, c = O.col;
        } else
          v = E.line, c = E.column;
        if (typeof A.offset == "number") {
          let O = this.fromOffset(A.offset);
          x = O.line, w = O.col;
        } else
          x = A.line, w = A.column;
      } else if (!c) {
        let E = this.fromOffset(v);
        v = E.line, c = E.col;
      }
      let S = this.origin(v, c, x, w);
      return S ? p = new f(
        g,
        S.endLine === void 0 ? S.line : { column: S.column, line: S.line },
        S.endLine === void 0 ? S.column : { column: S.endColumn, line: S.endLine },
        S.source,
        S.file,
        y.plugin
      ) : p = new f(
        g,
        x === void 0 ? v : { column: c, line: v },
        x === void 0 ? c : { column: w, line: x },
        this.css,
        this.file,
        y.plugin
      ), p.input = { column: c, endColumn: w, endLine: x, line: v, source: this.css }, this.file && (n && (p.input.url = n(this.file).toString()), p.input.file = this.file), p;
    }
    fromOffset(g) {
      let v, c;
      if (this[o])
        c = this[o];
      else {
        let w = this.css.split(`
`);
        c = new Array(w.length);
        let x = 0;
        for (let p = 0, S = w.length; p < S; p++)
          c[p] = x, x += w[p].length + 1;
        this[o] = c;
      }
      v = c[c.length - 1];
      let y = 0;
      if (g >= v)
        y = c.length - 1;
      else {
        let w = c.length - 2, x;
        for (; y < w; )
          if (x = y + (w - y >> 1), g < c[x])
            w = x - 1;
          else if (g >= c[x + 1])
            y = x + 1;
          else {
            y = x;
            break;
          }
      }
      return {
        col: g - c[y] + 1,
        line: y + 1
      };
    }
    mapResolve(g) {
      return /^\w+:\/\//.test(g) ? g : i(this.map.consumer().sourceRoot || this.map.root || ".", g);
    }
    origin(g, v, c, y) {
      if (!this.map) return !1;
      let w = this.map.consumer(), x = w.originalPositionFor({ column: v, line: g });
      if (!x.source) return !1;
      let p;
      typeof c == "number" && (p = w.originalPositionFor({ column: y, line: c }));
      let S;
      t(x.source) ? S = n(x.source) : S = new URL(
        x.source,
        this.map.consumer().sourceRoot || n(this.map.mapFile)
      );
      let E = {
        column: x.column,
        endColumn: p && p.column,
        endLine: p && p.line,
        line: x.line,
        url: S.toString()
      };
      if (S.protocol === "file:")
        if (d)
          E.file = d(S);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let A = w.sourceContentFor(x.source);
      return A && (E.source = A), E;
    }
    toJSON() {
      let g = {};
      for (let v of ["hasBOM", "css", "file", "id"])
        this[v] != null && (g[v] = this[v]);
      return this.map && (g.map = { ...this.map }, g.map.consumerCache && (g.map.consumerCache = void 0)), g;
    }
  }
  return It = r, r.default = r, a && a.registerInput && a.registerInput(r), It;
}
var Nt, ir;
function Ge() {
  if (ir) return Nt;
  ir = 1;
  let e = Ve(), t, i;
  class s extends e {
    constructor(d) {
      super(d), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(d, n, f) {
      let h = super.normalize(d);
      if (n) {
        if (f === "prepend")
          this.nodes.length > 1 ? n.raws.before = this.nodes[1].raws.before : delete n.raws.before;
        else if (this.first !== n)
          for (let a of h)
            a.raws.before = n.raws.before;
      }
      return h;
    }
    removeChild(d, n) {
      let f = this.index(d);
      return !n && f === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[f].raws.before), super.removeChild(d);
    }
    toResult(d = {}) {
      return new t(new i(), this, d).stringify();
    }
  }
  return s.registerLazyResult = (l) => {
    t = l;
  }, s.registerProcessor = (l) => {
    i = l;
  }, Nt = s, s.default = s, e.registerRoot(s), Nt;
}
var Mt, nr;
function Cr() {
  if (nr) return Mt;
  nr = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let i = [" ", `
`, "	"];
      return e.split(t, i);
    },
    split(t, i, s) {
      let l = [], d = "", n = !1, f = 0, h = !1, a = "", o = !1;
      for (let m of t)
        o ? o = !1 : m === "\\" ? o = !0 : h ? m === a && (h = !1) : m === '"' || m === "'" ? (h = !0, a = m) : m === "(" ? f += 1 : m === ")" ? f > 0 && (f -= 1) : f === 0 && i.includes(m) && (n = !0), n ? (d !== "" && l.push(d.trim()), d = "", n = !1) : d += m;
      return (s || d !== "") && l.push(d.trim()), l;
    }
  };
  return Mt = e, e.default = e, Mt;
}
var Bt, sr;
function su() {
  if (sr) return Bt;
  sr = 1;
  let e = Ve(), t = Cr();
  class i extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(l) {
      let d = this.selector ? this.selector.match(/,\s*/) : null, n = d ? d[0] : "," + this.raw("between", "beforeOpen");
      this.selector = l.join(n);
    }
    constructor(l) {
      super(l), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Bt = i, i.default = i, e.registerRule(i), Bt;
}
var _t, ar;
function Qi() {
  if (ar) return _t;
  ar = 1;
  let e = iu(), t = at(), i = lt(), s = ot(), l = Dr(), d = Ge(), n = su();
  function f(h, a) {
    if (Array.isArray(h)) return h.map((u) => f(u));
    let { inputs: o, ...m } = h;
    if (o) {
      a = [];
      for (let u of o) {
        let r = { ...u, __proto__: s.prototype };
        r.map && (r.map = {
          ...r.map,
          __proto__: l.prototype
        }), a.push(r);
      }
    }
    if (m.nodes && (m.nodes = h.nodes.map((u) => f(u, a))), m.source) {
      let { inputId: u, ...r } = m.source;
      m.source = r, u != null && (m.source.input = a[u]);
    }
    if (m.type === "root")
      return new d(m);
    if (m.type === "decl")
      return new i(m);
    if (m.type === "rule")
      return new n(m);
    if (m.type === "comment")
      return new t(m);
    if (m.type === "atrule")
      return new e(m);
    throw new Error("Unknown node type: " + h.type);
  }
  return _t = f, f.default = f, _t;
}
var $t, lr;
function Or() {
  if (lr) return $t;
  lr = 1;
  let { dirname: e, relative: t, resolve: i, sep: s } = Se, { SourceMapConsumer: l, SourceMapGenerator: d } = Se, { pathToFileURL: n } = Se, f = ot(), h = !!(l && d), a = !!(e && i && t && s);
  class o {
    constructor(u, r, b, g) {
      this.stringify = u, this.mapOpts = b.map || {}, this.root = r, this.opts = b, this.css = g, this.originalCSS = g, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let u;
      this.isInline() ? u = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? u = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? u = this.mapOpts.annotation(this.opts.to, this.root) : u = this.outputFile() + ".map";
      let r = `
`;
      this.css.includes(`\r
`) && (r = `\r
`), this.css += r + "/*# sourceMappingURL=" + u + " */";
    }
    applyPrevMaps() {
      for (let u of this.previous()) {
        let r = this.toUrl(this.path(u.file)), b = u.root || e(u.file), g;
        this.mapOpts.sourcesContent === !1 ? (g = new l(u.text), g.sourcesContent && (g.sourcesContent = null)) : g = u.consumer(), this.map.applySourceMap(g, r, this.toUrl(this.path(b)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let u;
          for (let r = this.root.nodes.length - 1; r >= 0; r--)
            u = this.root.nodes[r], u.type === "comment" && u.text.startsWith("# sourceMappingURL=") && this.root.removeChild(r);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), a && h && this.isMap())
        return this.generateMap();
      {
        let u = "";
        return this.stringify(this.root, (r) => {
          u += r;
        }), [u];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let u = this.previous()[0].consumer();
        u.file = this.outputFile(), this.map = d.fromSourceMap(u, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new d({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new d({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let u = 1, r = 1, b = "<no source>", g = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, v, c;
      this.stringify(this.root, (y, w, x) => {
        if (this.css += y, w && x !== "end" && (g.generated.line = u, g.generated.column = r - 1, w.source && w.source.start ? (g.source = this.sourcePath(w), g.original.line = w.source.start.line, g.original.column = w.source.start.column - 1, this.map.addMapping(g)) : (g.source = b, g.original.line = 1, g.original.column = 0, this.map.addMapping(g))), c = y.match(/\n/g), c ? (u += c.length, v = y.lastIndexOf(`
`), r = y.length - v) : r += y.length, w && x !== "start") {
          let p = w.parent || { raws: {} };
          (!(w.type === "decl" || w.type === "atrule" && !w.nodes) || w !== p.last || p.raws.semicolon) && (w.source && w.source.end ? (g.source = this.sourcePath(w), g.original.line = w.source.end.line, g.original.column = w.source.end.column - 1, g.generated.line = u, g.generated.column = r - 2, this.map.addMapping(g)) : (g.source = b, g.original.line = 1, g.original.column = 0, g.generated.line = u, g.generated.column = r - 1, this.map.addMapping(g)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((u) => u.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let u = this.mapOpts.annotation;
      return typeof u < "u" && u !== !0 ? !1 : this.previous().length ? this.previous().some((r) => r.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((u) => u.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(u) {
      if (this.mapOpts.absolute || u.charCodeAt(0) === 60 || /^\w+:\/\//.test(u)) return u;
      let r = this.memoizedPaths.get(u);
      if (r) return r;
      let b = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (b = e(i(b, this.mapOpts.annotation)));
      let g = t(b, u);
      return this.memoizedPaths.set(u, g), g;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((u) => {
            if (u.source && u.source.input.map) {
              let r = u.source.input.map;
              this.previousMaps.includes(r) || this.previousMaps.push(r);
            }
          });
        else {
          let u = new f(this.originalCSS, this.opts);
          u.map && this.previousMaps.push(u.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let u = {};
      if (this.root)
        this.root.walk((r) => {
          if (r.source) {
            let b = r.source.input.from;
            if (b && !u[b]) {
              u[b] = !0;
              let g = this.usesFileUrls ? this.toFileUrl(b) : this.toUrl(this.path(b));
              this.map.setSourceContent(g, r.source.input.css);
            }
          }
        });
      else if (this.css) {
        let r = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(r, this.css);
      }
    }
    sourcePath(u) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(u.source.input.from) : this.toUrl(this.path(u.source.input.from));
    }
    toBase64(u) {
      return Buffer ? Buffer.from(u).toString("base64") : window.btoa(unescape(encodeURIComponent(u)));
    }
    toFileUrl(u) {
      let r = this.memoizedFileURLs.get(u);
      if (r) return r;
      if (n) {
        let b = n(u).toString();
        return this.memoizedFileURLs.set(u, b), b;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(u) {
      let r = this.memoizedURLs.get(u);
      if (r) return r;
      s === "\\" && (u = u.replace(/\\/g, "/"));
      let b = encodeURI(u).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(u, b), b;
    }
  }
  return $t = o, $t;
}
var Rt, or;
function Zi() {
  if (or) return Rt;
  or = 1;
  const e = 39, t = 34, i = 92, s = 47, l = 10, d = 32, n = 12, f = 9, h = 13, a = 91, o = 93, m = 40, u = 41, r = 123, b = 125, g = 59, v = 42, c = 58, y = 64, w = /[\t\n\f\r "#'()/;[\\\]{}]/g, x = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, p = /.[\r\n"'(/\\]/, S = /[\da-f]/i;
  return Rt = function(A, O = {}) {
    let L = A.css.valueOf(), q = O.ignoreErrors, T, N, _, D, H, Y, X, re, ne, xe, Fe = L.length, V = 0, Ee = [], Le = [];
    function Ye() {
      return V;
    }
    function je(C) {
      throw A.error("Unclosed " + C, V);
    }
    function dt() {
      return Le.length === 0 && V >= Fe;
    }
    function ct(C) {
      if (Le.length) return Le.pop();
      if (V >= Fe) return;
      let B = C ? C.ignoreUnclosed : !1;
      switch (T = L.charCodeAt(V), T) {
        case l:
        case d:
        case f:
        case h:
        case n: {
          D = V;
          do
            D += 1, T = L.charCodeAt(D);
          while (T === d || T === l || T === f || T === h || T === n);
          Y = ["space", L.slice(V, D)], V = D - 1;
          break;
        }
        case a:
        case o:
        case r:
        case b:
        case c:
        case g:
        case u: {
          let I = String.fromCharCode(T);
          Y = [I, I, V];
          break;
        }
        case m: {
          if (xe = Ee.length ? Ee.pop()[1] : "", ne = L.charCodeAt(V + 1), xe === "url" && ne !== e && ne !== t && ne !== d && ne !== l && ne !== f && ne !== n && ne !== h) {
            D = V;
            do {
              if (X = !1, D = L.indexOf(")", D + 1), D === -1)
                if (q || B) {
                  D = V;
                  break;
                } else
                  je("bracket");
              for (re = D; L.charCodeAt(re - 1) === i; )
                re -= 1, X = !X;
            } while (X);
            Y = ["brackets", L.slice(V, D + 1), V, D], V = D;
          } else
            D = L.indexOf(")", V + 1), N = L.slice(V, D + 1), D === -1 || p.test(N) ? Y = ["(", "(", V] : (Y = ["brackets", N, V, D], V = D);
          break;
        }
        case e:
        case t: {
          H = T === e ? "'" : '"', D = V;
          do {
            if (X = !1, D = L.indexOf(H, D + 1), D === -1)
              if (q || B) {
                D = V + 1;
                break;
              } else
                je("string");
            for (re = D; L.charCodeAt(re - 1) === i; )
              re -= 1, X = !X;
          } while (X);
          Y = ["string", L.slice(V, D + 1), V, D], V = D;
          break;
        }
        case y: {
          w.lastIndex = V + 1, w.test(L), w.lastIndex === 0 ? D = L.length - 1 : D = w.lastIndex - 2, Y = ["at-word", L.slice(V, D + 1), V, D], V = D;
          break;
        }
        case i: {
          for (D = V, _ = !0; L.charCodeAt(D + 1) === i; )
            D += 1, _ = !_;
          if (T = L.charCodeAt(D + 1), _ && T !== s && T !== d && T !== l && T !== f && T !== h && T !== n && (D += 1, S.test(L.charAt(D)))) {
            for (; S.test(L.charAt(D + 1)); )
              D += 1;
            L.charCodeAt(D + 1) === d && (D += 1);
          }
          Y = ["word", L.slice(V, D + 1), V, D], V = D;
          break;
        }
        default: {
          T === s && L.charCodeAt(V + 1) === v ? (D = L.indexOf("*/", V + 2) + 1, D === 0 && (q || B ? D = L.length : je("comment")), Y = ["comment", L.slice(V, D + 1), V, D], V = D) : (x.lastIndex = V + 1, x.test(L), x.lastIndex === 0 ? D = L.length - 1 : D = x.lastIndex - 2, Y = ["word", L.slice(V, D + 1), V, D], Ee.push(Y), V = D);
          break;
        }
      }
      return V++, Y;
    }
    function We(C) {
      Le.push(C);
    }
    return {
      back: We,
      endOfFile: dt,
      nextToken: ct,
      position: Ye
    };
  }, Rt;
}
var Vt, dr;
function en() {
  if (dr) return Vt;
  dr = 1;
  let e = iu(), t = at(), i = lt(), s = Ge(), l = su(), d = Zi();
  const n = {
    empty: !0,
    space: !0
  };
  function f(a) {
    for (let o = a.length - 1; o >= 0; o--) {
      let m = a[o], u = m[3] || m[2];
      if (u) return u;
    }
  }
  class h {
    constructor(o) {
      this.input = o, this.root = new s(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: o, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(o) {
      let m = new e();
      m.name = o[1].slice(1), m.name === "" && this.unnamedAtrule(m, o), this.init(m, o[2]);
      let u, r, b, g = !1, v = !1, c = [], y = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (o = this.tokenizer.nextToken(), u = o[0], u === "(" || u === "[" ? y.push(u === "(" ? ")" : "]") : u === "{" && y.length > 0 ? y.push("}") : u === y[y.length - 1] && y.pop(), y.length === 0)
          if (u === ";") {
            m.source.end = this.getPosition(o[2]), m.source.end.offset++, this.semicolon = !0;
            break;
          } else if (u === "{") {
            v = !0;
            break;
          } else if (u === "}") {
            if (c.length > 0) {
              for (b = c.length - 1, r = c[b]; r && r[0] === "space"; )
                r = c[--b];
              r && (m.source.end = this.getPosition(r[3] || r[2]), m.source.end.offset++);
            }
            this.end(o);
            break;
          } else
            c.push(o);
        else
          c.push(o);
        if (this.tokenizer.endOfFile()) {
          g = !0;
          break;
        }
      }
      m.raws.between = this.spacesAndCommentsFromEnd(c), c.length ? (m.raws.afterName = this.spacesAndCommentsFromStart(c), this.raw(m, "params", c), g && (o = c[c.length - 1], m.source.end = this.getPosition(o[3] || o[2]), m.source.end.offset++, this.spaces = m.raws.between, m.raws.between = "")) : (m.raws.afterName = "", m.params = ""), v && (m.nodes = [], this.current = m);
    }
    checkMissedSemicolon(o) {
      let m = this.colon(o);
      if (m === !1) return;
      let u = 0, r;
      for (let b = m - 1; b >= 0 && (r = o[b], !(r[0] !== "space" && (u += 1, u === 2))); b--)
        ;
      throw this.input.error(
        "Missed semicolon",
        r[0] === "word" ? r[3] + 1 : r[2]
      );
    }
    colon(o) {
      let m = 0, u, r, b;
      for (let [g, v] of o.entries()) {
        if (r = v, b = r[0], b === "(" && (m += 1), b === ")" && (m -= 1), m === 0 && b === ":")
          if (!u)
            this.doubleColon(r);
          else {
            if (u[0] === "word" && u[1] === "progid")
              continue;
            return g;
          }
        u = r;
      }
      return !1;
    }
    comment(o) {
      let m = new t();
      this.init(m, o[2]), m.source.end = this.getPosition(o[3] || o[2]), m.source.end.offset++;
      let u = o[1].slice(2, -2);
      if (/^\s*$/.test(u))
        m.text = "", m.raws.left = u, m.raws.right = "";
      else {
        let r = u.match(/^(\s*)([^]*\S)(\s*)$/);
        m.text = r[2], m.raws.left = r[1], m.raws.right = r[3];
      }
    }
    createTokenizer() {
      this.tokenizer = d(this.input);
    }
    decl(o, m) {
      let u = new i();
      this.init(u, o[0][2]);
      let r = o[o.length - 1];
      for (r[0] === ";" && (this.semicolon = !0, o.pop()), u.source.end = this.getPosition(
        r[3] || r[2] || f(o)
      ), u.source.end.offset++; o[0][0] !== "word"; )
        o.length === 1 && this.unknownWord(o), u.raws.before += o.shift()[1];
      for (u.source.start = this.getPosition(o[0][2]), u.prop = ""; o.length; ) {
        let y = o[0][0];
        if (y === ":" || y === "space" || y === "comment")
          break;
        u.prop += o.shift()[1];
      }
      u.raws.between = "";
      let b;
      for (; o.length; )
        if (b = o.shift(), b[0] === ":") {
          u.raws.between += b[1];
          break;
        } else
          b[0] === "word" && /\w/.test(b[1]) && this.unknownWord([b]), u.raws.between += b[1];
      (u.prop[0] === "_" || u.prop[0] === "*") && (u.raws.before += u.prop[0], u.prop = u.prop.slice(1));
      let g = [], v;
      for (; o.length && (v = o[0][0], !(v !== "space" && v !== "comment")); )
        g.push(o.shift());
      this.precheckMissedSemicolon(o);
      for (let y = o.length - 1; y >= 0; y--) {
        if (b = o[y], b[1].toLowerCase() === "!important") {
          u.important = !0;
          let w = this.stringFrom(o, y);
          w = this.spacesFromEnd(o) + w, w !== " !important" && (u.raws.important = w);
          break;
        } else if (b[1].toLowerCase() === "important") {
          let w = o.slice(0), x = "";
          for (let p = y; p > 0; p--) {
            let S = w[p][0];
            if (x.trim().startsWith("!") && S !== "space")
              break;
            x = w.pop()[1] + x;
          }
          x.trim().startsWith("!") && (u.important = !0, u.raws.important = x, o = w);
        }
        if (b[0] !== "space" && b[0] !== "comment")
          break;
      }
      o.some((y) => y[0] !== "space" && y[0] !== "comment") && (u.raws.between += g.map((y) => y[1]).join(""), g = []), this.raw(u, "value", g.concat(o), m), u.value.includes(":") && !m && this.checkMissedSemicolon(o);
    }
    doubleColon(o) {
      throw this.input.error(
        "Double colon",
        { offset: o[2] },
        { offset: o[2] + o[1].length }
      );
    }
    emptyRule(o) {
      let m = new l();
      this.init(m, o[2]), m.selector = "", m.raws.between = "", this.current = m;
    }
    end(o) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(o[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(o);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(o) {
      if (this.spaces += o[1], this.current.nodes) {
        let m = this.current.nodes[this.current.nodes.length - 1];
        m && m.type === "rule" && !m.raws.ownSemicolon && (m.raws.ownSemicolon = this.spaces, this.spaces = "", m.source.end = this.getPosition(o[2]), m.source.end.offset += m.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(o) {
      let m = this.input.fromOffset(o);
      return {
        column: m.col,
        line: m.line,
        offset: o
      };
    }
    init(o, m) {
      this.current.push(o), o.source = {
        input: this.input,
        start: this.getPosition(m)
      }, o.raws.before = this.spaces, this.spaces = "", o.type !== "comment" && (this.semicolon = !1);
    }
    other(o) {
      let m = !1, u = null, r = !1, b = null, g = [], v = o[1].startsWith("--"), c = [], y = o;
      for (; y; ) {
        if (u = y[0], c.push(y), u === "(" || u === "[")
          b || (b = y), g.push(u === "(" ? ")" : "]");
        else if (v && r && u === "{")
          b || (b = y), g.push("}");
        else if (g.length === 0)
          if (u === ";")
            if (r) {
              this.decl(c, v);
              return;
            } else
              break;
          else if (u === "{") {
            this.rule(c);
            return;
          } else if (u === "}") {
            this.tokenizer.back(c.pop()), m = !0;
            break;
          } else u === ":" && (r = !0);
        else u === g[g.length - 1] && (g.pop(), g.length === 0 && (b = null));
        y = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (m = !0), g.length > 0 && this.unclosedBracket(b), m && r) {
        if (!v)
          for (; c.length && (y = c[c.length - 1][0], !(y !== "space" && y !== "comment")); )
            this.tokenizer.back(c.pop());
        this.decl(c, v);
      } else
        this.unknownWord(c);
    }
    parse() {
      let o;
      for (; !this.tokenizer.endOfFile(); )
        switch (o = this.tokenizer.nextToken(), o[0]) {
          case "space":
            this.spaces += o[1];
            break;
          case ";":
            this.freeSemicolon(o);
            break;
          case "}":
            this.end(o);
            break;
          case "comment":
            this.comment(o);
            break;
          case "at-word":
            this.atrule(o);
            break;
          case "{":
            this.emptyRule(o);
            break;
          default:
            this.other(o);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(o, m, u, r) {
      let b, g, v = u.length, c = "", y = !0, w, x;
      for (let p = 0; p < v; p += 1)
        b = u[p], g = b[0], g === "space" && p === v - 1 && !r ? y = !1 : g === "comment" ? (x = u[p - 1] ? u[p - 1][0] : "empty", w = u[p + 1] ? u[p + 1][0] : "empty", !n[x] && !n[w] ? c.slice(-1) === "," ? y = !1 : c += b[1] : y = !1) : c += b[1];
      if (!y) {
        let p = u.reduce((S, E) => S + E[1], "");
        o.raws[m] = { raw: p, value: c };
      }
      o[m] = c;
    }
    rule(o) {
      o.pop();
      let m = new l();
      this.init(m, o[0][2]), m.raws.between = this.spacesAndCommentsFromEnd(o), this.raw(m, "selector", o), this.current = m;
    }
    spacesAndCommentsFromEnd(o) {
      let m, u = "";
      for (; o.length && (m = o[o.length - 1][0], !(m !== "space" && m !== "comment")); )
        u = o.pop()[1] + u;
      return u;
    }
    // Errors
    spacesAndCommentsFromStart(o) {
      let m, u = "";
      for (; o.length && (m = o[0][0], !(m !== "space" && m !== "comment")); )
        u += o.shift()[1];
      return u;
    }
    spacesFromEnd(o) {
      let m, u = "";
      for (; o.length && (m = o[o.length - 1][0], m === "space"); )
        u = o.pop()[1] + u;
      return u;
    }
    stringFrom(o, m) {
      let u = "";
      for (let r = m; r < o.length; r++)
        u += o[r][1];
      return o.splice(m, o.length - m), u;
    }
    unclosedBlock() {
      let o = this.current.source.start;
      throw this.input.error("Unclosed block", o.line, o.column);
    }
    unclosedBracket(o) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: o[2] },
        { offset: o[2] + 1 }
      );
    }
    unexpectedClose(o) {
      throw this.input.error(
        "Unexpected }",
        { offset: o[2] },
        { offset: o[2] + 1 }
      );
    }
    unknownWord(o) {
      throw this.input.error(
        "Unknown word " + o[0][1],
        { offset: o[0][2] },
        { offset: o[0][2] + o[0][1].length }
      );
    }
    unnamedAtrule(o, m) {
      throw this.input.error(
        "At-rule without name",
        { offset: m[2] },
        { offset: m[2] + m[1].length }
      );
    }
  }
  return Vt = h, Vt;
}
var Ft, cr;
function au() {
  if (cr) return Ft;
  cr = 1;
  let e = Ve(), t = ot(), i = en();
  function s(l, d) {
    let n = new t(l, d), f = new i(n);
    try {
      f.parse();
    } catch (h) {
      throw process.env.NODE_ENV !== "production" && h.name === "CssSyntaxError" && d && d.from && (/\.scss$/i.test(d.from) ? h.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(d.from) ? h.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(d.from) && (h.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), h;
    }
    return f.root;
  }
  return Ft = s, s.default = s, e.registerParse(s), Ft;
}
var jt, fr;
function Pr() {
  if (fr) return jt;
  fr = 1;
  class e {
    constructor(i, s = {}) {
      if (this.type = "warning", this.text = i, s.node && s.node.source) {
        let l = s.node.rangeBy(s);
        this.line = l.start.line, this.column = l.start.column, this.endLine = l.end.line, this.endColumn = l.end.column;
      }
      for (let l in s) this[l] = s[l];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return jt = e, e.default = e, jt;
}
var Ut, hr;
function lu() {
  if (hr) return Ut;
  hr = 1;
  let e = Pr();
  class t {
    get content() {
      return this.css;
    }
    constructor(s, l, d) {
      this.processor = s, this.messages = [], this.root = l, this.opts = d, this.css = void 0, this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(s, l = {}) {
      l.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (l.plugin = this.lastPlugin.postcssPlugin);
      let d = new e(s, l);
      return this.messages.push(d), d;
    }
    warnings() {
      return this.messages.filter((s) => s.type === "warning");
    }
  }
  return Ut = t, t.default = t, Ut;
}
var Ht, pr;
function Lr() {
  if (pr) return Ht;
  pr = 1;
  let e = {};
  return Ht = function(i) {
    e[i] || (e[i] = !0, typeof console < "u" && console.warn && console.warn(i));
  }, Ht;
}
var zt, br;
function Ir() {
  if (br) return zt;
  br = 1;
  let e = Ve(), t = nu(), i = Or(), s = au(), l = lu(), d = Ge(), n = nt(), { isClean: f, my: h } = ru(), a = Lr();
  const o = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, m = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, u = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, r = 0;
  function b(x) {
    return typeof x == "object" && typeof x.then == "function";
  }
  function g(x) {
    let p = !1, S = o[x.type];
    return x.type === "decl" ? p = x.prop.toLowerCase() : x.type === "atrule" && (p = x.name.toLowerCase()), p && x.append ? [
      S,
      S + "-" + p,
      r,
      S + "Exit",
      S + "Exit-" + p
    ] : p ? [S, S + "-" + p, S + "Exit", S + "Exit-" + p] : x.append ? [S, r, S + "Exit"] : [S, S + "Exit"];
  }
  function v(x) {
    let p;
    return x.type === "document" ? p = ["Document", r, "DocumentExit"] : x.type === "root" ? p = ["Root", r, "RootExit"] : p = g(x), {
      eventIndex: 0,
      events: p,
      iterator: 0,
      node: x,
      visitorIndex: 0,
      visitors: []
    };
  }
  function c(x) {
    return x[f] = !1, x.nodes && x.nodes.forEach((p) => c(p)), x;
  }
  let y = {};
  class w {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(p, S, E) {
      this.stringified = !1, this.processed = !1;
      let A;
      if (typeof S == "object" && S !== null && (S.type === "root" || S.type === "document"))
        A = c(S);
      else if (S instanceof w || S instanceof l)
        A = c(S.root), S.map && (typeof E.map > "u" && (E.map = {}), E.map.inline || (E.map.inline = !1), E.map.prev = S.map);
      else {
        let O = s;
        E.syntax && (O = E.syntax.parse), E.parser && (O = E.parser), O.parse && (O = O.parse);
        try {
          A = O(S, E);
        } catch (L) {
          this.processed = !0, this.error = L;
        }
        A && !A[h] && e.rebuild(A);
      }
      this.result = new l(p, A, E), this.helpers = { ...y, postcss: y, result: this.result }, this.plugins = this.processor.plugins.map((O) => typeof O == "object" && O.prepare ? { ...O, ...O.prepare(this.result) } : O);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(p) {
      return this.async().catch(p);
    }
    finally(p) {
      return this.async().then(p, p);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(p, S) {
      let E = this.result.lastPlugin;
      try {
        if (S && S.addToError(p), this.error = p, p.name === "CssSyntaxError" && !p.plugin)
          p.plugin = E.postcssPlugin, p.setMessage();
        else if (E.postcssVersion && process.env.NODE_ENV !== "production") {
          let A = E.postcssPlugin, O = E.postcssVersion, L = this.result.processor.version, q = O.split("."), T = L.split(".");
          (q[0] !== T[0] || parseInt(q[1]) > parseInt(T[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + L + ", but " + A + " uses " + O + ". Perhaps this is the source of the error below."
          );
        }
      } catch (A) {
        console && console.error && console.error(A);
      }
      return p;
    }
    prepareVisitors() {
      this.listeners = {};
      let p = (S, E, A) => {
        this.listeners[E] || (this.listeners[E] = []), this.listeners[E].push([S, A]);
      };
      for (let S of this.plugins)
        if (typeof S == "object")
          for (let E in S) {
            if (!m[E] && /^[A-Z]/.test(E))
              throw new Error(
                `Unknown event ${E} in ${S.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!u[E])
              if (typeof S[E] == "object")
                for (let A in S[E])
                  A === "*" ? p(S, E, S[E][A]) : p(
                    S,
                    E + "-" + A.toLowerCase(),
                    S[E][A]
                  );
              else typeof S[E] == "function" && p(S, E, S[E]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let p = 0; p < this.plugins.length; p++) {
        let S = this.plugins[p], E = this.runOnRoot(S);
        if (b(E))
          try {
            await E;
          } catch (A) {
            throw this.handleError(A);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let p = this.result.root;
        for (; !p[f]; ) {
          p[f] = !0;
          let S = [v(p)];
          for (; S.length > 0; ) {
            let E = this.visitTick(S);
            if (b(E))
              try {
                await E;
              } catch (A) {
                let O = S[S.length - 1].node;
                throw this.handleError(A, O);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [S, E] of this.listeners.OnceExit) {
            this.result.lastPlugin = S;
            try {
              if (p.type === "document") {
                let A = p.nodes.map(
                  (O) => E(O, this.helpers)
                );
                await Promise.all(A);
              } else
                await E(p, this.helpers);
            } catch (A) {
              throw this.handleError(A);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(p) {
      this.result.lastPlugin = p;
      try {
        if (typeof p == "object" && p.Once) {
          if (this.result.root.type === "document") {
            let S = this.result.root.nodes.map(
              (E) => p.Once(E, this.helpers)
            );
            return b(S[0]) ? Promise.all(S) : S;
          }
          return p.Once(this.result.root, this.helpers);
        } else if (typeof p == "function")
          return p(this.result.root, this.result);
      } catch (S) {
        throw this.handleError(S);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let p = this.result.opts, S = n;
      p.syntax && (S = p.syntax.stringify), p.stringifier && (S = p.stringifier), S.stringify && (S = S.stringify);
      let A = new i(S, this.result.root, this.result.opts).generate();
      return this.result.css = A[0], this.result.map = A[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let p of this.plugins) {
        let S = this.runOnRoot(p);
        if (b(S))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let p = this.result.root;
        for (; !p[f]; )
          p[f] = !0, this.walkSync(p);
        if (this.listeners.OnceExit)
          if (p.type === "document")
            for (let S of p.nodes)
              this.visitSync(this.listeners.OnceExit, S);
          else
            this.visitSync(this.listeners.OnceExit, p);
      }
      return this.result;
    }
    then(p, S) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || a(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(p, S);
    }
    toString() {
      return this.css;
    }
    visitSync(p, S) {
      for (let [E, A] of p) {
        this.result.lastPlugin = E;
        let O;
        try {
          O = A(S, this.helpers);
        } catch (L) {
          throw this.handleError(L, S.proxyOf);
        }
        if (S.type !== "root" && S.type !== "document" && !S.parent)
          return !0;
        if (b(O))
          throw this.getAsyncError();
      }
    }
    visitTick(p) {
      let S = p[p.length - 1], { node: E, visitors: A } = S;
      if (E.type !== "root" && E.type !== "document" && !E.parent) {
        p.pop();
        return;
      }
      if (A.length > 0 && S.visitorIndex < A.length) {
        let [L, q] = A[S.visitorIndex];
        S.visitorIndex += 1, S.visitorIndex === A.length && (S.visitors = [], S.visitorIndex = 0), this.result.lastPlugin = L;
        try {
          return q(E.toProxy(), this.helpers);
        } catch (T) {
          throw this.handleError(T, E);
        }
      }
      if (S.iterator !== 0) {
        let L = S.iterator, q;
        for (; q = E.nodes[E.indexes[L]]; )
          if (E.indexes[L] += 1, !q[f]) {
            q[f] = !0, p.push(v(q));
            return;
          }
        S.iterator = 0, delete E.indexes[L];
      }
      let O = S.events;
      for (; S.eventIndex < O.length; ) {
        let L = O[S.eventIndex];
        if (S.eventIndex += 1, L === r) {
          E.nodes && E.nodes.length && (E[f] = !0, S.iterator = E.getIterator());
          return;
        } else if (this.listeners[L]) {
          S.visitors = this.listeners[L];
          return;
        }
      }
      p.pop();
    }
    walkSync(p) {
      p[f] = !0;
      let S = g(p);
      for (let E of S)
        if (E === r)
          p.nodes && p.each((A) => {
            A[f] || this.walkSync(A);
          });
        else {
          let A = this.listeners[E];
          if (A && this.visitSync(A, p.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return w.registerPostcss = (x) => {
    y = x;
  }, zt = w, w.default = w, d.registerLazyResult(w), t.registerLazyResult(w), zt;
}
var Gt, mr;
function tn() {
  if (mr) return Gt;
  mr = 1;
  let e = Or(), t = au();
  const i = lu();
  let s = nt(), l = Lr();
  class d {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let f, h = t;
      try {
        f = h(this._css, this._opts);
      } catch (a) {
        this.error = a;
      }
      if (this.error)
        throw this.error;
      return this._root = f, f;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(f, h, a) {
      h = h.toString(), this.stringified = !1, this._processor = f, this._css = h, this._opts = a, this._map = void 0;
      let o, m = s;
      this.result = new i(this._processor, o, this._opts), this.result.css = h;
      let u = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return u.root;
        }
      });
      let r = new e(m, o, this._opts, h);
      if (r.isMap()) {
        let [b, g] = r.generate();
        b && (this.result.css = b), g && (this.result.map = g);
      } else
        r.clearAnnotation(), this.result.css = r.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(f) {
      return this.async().catch(f);
    }
    finally(f) {
      return this.async().then(f, f);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(f, h) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || l(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(f, h);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Gt = d, d.default = d, Gt;
}
var Yt, gr;
function un() {
  if (gr) return Yt;
  gr = 1;
  let e = nu(), t = Ir(), i = tn(), s = Ge();
  class l {
    constructor(n = []) {
      this.version = "8.5.3", this.plugins = this.normalize(n);
    }
    normalize(n) {
      let f = [];
      for (let h of n)
        if (h.postcss === !0 ? h = h() : h.postcss && (h = h.postcss), typeof h == "object" && Array.isArray(h.plugins))
          f = f.concat(h.plugins);
        else if (typeof h == "object" && h.postcssPlugin)
          f.push(h);
        else if (typeof h == "function")
          f.push(h);
        else if (typeof h == "object" && (h.parse || h.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(h + " is not a PostCSS plugin");
      return f;
    }
    process(n, f = {}) {
      return !this.plugins.length && !f.parser && !f.stringifier && !f.syntax ? new i(this, n, f) : new t(this, n, f);
    }
    use(n) {
      return this.plugins = this.plugins.concat(this.normalize([n])), this;
    }
  }
  return Yt = l, l.default = l, s.registerProcessor(l), e.registerProcessor(l), Yt;
}
var Wt, yr;
function rn() {
  if (yr) return Wt;
  yr = 1;
  let e = iu(), t = at(), i = Ve(), s = uu(), l = lt(), d = nu(), n = Qi(), f = ot(), h = Ir(), a = Cr(), o = st(), m = au(), u = un(), r = lu(), b = Ge(), g = su(), v = nt(), c = Pr();
  function y(...w) {
    return w.length === 1 && Array.isArray(w[0]) && (w = w[0]), new u(w);
  }
  return y.plugin = function(x, p) {
    let S = !1;
    function E(...O) {
      console && console.warn && !S && (S = !0, console.warn(
        x + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        x + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let L = p(...O);
      return L.postcssPlugin = x, L.postcssVersion = new u().version, L;
    }
    let A;
    return Object.defineProperty(E, "postcss", {
      get() {
        return A || (A = E()), A;
      }
    }), E.process = function(O, L, q) {
      return y([E(q)]).process(O, L);
    }, E;
  }, y.stringify = v, y.parse = m, y.fromJSON = n, y.list = a, y.comment = (w) => new t(w), y.atRule = (w) => new e(w), y.decl = (w) => new l(w), y.rule = (w) => new g(w), y.root = (w) => new b(w), y.document = (w) => new d(w), y.CssSyntaxError = s, y.Declaration = l, y.Container = i, y.Processor = u, y.Document = d, y.Comment = t, y.Warning = c, y.AtRule = e, y.Result = r, y.Input = f, y.Rule = g, y.Root = b, y.Node = o, h.registerPostcss(y), Wt = y, y.default = y, Wt;
}
var Kt, vr;
function nn() {
  if (vr) return Kt;
  vr = 1;
  const e = /* @__PURE__ */ ji(), t = Ui(), { isPlainObject: i } = Hi(), s = zi(), l = Yi(), { parse: d } = rn(), n = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], f = ["script", "style"];
  function h(v, c) {
    v && Object.keys(v).forEach(function(y) {
      c(v[y], y);
    });
  }
  function a(v, c) {
    return {}.hasOwnProperty.call(v, c);
  }
  function o(v, c) {
    const y = [];
    return h(v, function(w) {
      c(w) && y.push(w);
    }), y;
  }
  function m(v) {
    for (const c in v)
      if (a(v, c))
        return !1;
    return !0;
  }
  function u(v) {
    return v.map(function(c) {
      if (!c.url)
        throw new Error("URL missing");
      return c.url + (c.w ? ` ${c.w}w` : "") + (c.h ? ` ${c.h}h` : "") + (c.d ? ` ${c.d}x` : "");
    }).join(", ");
  }
  Kt = b;
  const r = /^[^\0\t\n\f\r /<=>]+$/;
  function b(v, c, y) {
    if (v == null)
      return "";
    typeof v == "number" && (v = v.toString());
    let w = "", x = "";
    function p(C, B) {
      const I = this;
      this.tag = C, this.attribs = B || {}, this.tagPosition = w.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (H.length) {
          const F = H[H.length - 1];
          F.text += I.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        H.length && n.includes(this.tag) && H[H.length - 1].mediaChildren.push(this.tag);
      };
    }
    c = Object.assign({}, b.defaults, c), c.parser = Object.assign({}, g, c.parser);
    const S = function(C) {
      return c.allowedTags === !1 || (c.allowedTags || []).indexOf(C) > -1;
    };
    f.forEach(function(C) {
      S(C) && !c.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${C}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const E = c.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let A, O;
    c.allowedAttributes && (A = {}, O = {}, h(c.allowedAttributes, function(C, B) {
      A[B] = [];
      const I = [];
      C.forEach(function(F) {
        typeof F == "string" && F.indexOf("*") >= 0 ? I.push(t(F).replace(/\\\*/g, ".*")) : A[B].push(F);
      }), I.length && (O[B] = new RegExp("^(" + I.join("|") + ")$"));
    }));
    const L = {}, q = {}, T = {};
    h(c.allowedClasses, function(C, B) {
      if (A && (a(A, B) || (A[B] = []), A[B].push("class")), L[B] = C, Array.isArray(C)) {
        const I = [];
        L[B] = [], T[B] = [], C.forEach(function(F) {
          typeof F == "string" && F.indexOf("*") >= 0 ? I.push(t(F).replace(/\\\*/g, ".*")) : F instanceof RegExp ? T[B].push(F) : L[B].push(F);
        }), I.length && (q[B] = new RegExp("^(" + I.join("|") + ")$"));
      }
    });
    const N = {};
    let _;
    h(c.transformTags, function(C, B) {
      let I;
      typeof C == "function" ? I = C : typeof C == "string" && (I = b.simpleTransform(C)), B === "*" ? _ = I : N[B] = I;
    });
    let D, H, Y, X, re, ne, xe = !1;
    V();
    const Fe = new e.Parser({
      onopentag: function(C, B) {
        if (c.onOpenTag && c.onOpenTag(C, B), c.enforceHtmlBoundary && C === "html" && V(), re) {
          ne++;
          return;
        }
        const I = new p(C, B);
        H.push(I);
        let F = !1;
        const le = !!I.text;
        let ce;
        if (a(N, C) && (ce = N[C](C, B), I.attribs = B = ce.attribs, ce.text !== void 0 && (I.innerText = ce.text), C !== ce.tagName && (I.name = C = ce.tagName, X[D] = ce.tagName)), _ && (ce = _(C, B), I.attribs = B = ce.attribs, C !== ce.tagName && (I.name = C = ce.tagName, X[D] = ce.tagName)), (!S(C) || c.disallowedTagsMode === "recursiveEscape" && !m(Y) || c.nestingLimit != null && D >= c.nestingLimit) && (F = !0, Y[D] = !0, (c.disallowedTagsMode === "discard" || c.disallowedTagsMode === "completelyDiscard") && E.indexOf(C) !== -1 && (re = !0, ne = 1)), D++, F) {
          if (c.disallowedTagsMode === "discard" || c.disallowedTagsMode === "completelyDiscard") {
            if (I.innerText && !le) {
              const ee = Ee(I.innerText);
              c.textFilter ? w += c.textFilter(ee, C) : w += ee, xe = !0;
            }
            return;
          }
          x = w, w = "";
        }
        w += "<" + C, C === "script" && (c.allowedScriptHostnames || c.allowedScriptDomains) && (I.innerText = ""), (!A || a(A, C) || A["*"]) && h(B, function(ee, Q) {
          if (!r.test(Q)) {
            delete I.attribs[Q];
            return;
          }
          if (ee === "" && !c.allowedEmptyAttributes.includes(Q) && (c.nonBooleanAttributes.includes(Q) || c.nonBooleanAttributes.includes("*"))) {
            delete I.attribs[Q];
            return;
          }
          let ft = !1;
          if (!A || a(A, C) && A[C].indexOf(Q) !== -1 || A["*"] && A["*"].indexOf(Q) !== -1 || a(O, C) && O[C].test(Q) || O["*"] && O["*"].test(Q))
            ft = !0;
          else if (A && A[C]) {
            for (const K of A[C])
              if (i(K) && K.name && K.name === Q) {
                ft = !0;
                let J = "";
                if (K.multiple === !0) {
                  const Ie = ee.split(" ");
                  for (const Ae of Ie)
                    K.values.indexOf(Ae) !== -1 && (J === "" ? J = Ae : J += " " + Ae);
                } else K.values.indexOf(ee) >= 0 && (J = ee);
                ee = J;
              }
          }
          if (ft) {
            if (c.allowedSchemesAppliedToAttributes.indexOf(Q) !== -1 && Le(C, ee)) {
              delete I.attribs[Q];
              return;
            }
            if (C === "script" && Q === "src") {
              let K = !0;
              try {
                const J = Ye(ee);
                if (c.allowedScriptHostnames || c.allowedScriptDomains) {
                  const Ie = (c.allowedScriptHostnames || []).find(function(be) {
                    return be === J.url.hostname;
                  }), Ae = (c.allowedScriptDomains || []).find(function(be) {
                    return J.url.hostname === be || J.url.hostname.endsWith(`.${be}`);
                  });
                  K = Ie || Ae;
                }
              } catch {
                K = !1;
              }
              if (!K) {
                delete I.attribs[Q];
                return;
              }
            }
            if (C === "iframe" && Q === "src") {
              let K = !0;
              try {
                const J = Ye(ee);
                if (J.isRelativeUrl)
                  K = a(c, "allowIframeRelativeUrls") ? c.allowIframeRelativeUrls : !c.allowedIframeHostnames && !c.allowedIframeDomains;
                else if (c.allowedIframeHostnames || c.allowedIframeDomains) {
                  const Ie = (c.allowedIframeHostnames || []).find(function(be) {
                    return be === J.url.hostname;
                  }), Ae = (c.allowedIframeDomains || []).find(function(be) {
                    return J.url.hostname === be || J.url.hostname.endsWith(`.${be}`);
                  });
                  K = Ie || Ae;
                }
              } catch {
                K = !1;
              }
              if (!K) {
                delete I.attribs[Q];
                return;
              }
            }
            if (Q === "srcset")
              try {
                let K = l(ee);
                if (K.forEach(function(J) {
                  Le("srcset", J.url) && (J.evil = !0);
                }), K = o(K, function(J) {
                  return !J.evil;
                }), K.length)
                  ee = u(o(K, function(J) {
                    return !J.evil;
                  })), I.attribs[Q] = ee;
                else {
                  delete I.attribs[Q];
                  return;
                }
              } catch {
                delete I.attribs[Q];
                return;
              }
            if (Q === "class") {
              const K = L[C], J = L["*"], Ie = q[C], Ae = T[C], be = T["*"], _r = q["*"], du = [
                Ie,
                _r
              ].concat(Ae, be).filter(function($r) {
                return $r;
              });
              if (K && J ? ee = We(ee, s(K, J), du) : ee = We(ee, K || J, du), !ee.length) {
                delete I.attribs[Q];
                return;
              }
            }
            if (Q === "style") {
              if (c.parseStyleAttributes)
                try {
                  const K = d(C + " {" + ee + "}", { map: !1 }), J = je(K, c.allowedStyles);
                  if (ee = dt(J), ee.length === 0) {
                    delete I.attribs[Q];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + C + " {" + ee + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete I.attribs[Q];
                  return;
                }
              else if (c.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            w += " " + Q, ee && ee.length ? w += '="' + Ee(ee, !0) + '"' : c.allowedEmptyAttributes.includes(Q) && (w += '=""');
          } else
            delete I.attribs[Q];
        }), c.selfClosing.indexOf(C) !== -1 ? w += " />" : (w += ">", I.innerText && !le && !c.textFilter && (w += Ee(I.innerText), xe = !0)), F && (w = x + Ee(w), x = ""), I.openingTagLength = w.length - I.tagPosition;
      },
      ontext: function(C) {
        if (re)
          return;
        const B = H[H.length - 1];
        let I;
        if (B && (I = B.tag, C = B.innerText !== void 0 ? B.innerText : C), c.disallowedTagsMode === "completelyDiscard" && !S(I))
          C = "";
        else if ((c.disallowedTagsMode === "discard" || c.disallowedTagsMode === "completelyDiscard") && (I === "script" || I === "style"))
          w += C;
        else if (!xe) {
          const F = Ee(C, !1);
          c.textFilter ? w += c.textFilter(F, I) : w += F;
        }
        if (H.length) {
          const F = H[H.length - 1];
          F.text += C;
        }
      },
      onclosetag: function(C, B) {
        if (c.onCloseTag && c.onCloseTag(C, B), re)
          if (ne--, !ne)
            re = !1;
          else
            return;
        const I = H.pop();
        if (!I)
          return;
        if (I.tag !== C) {
          H.push(I);
          return;
        }
        re = c.enforceHtmlBoundary ? C === "html" : !1, D--;
        const F = Y[D];
        if (F) {
          if (delete Y[D], c.disallowedTagsMode === "discard" || c.disallowedTagsMode === "completelyDiscard") {
            I.updateParentNodeText();
            return;
          }
          x = w, w = "";
        }
        if (X[D] && (C = X[D], delete X[D]), c.exclusiveFilter) {
          const le = c.exclusiveFilter(I);
          if (le === "excludeTag") {
            F && (w = x, x = ""), w = w.substring(0, I.tagPosition) + w.substring(I.tagPosition + I.openingTagLength);
            return;
          } else if (le) {
            w = w.substring(0, I.tagPosition);
            return;
          }
        }
        if (I.updateParentNodeMediaChildren(), I.updateParentNodeText(), // Already output />
        c.selfClosing.indexOf(C) !== -1 || // Escaped tag, closing tag is implied
        B && !S(C) && ["escape", "recursiveEscape"].indexOf(c.disallowedTagsMode) >= 0) {
          F && (w = x, x = "");
          return;
        }
        w += "</" + C + ">", F && (w = x + Ee(w), x = ""), xe = !1;
      }
    }, c.parser);
    return Fe.write(v), Fe.end(), w;
    function V() {
      w = "", D = 0, H = [], Y = {}, X = {}, re = !1, ne = 0;
    }
    function Ee(C, B) {
      return typeof C != "string" && (C = C + ""), c.parser.decodeEntities && (C = C.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), B && (C = C.replace(/"/g, "&quot;"))), C = C.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), B && (C = C.replace(/"/g, "&quot;")), C;
    }
    function Le(C, B) {
      for (B = B.replace(/[\x00-\x20]+/g, ""); ; ) {
        const le = B.indexOf("<!--");
        if (le === -1)
          break;
        const ce = B.indexOf("-->", le + 4);
        if (ce === -1)
          break;
        B = B.substring(0, le) + B.substring(ce + 3);
      }
      const I = B.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!I)
        return B.match(/^[/\\]{2}/) ? !c.allowProtocolRelative : !1;
      const F = I[1].toLowerCase();
      return a(c.allowedSchemesByTag, C) ? c.allowedSchemesByTag[C].indexOf(F) === -1 : !c.allowedSchemes || c.allowedSchemes.indexOf(F) === -1;
    }
    function Ye(C) {
      if (C = C.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), C.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let B = "relative://relative-site";
      for (let le = 0; le < 100; le++)
        B += `/${le}`;
      const I = new URL(C, B);
      return {
        isRelativeUrl: I && I.hostname === "relative-site" && I.protocol === "relative:",
        url: I
      };
    }
    function je(C, B) {
      if (!B)
        return C;
      const I = C.nodes[0];
      let F;
      return B[I.selector] && B["*"] ? F = s(
        B[I.selector],
        B["*"]
      ) : F = B[I.selector] || B["*"], F && (C.nodes[0].nodes = I.nodes.reduce(ct(F), [])), C;
    }
    function dt(C) {
      return C.nodes[0].nodes.reduce(function(B, I) {
        return B.push(
          `${I.prop}:${I.value}${I.important ? " !important" : ""}`
        ), B;
      }, []).join(";");
    }
    function ct(C) {
      return function(B, I) {
        return a(C, I.prop) && C[I.prop].some(function(le) {
          return le.test(I.value);
        }) && B.push(I), B;
      };
    }
    function We(C, B, I) {
      return B ? (C = C.split(/\s+/), C.filter(function(F) {
        return B.indexOf(F) !== -1 || I.some(function(le) {
          return le.test(F);
        });
      }).join(" ")) : C;
    }
  }
  const g = {
    decodeEntities: !0
  };
  return b.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0
  }, b.simpleTransform = function(v, c, y) {
    return y = y === void 0 ? !0 : y, c = c || {}, function(w, x) {
      let p;
      if (y)
        for (p in c)
          x[p] = c[p];
      else
        x = c;
      return {
        tagName: v,
        attribs: x
      };
    };
  }, Kt;
}
var sn = /* @__PURE__ */ nn();
const ou = /* @__PURE__ */ Oi(sn), an = te({
  name: "DpsFormCheckboxGroup",
  components: {
    DpsFormCheckbox: tu
  },
  props: {
    /**
     * The unique identifier for the checkbox group (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * modelValue of the checkbox group.
     * @default undefined
     */
    modelValue: {
      type: Array,
      required: !1,
      default: void 0
    },
    /**
     * Name attribute of the checkboxes.
     * @default undefined
     */
    name: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Label for the checkbox group.
     * @default undefined
     */
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Array of checkbox data to be displayed.
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Key to use for the checkbox values.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: !1,
      default: "value"
    },
    /**
     * Key to use for the checkbox labels.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: !1,
      default: "label"
    },
    /**
     * Disables the checkbox group.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Checkboxes displayed in line.
     * @default false
     */
    inline: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Truncates the labels.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Size of the checkboxes.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when one of the values changes.
     * @event module:DpsFormCheckboxGroup#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    mappedOptions() {
      const e = [];
      return this.options.forEach((t) => {
        let i = {};
        typeof t != "object" ? (i[this.optionValue] = t, i[this.optionLabel] = t) : i = JSON.parse(JSON.stringify(t)), e.push(i);
      }), e;
    },
    uniqueId() {
      return this.id ? this.id : de("dps-form-checkbox-group-");
    }
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleChange(e) {
      this.selected = e, this.$emit("update:modelValue", e);
    },
    getLabelContent(e) {
      const t = e[this.optionLabel];
      return typeof t == "string" ? ou(t) : t.toString();
    }
  }
}), ln = ["id"], on = { class: "dps-input-wrapper" }, dn = ["innerHTML"];
function cn(e, t, i, s, l, d) {
  const n = se("DpsFormCheckbox");
  return k(), P("fieldset", {
    id: e.uniqueId,
    class: R(["dps-form-checkbox-group", { "dps-form-checkbox-group--inline": e.inline }])
  }, [
    e.label ? (k(), P("legend", {
      key: 0,
      class: R(["dps-label", { "visually-hidden": e.hideLabel }])
    }, G(e.label), 3)) : U("", !0),
    M("div", on, [
      (k(!0), P(ae, null, we(e.mappedOptions, (f, h) => (k(), ie(n, {
        id: e.uniqueId + "-option-" + h,
        key: "option-" + h,
        name: e.name,
        value: f[e.optionValue],
        disabled: e.disabled || f.disabled,
        readonly: f.readonly,
        error: f.error,
        block: !e.inline,
        truncate: e.truncate,
        tooltip: f.tooltip,
        size: e.size,
        "model-value": e.selected,
        "onUpdate:modelValue": e.handleChange
      }, {
        default: z(() => [
          M("span", {
            innerHTML: e.getLabelContent(f)
          }, null, 8, dn)
        ]),
        _: 2
      }, 1032, ["id", "name", "value", "disabled", "readonly", "error", "block", "truncate", "tooltip", "size", "model-value", "onUpdate:modelValue"]))), 128))
    ])
  ], 10, ln);
}
const Wa = /* @__PURE__ */ W(an, [["render", cn]]), fn = te({
  name: "DpsFormGroup",
  props: {
    /**
     * Unique ID for the component (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Description text shown under the content.
     * @default undefined
     */
    description: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Label for the group.
     * @default undefined
     */
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of the element the label is for.
     * @default undefined
     */
    labelFor: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Text shown on success.
     * @default undefined
     */
    successFeedback: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Text shown on error.
     * @default undefined
     */
    errorFeedback: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the input is valid or not.
     * `undefined` if the state is neutral.
     * @default undefined
     */
    valid: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    /**
     * Whether the group is disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-form-group-");
    },
    hasError() {
      return this.valid === !1;
    },
    hasSuccess() {
      return this.valid === !0;
    },
    ariaDescribedby() {
      const e = [];
      if (this.description && e.push(this.uniqueId + "__description"), this.successFeedback && this.hasSuccess && e.push(this.uniqueId + "__success-feedback"), this.errorFeedback && this.hasError && e.push(this.uniqueId + "__error-feedback"), e.length)
        return e.join(" ");
    }
  }
}), hn = ["id", "aria-invalid"], pn = ["id", "for"], bn = ["id"], mn = ["id"], gn = ["id"];
function yn(e, t, i, s, l, d) {
  return k(), P("div", {
    id: e.uniqueId,
    class: R(["dps-form-group", {
      "dps-form-group--disabled": e.disabled
    }]),
    role: "group",
    "aria-invalid": e.hasError ? "true" : void 0
  }, [
    e.label ? (k(), P("label", {
      key: 0,
      id: e.uniqueId + "__label",
      for: e.labelFor,
      class: R(["dps-form-group__label", { "visually-hidden": e.hideLabel }])
    }, G(e.label), 11, pn)) : U("", !0),
    M("div", null, [
      $(e.$slots, "default", {
        slotProps: {
          success: e.hasSuccess,
          error: e.hasError,
          disabled: e.disabled,
          description: e.description,
          ariaDescribedby: e.ariaDescribedby
        }
      }),
      e.errorFeedback ? _e((k(), P("div", {
        key: 0,
        id: e.uniqueId + "__error-feedback",
        tabindex: "-1",
        "aria-live": "assertive",
        class: "dps-form-group__feedback dps-form-group__feedback--error"
      }, G(e.errorFeedback), 9, bn)), [
        [$e, e.hasError]
      ]) : U("", !0),
      e.successFeedback ? _e((k(), P("div", {
        key: 1,
        id: e.uniqueId + "__success-feedback",
        tabindex: "-1",
        "aria-live": "assertive",
        class: "dps-form-group__feedback dps-form-group__feedback--success"
      }, G(e.successFeedback), 9, mn)), [
        [$e, e.hasSuccess]
      ]) : U("", !0),
      e.description ? (k(), P("div", {
        key: 2,
        id: e.uniqueId + "__description",
        tabindex: "-1",
        class: "dps-form-group__description"
      }, G(e.description), 9, gn)) : U("", !0)
    ])
  ], 10, hn);
}
const Nr = /* @__PURE__ */ W(fn, [["render", yn]]), vn = te({
  name: "DpsFormInput",
  inheritAttrs: !1,
  props: {
    /**
     * Unique ID of the input field.
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ModelValue of the input.
     * @default undefined
     */
    modelValue: {
      type: [String, Number],
      required: !1,
      default: void 0
    },
    /**
     * Icon displayed at the end of the input field.
     * @default undefined
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Placeholder text.
     * @default undefined
     */
    placeholder: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Title attribute of the input.
     * @default undefined
     */
    title: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Makes the field readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Disables the field.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The maximum string length that the user can enter.
     * @default -1
     */
    maxlength: {
      type: Number,
      required: !1,
      default: -1
    },
    /**
     * The type of the input field.
     * @default "text"
     */
    type: {
      type: String,
      required: !1,
      default: "text"
    },
    /**
     * The step attribute specifying the granularity number values have to
     * adhere to.
     * @default 1
     */
    step: {
      type: Number,
      required: !1,
      default: 1
    },
    /**
     * The minimum value to accept for this input.
     * @default undefined
     */
    min: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * The maximum value to accept for this input.
     * @default undefined
     */
    max: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * Pattern the value must match to be valid.
     * @default undefined
     */
    pattern: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Required field.
     * @default false
     */
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Aria label for the input.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of the element that labels the input.
     * @default undefined
     */
    ariaLabelledby: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of the element that describes the input.
     * @default undefined
     */
    ariaDescribedby: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Vertical size of the input field.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Displays the success state.
     * @default false
     */
    success: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Displays the error state.
     * @default false
     */
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: !1,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     * @event module:DpsFormInput#update:modelValue
     */
    "update:modelValue",
    /**
     * Emitted on keyup.
     * @event module:DpsFormInput#keyup
     */
    "keyup",
    /**
     * Emitted on keydown.
     * @event module:DpsFormInput#keydown
     */
    "keydown",
    /**
     * Emitted on blur.
     * @event module:DpsFormInput#blur
     */
    "blur",
    /**
     * Emitted on focus.
     * @event module:DpsFormInput#focus
     */
    "focus"
  ],
  computed: {
    outerClass() {
      return this.class;
    },
    iconName() {
      if (this.icon)
        return this.icon;
      if (this.error)
        return "error";
      if (this.success)
        return "success";
    },
    showSearchCancelButton() {
      var e;
      return this.type === "search" && typeof this.modelValue == "string" && ((e = this.modelValue) == null ? void 0 : e.length) > 0;
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    cancelSearch() {
      this.$emit("update:modelValue", ""), this.focus();
    },
    handleInput(e) {
      const i = e.target.value;
      this.$emit("update:modelValue", i);
    }
  }
}), wn = ["id", "value", "type", "step", "min", "max", "placeholder", "title", "pattern", "required", "readonly", "disabled", "maxlength", "aria-label", "aria-describedby", "aria-labelledby"];
function Sn(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-form-input dps-input-wrapper", {
      "dps-form-input--success": e.success,
      "dps-form-input--error": e.error,
      [e.outerClass]: !0
    }])
  }, [
    M("input", Zt(e.$attrs, {
      id: e.id,
      ref: "input",
      value: e.modelValue,
      class: ["dps-input", {
        "dps-input--success": e.success,
        "dps-input--error": e.error,
        "dps-input--size-sm": e.size === "sm",
        "dps-input--icon": e.iconName
      }],
      type: e.type,
      step: e.type === "number" ? e.step : void 0,
      min: e.type === "number" ? e.min : void 0,
      max: e.type === "number" ? e.max : void 0,
      placeholder: e.placeholder,
      title: e.title,
      pattern: e.pattern,
      required: e.required,
      readonly: e.readonly,
      disabled: e.disabled,
      maxlength: e.maxlength,
      "aria-label": e.ariaLabel,
      "aria-describedby": e.ariaDescribedby,
      "aria-labelledby": e.ariaLabelledby,
      onKeyup: t[0] || (t[0] = ue((n) => e.$emit("keyup", n), ["stop"])),
      onKeydown: t[1] || (t[1] = ue((n) => e.$emit("keydown", n), ["stop"])),
      onBlur: t[2] || (t[2] = ue((n) => e.$emit("blur", n), ["stop"])),
      onFocus: t[3] || (t[3] = ue((n) => e.$emit("focus", n), ["stop"])),
      onInput: t[4] || (t[4] = (...n) => e.handleInput && e.handleInput(...n))
    }), null, 16, wn),
    e.showSearchCancelButton ? (k(), P("button", {
      key: 0,
      type: "button",
      class: "dps-form-input__search-cancel-button dps-icon dps-icon--close",
      title: "Eingabe zurücksetzen",
      onClick: t[5] || (t[5] = (...n) => e.cancelSearch && e.cancelSearch(...n))
    })) : e.iconName ? (k(), P("span", {
      key: 1,
      class: R(["dps-icon", "dps-icon--" + e.iconName])
    }, null, 2)) : U("", !0)
  ], 2);
}
const Ka = /* @__PURE__ */ W(vn, [["render", Sn]]), xn = te({
  name: "DpsFormRadio",
  props: {
    /**
     * Unique ID for the radio (optional)
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ModelValue of the radio.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number],
      required: !1,
      default: void 0
    },
    /**
     * Name attribute of the radio input.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Value of the radio input.
     */
    value: {
      type: [String, Boolean, Number],
      required: !0
    },
    /**
     * Disables the radio input.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Displays the component as a block.
     * @default false
     */
    block: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Truncates the label.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsFormRadio#update:modelValue
     */
    "update:modelValue"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-form-radio-");
    },
    isChecked() {
      return this.modelValue === this.value;
    }
  },
  methods: {
    handleChange(e) {
      const i = e.target.value;
      this.$emit("update:modelValue", i);
    }
  }
}), En = ["id", "name", "value", "checked", "disabled", "readonly"], qn = ["for"], An = {
  key: 0,
  class: "sr-only"
};
function kn(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-form-radio dps-input-wrapper", { "dps-form-radio--block": e.block || e.truncate }])
  }, [
    M("input", {
      id: e.uniqueId,
      class: R(["dps-form-radio__input dps-radio", { "dps-radio--error": e.error }]),
      type: "radio",
      name: e.name,
      value: e.value,
      checked: e.isChecked,
      disabled: e.disabled || e.readonly,
      readonly: e.readonly,
      onChange: t[0] || (t[0] = (...n) => e.handleChange && e.handleChange(...n))
    }, null, 42, En),
    M("label", {
      for: e.uniqueId,
      class: R(["dps-form-radio__label dps-label", {
        "dps-form-radio__label--input-only": e.hideLabel,
        "dps-text--ellipse": e.truncate
      }])
    }, [
      e.hideLabel ? (k(), P("span", An, [
        $(e.$slots, "default")
      ])) : $(e.$slots, "default", { key: 1 })
    ], 10, qn)
  ], 2);
}
const Tn = /* @__PURE__ */ W(xn, [["render", kn]]), Dn = te({
  name: "DpsFormRadioGroup",
  components: {
    DpsFormRadio: Tn
  },
  props: {
    /**
     * The unique identifier for the radio group (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ModelValue of the radio group.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number],
      required: !1,
      default: void 0
    },
    /**
     * Name of the radio inputs.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Label for the radio group.
     * @default undefined
     */
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Array of options to be displayed.
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Which key to use for the option value.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: !1,
      default: "value"
    },
    /**
     * Which key to use for the option label.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: !1,
      default: "label"
    },
    /**
     * Whether the radio group should be disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether the radio inputs should be displayed in line.
     * @default false
     */
    inline: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether the labels should be truncated.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsFormRadioGroup#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    mappedOptions() {
      const e = [];
      return this.options.forEach((t) => {
        let i = {};
        typeof t != "object" ? (i[this.optionValue] = t, i[this.optionLabel] = t) : i = JSON.parse(JSON.stringify(t)), e.push(i);
      }), e;
    },
    uniqueId() {
      return this.id ? this.id : de("dps-form-radio-group-");
    }
  },
  watch: {
    modelValue(e) {
      this.selected = e;
    }
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleChange(e) {
      this.$emit("update:modelValue", e);
    },
    getLabelContent(e) {
      const t = e[this.optionLabel];
      return typeof t == "string" ? ou(t) : t.toString();
    }
  }
}), Cn = ["id"], On = { class: "dps-input-wrapper" }, Pn = ["innerHTML"];
function Ln(e, t, i, s, l, d) {
  const n = se("DpsFormRadio");
  return k(), P("fieldset", {
    id: e.uniqueId,
    class: R(["dps-form-radio-group", { "dps-form-radio-group--inline": e.inline }])
  }, [
    e.label ? (k(), P("legend", {
      key: 0,
      class: R(["dps-label", { "visually-hidden": e.hideLabel }])
    }, G(e.label), 3)) : U("", !0),
    M("div", On, [
      (k(!0), P(ae, null, we(e.mappedOptions, (f, h) => (k(), ie(n, {
        id: e.uniqueId + "-option-" + h,
        key: "option-" + h,
        name: e.name,
        value: f[e.optionValue],
        disabled: e.disabled || f.disabled,
        readonly: f.readonly,
        error: f.error,
        block: !e.inline,
        truncate: e.truncate,
        "model-value": e.selected,
        "onUpdate:modelValue": e.handleChange
      }, {
        default: z(() => [
          M("span", {
            innerHTML: e.getLabelContent(f)
          }, null, 8, Pn)
        ]),
        _: 2
      }, 1032, ["id", "name", "value", "disabled", "readonly", "error", "block", "truncate", "model-value", "onUpdate:modelValue"]))), 128))
    ])
  ], 10, Cn);
}
const Ja = /* @__PURE__ */ W(Dn, [["render", Ln]]);
function Jt(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function In(e) {
  return (...t) => !e(...t);
}
function Nn(e, t) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(t.trim()) !== -1;
}
function Mn(e) {
  return e.filter((t) => !t.$isLabel);
}
function Xt(e, t) {
  return (i) => i.reduce((s, l) => l[e] && l[e].length ? (s.push({
    $groupLabel: l[t],
    $isLabel: !0
  }), s.concat(l[e])) : s, []);
}
const wr = (...e) => (t) => e.reduce((i, s) => s(i), t);
var Bn = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, t) {
        return Jt(e) ? "" : t ? e[t] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", t = e.toLowerCase().trim();
      let i = this.options.concat();
      return this.internalSearch ? i = this.groupValues ? this.filterAndFlat(i, t, this.label) : this.filterOptions(i, t, this.label, this.customLabel) : i = this.groupValues ? Xt(this.groupValues, this.groupLabel)(i) : i, i = this.hideSelected ? i.filter(In(this.isSelected)) : i, this.taggable && t.length && !this.isExistingOption(t) && (this.tagPosition === "bottom" ? i.push({ isTag: !0, label: e }) : i.unshift({ isTag: !0, label: e })), i.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((t) => this.customLabel(t, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, t, i) {
      return wr(
        this.filterGroups(t, i, this.groupValues, this.groupLabel, this.customLabel),
        Xt(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return wr(
        Xt(this.groupValues, this.groupLabel),
        Mn
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const t = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(t) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (Jt(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const t = this.customLabel(e, this.label);
      return Jt(t) ? "" : t;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, t) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(t) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(t === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            t !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const t = this.options.find((i) => i[this.groupLabel] === e.$groupLabel);
      if (t) {
        if (this.wholeGroupSelected(t)) {
          this.$emit("remove", t[this.groupValues], this.id);
          const i = this.trackBy ? t[this.groupValues].map((l) => l[this.trackBy]) : t[this.groupValues], s = this.internalValue.filter(
            (l) => i.indexOf(this.trackBy ? l[this.trackBy] : l) === -1
          );
          this.$emit("update:modelValue", s);
        } else {
          const i = t[this.groupValues].filter(
            (s) => !(this.isOptionDisabled(s) || this.isSelected(s))
          );
          this.max && i.splice(this.max - this.internalValue.length), this.$emit("select", i, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(i)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (t) => this.isSelected(t) || this.isOptionDisabled(t)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, t = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const i = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const s = this.internalValue.slice(0, i).concat(this.internalValue.slice(i + 1));
        this.$emit("update:modelValue", s);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && t && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, t = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      t > this.maxHeight || t > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(t - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, t, i, s) {
      return t ? e.filter((l) => Nn(s(l, i), t)).sort((l, d) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(l, d) : s(l, i).length - s(d, i).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, t, i, s, l) {
      return (d) => d.map((n) => {
        if (!n[i])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const f = this.filterOptions(n[i], e, t, l);
        return f.length ? {
          [s]: n[s],
          [i]: f
        } : [];
      });
    }
  }
}, _n = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, t) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(t)
      };
    },
    groupHighlight(e, t) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": t.$isLabel }
        ];
      const i = this.options.find((s) => s[this.groupLabel] === t.$groupLabel);
      return i && !this.wholeGroupDisabled(i) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(i) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Mr = {
  name: "vue-multiselect",
  mixins: [Bn, _n],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  }
};
const $n = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], Rn = {
  ref: "tags",
  class: "multiselect__tags"
}, Vn = { class: "multiselect__tags-wrap" }, Fn = ["textContent"], jn = ["onKeypress", "onMousedown"], Un = ["textContent"], Hn = { class: "multiselect__spinner" }, zn = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], Gn = ["id", "aria-multiselectable"], Yn = { key: 0 }, Wn = { class: "multiselect__option" }, Kn = ["aria-selected", "id", "role"], Jn = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], Xn = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], Qn = { class: "multiselect__option" }, Zn = { class: "multiselect__option" };
function es(e, t, i, s, l, d) {
  return k(), P("div", {
    tabindex: e.searchable ? -1 : i.tabindex,
    class: R([{ "multiselect--active": e.isOpen, "multiselect--disabled": i.disabled, "multiselect--above": d.isAbove, "multiselect--has-options-group": d.hasOptionGroup }, "multiselect"]),
    onFocus: t[14] || (t[14] = (n) => e.activate()),
    onBlur: t[15] || (t[15] = (n) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      t[16] || (t[16] = he(ue((n) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      t[17] || (t[17] = he(ue((n) => e.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: t[18] || (t[18] = he(ue((n) => e.addPointerElement(n), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: t[19] || (t[19] = he((n) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    $(e.$slots, "caret", { toggle: e.toggle }, () => [
      M(
        "div",
        {
          onMousedown: t[0] || (t[0] = ue((n) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    $(e.$slots, "clear", { search: e.search }),
    M(
      "div",
      Rn,
      [
        $(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: d.visibleValues,
          isOpen: e.isOpen
        }, () => [
          _e(M(
            "div",
            Vn,
            [
              (k(!0), P(
                ae,
                null,
                we(d.visibleValues, (n, f) => $(e.$slots, "tag", {
                  option: n,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (k(), P(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: f,
                      onMousedown: t[1] || (t[1] = ue(() => {
                      }, ["prevent"]))
                    },
                    [
                      M("span", {
                        textContent: G(e.getOptionLabel(n))
                      }, null, 8, Fn),
                      M("i", {
                        tabindex: "1",
                        onKeypress: he(ue((h) => e.removeElement(n), ["prevent"]), ["enter"]),
                        onMousedown: ue((h) => e.removeElement(n), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, jn)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [$e, d.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > i.limit ? $(e.$slots, "limit", { key: 0 }, () => [
            M("strong", {
              class: "multiselect__strong",
              textContent: G(i.limitText(e.internalValue.length - i.limit))
            }, null, 8, Un)
          ]) : U("v-if", !0)
        ]),
        pe(cu, { name: "multiselect__loading" }, {
          default: z(() => [
            $(e.$slots, "loading", {}, () => [
              _e(M(
                "div",
                Hn,
                null,
                512
                /* NEED_PATCH */
              ), [
                [$e, i.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (k(), P("input", {
          key: 0,
          ref: "search",
          name: i.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: i.spellcheck,
          placeholder: e.placeholder,
          required: d.isRequired,
          style: ht(d.inputStyle),
          value: e.search,
          disabled: i.disabled,
          tabindex: i.tabindex,
          "aria-label": i.name + "-searchbox",
          onInput: t[2] || (t[2] = (n) => e.updateSearch(n.target.value)),
          onFocus: t[3] || (t[3] = ue((n) => e.activate(), ["prevent"])),
          onBlur: t[4] || (t[4] = ue((n) => e.deactivate(), ["prevent"])),
          onKeyup: t[5] || (t[5] = he((n) => e.deactivate(), ["esc"])),
          onKeydown: [
            t[6] || (t[6] = he(ue((n) => e.pointerForward(), ["prevent"]), ["down"])),
            t[7] || (t[7] = he(ue((n) => e.pointerBackward(), ["prevent"]), ["up"])),
            t[9] || (t[9] = he(ue((n) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          onKeypress: t[8] || (t[8] = he(ue((n) => e.addPointerElement(n), ["prevent", "stop", "self"]), ["enter"])),
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, zn)) : U("v-if", !0),
        d.isSingleLabelVisible ? (k(), P(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: t[10] || (t[10] = ue((...n) => e.toggle && e.toggle(...n), ["prevent"]))
          },
          [
            $(e.$slots, "singleLabel", { option: d.singleValue }, () => [
              Z(
                G(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : U("v-if", !0),
        d.isPlaceholderVisible ? (k(), P(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: t[11] || (t[11] = ue((...n) => e.toggle && e.toggle(...n), ["prevent"]))
          },
          [
            $(e.$slots, "placeholder", {}, () => [
              Z(
                G(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : U("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    pe(cu, {
      name: "multiselect",
      persisted: ""
    }, {
      default: z(() => [
        _e(M(
          "div",
          {
            class: "multiselect__content-wrapper",
            onFocus: t[12] || (t[12] = (...n) => e.activate && e.activate(...n)),
            tabindex: "-1",
            onMousedown: t[13] || (t[13] = ue(() => {
            }, ["prevent"])),
            style: ht({ maxHeight: e.optimizedHeight + "px" }),
            ref: "list"
          },
          [
            M("ul", {
              class: "multiselect__content",
              style: ht(d.contentStyle),
              role: "listbox",
              id: "listbox-" + e.id,
              "aria-multiselectable": e.multiple
            }, [
              $(e.$slots, "beforeList"),
              e.multiple && e.max === e.internalValue.length ? (k(), P("li", Yn, [
                M("span", Wn, [
                  $(e.$slots, "maxElements", {}, () => [
                    Z(
                      "Maximum of " + G(e.max) + " options selected. First remove a selected option to select another.",
                      1
                      /* TEXT */
                    )
                  ])
                ])
              ])) : U("v-if", !0),
              !e.max || e.internalValue.length < e.max ? (k(!0), P(
                ae,
                { key: 1 },
                we(e.filteredOptions, (n, f) => (k(), P("li", {
                  class: "multiselect__element",
                  key: f,
                  "aria-selected": e.isSelected(n),
                  id: e.id + "-" + f,
                  role: n && (n.$isLabel || n.$isDisabled) ? null : "option"
                }, [
                  n && (n.$isLabel || n.$isDisabled) ? U("v-if", !0) : (k(), P("span", {
                    key: 0,
                    class: R([e.optionHighlight(f, n), "multiselect__option"]),
                    onClick: ue((h) => e.select(n), ["stop"]),
                    onMouseenter: ue((h) => e.pointerSet(f), ["self"]),
                    "data-select": n && n.isTag ? e.tagPlaceholder : d.selectLabelText,
                    "data-selected": d.selectedLabelText,
                    "data-deselect": d.deselectLabelText
                  }, [
                    $(e.$slots, "option", {
                      option: n,
                      search: e.search,
                      index: f
                    }, () => [
                      M(
                        "span",
                        null,
                        G(e.getOptionLabel(n)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, Jn)),
                  n && (n.$isLabel || n.$isDisabled) ? (k(), P("span", {
                    key: 1,
                    "data-select": e.groupSelect && d.selectGroupLabelText,
                    "data-deselect": e.groupSelect && d.deselectGroupLabelText,
                    class: R([e.groupHighlight(f, n), "multiselect__option"]),
                    onMouseenter: ue((h) => e.groupSelect && e.pointerSet(f), ["self"]),
                    onMousedown: ue((h) => e.selectGroup(n), ["prevent"])
                  }, [
                    $(e.$slots, "option", {
                      option: n,
                      search: e.search,
                      index: f
                    }, () => [
                      M(
                        "span",
                        null,
                        G(e.getOptionLabel(n)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, Xn)) : U("v-if", !0)
                ], 8, Kn))),
                128
                /* KEYED_FRAGMENT */
              )) : U("v-if", !0),
              _e(M(
                "li",
                null,
                [
                  M("span", Qn, [
                    $(e.$slots, "noResult", { search: e.search }, () => [
                      t[20] || (t[20] = Z("No elements found. Consider changing the search query."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [$e, i.showNoResults && e.filteredOptions.length === 0 && e.search && !i.loading]
              ]),
              _e(M(
                "li",
                null,
                [
                  M("span", Zn, [
                    $(e.$slots, "noOptions", {}, () => [
                      t[21] || (t[21] = Z("List is empty."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [$e, i.showNoOptions && (e.options.length === 0 || d.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !i.loading]
              ]),
              $(e.$slots, "afterList")
            ], 12, Gn)
          ],
          36
          /* STYLE, NEED_HYDRATION */
        ), [
          [$e, e.isOpen]
        ])
      ]),
      _: 3
      /* FORWARDED */
    })
  ], 42, $n);
}
Mr.render = es;
const ts = te({
  name: "DpsFormSelect",
  components: { DpsFilterButton: qi, Multiselect: Mr },
  props: {
    /**
     * Unique ID of the select (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Size of the select.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Style variant of the select.
     * @default undefined
     */
    variant: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Hides tags for selected elements (only for multiple).
     * @default false
     */
    hideTags: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * ModelValue for the select.
     * @default undefined
     */
    modelValue: {
      type: [String, Number, Array, Object],
      required: !1,
      default: void 0
    },
    /**
     * Key for the label text in the option object.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: !1,
      default: "label"
    },
    /**
     * Key for the value in the option object.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: !1,
      default: "value"
    },
    /**
     * Makes the select readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Requires a value to be selected.
     * @default false
     */
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Title attribute of the select.
     * @default props.placeholder
     */
    title: {
      type: String,
      required: !1,
      default(e) {
        return e.placeholder;
      }
    },
    /**
     * Label for the select.
     * @default undefined
     */
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Icon placed before the select in the simple variant.
     * @default undefined
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Success state of the select.
     * @default false
     */
    success: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Error state of the select.
     * @default false
     */
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Aligns the dropdown left or right.
     * @default "start"
     */
    align: {
      type: String,
      required: !1,
      default: "start"
    },
    // -----------------------
    // Vue-Multiselect
    // -----------------------
    /**
     * Array of available options: Objects, Strings or Integers. If array of objects, visible label will default to option.label.
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Clear the search input after `select()`. Use only when multiple is true.
     * @default true
     */
    clearOnSelect: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     */
    closeOnSelect: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Enable/disable the multiselect.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Number of allowed selected options.
     * @default undefined
     */
    max: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * Equivalent to the multiple attribute on a `<select>` input.
     * @default false
     */
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Fixed opening direction (instead of auto). Options are "above"/"top" or "below"/"bottom"
     * @default ""
     */
    openDirection: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Equivalent to the placeholder attribute on a `<select>` input.
     * @default "Bitte wählen"
     */
    placeholder: {
      type: String,
      required: !1,
      default: "Bitte wählen"
    },
    /**
     * Selects the first option if initial value is empty
     * @default false
     */
    preselectFirst: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * If set to true, will preserve the search query when opening/closing the component.
     * @default false
     */
    preserveSearch: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Add / removes search input.
     * @default false
     */
    searchable: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when a value gets selected.
     */
    "select",
    /**
     * Emitted after removing an option.
     */
    "remove",
    /**
     * Emitted after the search query changes.
     */
    "search-change",
    /**
     * Emitted after user attempts to add a tag.
     */
    "tag",
    /**
     * Emitted when the dropdown opens. Useful for detecting when touched.
     */
    "open",
    /**
     * Emitted when the dropdown closes.
     */
    "close",
    /**
     * Emitted after this.modelValue changes.
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0,
      multiselectEl: null,
      isDropdownOpen: !1
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-form-select-");
    },
    multiselectOptions() {
      const e = [];
      for (const t of this.options)
        if (typeof t != "object") {
          const i = {};
          i[this.optionValue] = t, i[this.optionLabel] = t, e.push(i);
        } else
          e.push(t);
      return e;
    }
  },
  watch: {
    modelValue(e) {
      this.selected = e;
    },
    selected(e, t) {
      JSON.stringify(e) !== JSON.stringify(t) && this.$emit("update:modelValue", e);
    }
  },
  mounted() {
    const e = this.$refs.multiselect;
    this.multiselectEl = e == null ? void 0 : e.$el, this.improveMultiselectAccessibility(), this.improveElementAccessibility(), this.improveContentAccessibility();
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleMouseDown(e) {
      const t = this.multiselectEl, i = t.querySelector(".multiselect__content"), s = t.querySelector(".multiselect__input"), l = e.target, d = this.isDropdownOpen, n = this.$refs.multiselect;
      if (!(s && s.contains(l)) && !(i && i.contains(l)) && t.contains(l)) {
        e.preventDefault(), e.stopImmediatePropagation(), d ? (n.deactivate(), this.isDropdownOpen = !1) : (n.activate(), this.isDropdownOpen = !0);
        return;
      }
    },
    improveMultiselectAccessibility() {
      var e, t;
      (e = this.multiselectEl) == null || e.setAttribute("aria-expanded", "false"), (t = this.multiselectEl) == null || t.setAttribute("aria-controls", "listbox-" + this.uniqueId);
    },
    improveContentAccessibility() {
      var t;
      const e = (t = this.multiselectEl) == null ? void 0 : t.querySelector(".multiselect__content");
      e && (e.ariaLabel = "Auswahlliste");
    },
    improveElementAccessibility() {
      var s, l, d;
      const e = (s = this.multiselectEl) == null ? void 0 : s.querySelectorAll(".multiselect__option");
      if (e)
        for (const n of Array.from(e)) {
          const f = n.parentElement;
          f != null && f.classList.contains("multiselect__element") && (n.classList.contains("multiselect__option--selected") ? f.ariaSelected = "true" : f.ariaSelected = "false");
        }
      const t = (l = this.multiselectEl) == null ? void 0 : l.querySelectorAll(
        ".multiselect__content > li:not(.multiselect__element)"
      );
      if (t)
        for (const n of Array.from(t))
          n.role = "option";
      const i = (d = this.multiselectEl) == null ? void 0 : d.querySelector(
        ".multiselect__input"
      );
      i && (i.placeholder = "Suchbegriff ...");
    },
    handleSelect(e) {
      this.$emit("select", e), this.$nextTick(() => {
        this.improveElementAccessibility();
      });
    },
    handleRemove(e) {
      this.$emit("remove", e), this.$nextTick(() => {
        this.improveElementAccessibility();
      });
    },
    handleOpen(e) {
      var t;
      this.isDropdownOpen = !0, this.$emit("open", e), (t = this.multiselectEl) == null || t.setAttribute("aria-expanded", "true"), this.$nextTick(() => {
        this.setSearchInputWidth();
      });
    },
    handleClose(e) {
      var t;
      this.isDropdownOpen = !1, this.$emit("close", e), (t = this.multiselectEl) == null || t.setAttribute("aria-expanded", "false");
    },
    handleTag(e) {
      this.$emit("tag", e);
    },
    handleSearchChange(e) {
      this.$emit("search-change", e);
    },
    setSearchInputWidth() {
      var s, l;
      const t = (s = this.multiselectEl) == null ? void 0 : s.querySelector(
        ".multiselect__input"
      ), i = (l = this.multiselectEl) == null ? void 0 : l.querySelector(
        ".multiselect__content"
      );
      if (t && i) {
        const d = i.offsetWidth;
        t.style.setProperty("--width", d - 12 + "px");
      }
    }
  }
}), us = {
  key: 0,
  class: "multiselect__option-checkbox"
}, rs = { class: "multiselect__option-label" }, is = {
  key: 2,
  class: "multiselect__option-checkbox"
}, ns = {
  key: 0,
  class: "multiselect__single multiselect__single--label"
}, ss = {
  key: 1,
  class: "multiselect__placeholder multiselect__placeholder--label"
}, as = {
  key: 1,
  class: "multiselect__tags-wrap"
}, ls = {
  key: 1,
  class: "multiselect__single multiselect__single--label"
}, os = {
  key: 2,
  class: "multiselect__placeholder multiselect__placeholder--label"
}, ds = {
  key: 3,
  class: "multiselect__placeholder multiselect__placeholder--label"
}, cs = { class: "multiselect__option-results" }, fs = { class: "multiselect__option-results" }, hs = { class: "multiselect__option-results" };
function ps(e, t, i, s, l, d) {
  const n = se("DpsFilterButton"), f = se("Multiselect");
  return k(), ie(f, {
    id: e.uniqueId,
    ref: "multiselect",
    modelValue: e.selected,
    "onUpdate:modelValue": t[0] || (t[0] = (h) => e.selected = h),
    class: R(["dps-form-select", {
      "dps-form-select--readonly": e.readonly,
      "dps-form-select--multiple": e.multiple,
      "dps-form-select--searchable": e.searchable,
      "dps-form-select--labelled": e.label,
      "dps-form-select--filter": e.variant === "filter",
      "dps-form-select--simple": e.variant === "simple",
      "dps-form-select--size-sm": e.size === "sm",
      "dps-form-select--success": e.success,
      "dps-form-select--error": e.error,
      "dps-form-select--align-end": e.align === "end"
    }]),
    options: e.multiselectOptions,
    "allow-empty": !e.required,
    "clear-on-select": e.clearOnSelect,
    "close-on-select": e.closeOnSelect,
    disabled: e.disabled || e.readonly,
    label: e.optionLabel,
    max: e.max,
    multiple: e.multiple,
    "open-direction": e.openDirection,
    placeholder: e.placeholder,
    "preselect-first": e.preselectFirst,
    "preserve-search": e.preserveSearch,
    searchable: e.searchable,
    "track-by": e.optionValue,
    title: e.title,
    onMousedownCapture: e.handleMouseDown,
    onClose: e.handleClose,
    onOpen: e.handleOpen,
    onRemove: e.handleRemove,
    onSearchChange: e.handleSearchChange,
    onSelect: e.handleSelect,
    onTag: e.handleTag
  }, eu({
    option: z((h) => [
      e.multiple ? (k(), P("span", us, t[1] || (t[1] = [
        M("span", { class: "dps-icon dps-icon--success" }, null, -1)
      ]))) : U("", !0),
      h.option.icon ? (k(), P("span", {
        key: 1,
        class: R(["multiselect__option-icon dps-icon", "dps-icon--" + h.option.icon])
      }, null, 2)) : U("", !0),
      M("span", rs, [
        $(e.$slots, "option", Ue(He(h)), () => [
          Z(G(h.option[e.optionLabel]), 1)
        ])
      ]),
      e.multiple ? U("", !0) : (k(), P("span", is, t[2] || (t[2] = [
        M("span", { class: "dps-icon dps-icon--success" }, null, -1)
      ])))
    ]),
    tag: z((h) => [
      pe(n, {
        disabled: e.disabled,
        readonly: e.readonly,
        onClick: (a) => h.remove(h.option)
      }, {
        default: z(() => [
          $(e.$slots, "tag", Ue(He(h)), () => [
            Z(G(h.option[e.optionLabel]), 1)
          ])
        ]),
        _: 2
      }, 1032, ["disabled", "readonly", "onClick"])
    ]),
    noOptions: z(() => [
      M("span", cs, [
        $(e.$slots, "noOptions", {}, () => [
          t[3] || (t[3] = Z("Keine Elemente"))
        ])
      ])
    ]),
    noResult: z(() => [
      M("span", fs, [
        $(e.$slots, "noResult", {}, () => [
          t[4] || (t[4] = Z(" Es wurden keine Elemente gefunden. "))
        ])
      ])
    ]),
    maxElements: z(() => [
      M("span", hs, [
        $(e.$slots, "maxElements", {}, () => [
          t[5] || (t[5] = Z(" Maximale Anzahl von Elementen erreicht. Bitte zuerst ein Element abwählen bevor Sie eine erneute Auswahl treffen. "))
        ])
      ])
    ]),
    _: 2
  }, [
    e.multiple ? {
      name: "selection",
      fn: z((h) => [
        h.values.length === 0 || e.hideTags ? (k(), P(ae, { key: 0 }, [
          e.label ? (k(), P("div", ns, G(e.label), 1)) : (k(), P("div", ss, [
            $(e.$slots, "selection", Ue(He(h)), () => [
              Z(G(e.placeholder), 1)
            ])
          ]))
        ], 64)) : (k(), P("div", as, [
          (k(!0), P(ae, null, we(h.values, (a, o) => (k(), ie(n, {
            key: "option-" + o,
            disabled: e.disabled,
            readonly: e.readonly,
            onClick: (m) => h.remove(a)
          }, {
            default: z(() => [
              $(e.$slots, "selection", Zt({ ref_for: !0 }, h, { option: a }), () => [
                Z(G(a[e.optionLabel]), 1)
              ])
            ]),
            _: 2
          }, 1032, ["disabled", "readonly", "onClick"]))), 128))
        ]))
      ]),
      key: "0"
    } : {
      name: "selection",
      fn: z((h) => [
        e.variant === "simple" && e.icon ? (k(), P("span", {
          key: 0,
          class: R(["dps-icon dps-icon--" + e.icon])
        }, null, 2)) : U("", !0),
        e.label ? (k(), P("div", ls, G(e.label), 1)) : U("", !0),
        e.modelValue && typeof e.modelValue == "object" && !Array.isArray(e.modelValue) && e.modelValue[e.optionLabel] ? (k(), P("div", os, [
          $(e.$slots, "selection", Ue(He(h)), () => [
            Z(G(e.modelValue[e.optionLabel]), 1)
          ])
        ])) : (k(), P("div", ds, [
          $(e.$slots, "selection", Ue(He(h)), () => [
            Z(G(e.placeholder), 1)
          ])
        ]))
      ]),
      key: "1"
    },
    e.$slots.beforeList ? {
      name: "beforeList",
      fn: z(() => [
        $(e.$slots, "beforeList")
      ]),
      key: "2"
    } : void 0,
    e.$slots.afterList ? {
      name: "afterList",
      fn: z(() => [
        $(e.$slots, "afterList")
      ]),
      key: "3"
    } : void 0
  ]), 1032, ["id", "modelValue", "class", "options", "allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "max", "multiple", "open-direction", "placeholder", "preselect-first", "preserve-search", "searchable", "track-by", "title", "onMousedownCapture", "onClose", "onOpen", "onRemove", "onSearchChange", "onSelect", "onTag"]);
}
const Br = /* @__PURE__ */ W(ts, [["render", ps]]), bs = te({
  name: "DpsFormTextarea",
  props: {
    /**
     * ModelValue of the textarea.
     * @default undefined
     */
    modelValue: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Sets whether the textarea is resizable, and if so, in which directions.
     * @default false
     */
    resizable: {
      type: [Boolean, String],
      required: !1,
      default: !1
    },
    /**
     * Success state of the textarea.
     * @default false
     */
    success: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Error state of the textarea.
     * @default false
     */
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The number of visible text lines.
     * @default 3
     */
    rows: {
      type: Number,
      required: !1,
      default: 3
    },
    /**
     * Makes the textarea readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Disables the textarea.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     */
    "update:modelValue"
  ],
  watch: {
    modelValue() {
      this.$nextTick(() => {
        this.resizable === "auto" && this.resize();
      });
    }
  },
  mounted() {
    this.resizable === "auto" && this.resize();
  },
  methods: {
    handleInput(e) {
      const i = e.target.value;
      this.$emit("update:modelValue", i), this.resizable === "auto" && this.$nextTick(this.resize);
    },
    /**
     * Resize the textarea to fit its content when in `auto` mode.
     */
    resize() {
      if (this.$refs.textarea) {
        const e = this.$refs.textarea;
        e.style.height = "auto", e.style.height = e.scrollHeight + "px";
      }
    }
  }
}), ms = ["value", "rows", "readonly", "disabled"];
function gs(e, t, i, s, l, d) {
  return k(), P("textarea", {
    ref: "textarea",
    class: R(["dps-form-textarea dps-textarea", {
      "dps-form-textarea--resize": e.resizable === !0,
      "dps-form-textarea--resize-v": e.resizable === "vertical",
      "dps-form-textarea--resize-h": e.resizable === "horizontal",
      "dps-form-textarea--resize-a": e.resizable === "auto",
      "dps-form-textarea--success": e.success,
      "dps-form-textarea--error": e.error
    }]),
    value: e.modelValue,
    rows: e.rows,
    readonly: e.readonly,
    disabled: e.disabled,
    onInput: t[0] || (t[0] = (...n) => e.handleInput && e.handleInput(...n))
  }, null, 42, ms);
}
const Xa = /* @__PURE__ */ W(bs, [["render", gs]]), ys = te({
  name: "DpsLink",
  props: {
    /**
     * The URL that the hyperlink points to.
     */
    href: {
      type: String,
      required: !0
    },
    /**
     * Icon to be displayed in front of the link text.
     * Can be set to 'false' when using external links to
     * hide the icon.
     * @default undefined
     */
    icon: {
      type: [String, Boolean],
      required: !1,
      default: void 0
    },
    /**
     * The relationship of the linked URL as space-separated
     * link types. "noopener noreferrer" gets set automatically
     * when "external" is true.
     * @default undefined
     */
    rel: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Where to display the linked URL,
     * as the name for a browsing context.
     * Gets set to "_blank" automatically when "external" is true.
     * @default undefined
     */
    target: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the link is an external link.
     * @default false
     */
    external: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * How to format the link (telephone or email formatting).
     * @default undefined
     */
    format: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether the link should be a slightly darker blue.
     * @default false
     */
    darker: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the link is clicked.
     */
    "click"
  ],
  computed: {
    hrefAttribute() {
      return this.format === "telephone" ? "tel:" + this.href.replaceAll(" ", "").replaceAll("-", "").replaceAll("/", "").replaceAll("(", "").replaceAll(")", "") : this.format === "email" ? "mailto:" + this.href.replaceAll(" ", "") : this.href;
    },
    relAttribute() {
      if (this.rel)
        return this.rel;
      if (this.external)
        return "noopener noreferrer";
    },
    targetAttribute() {
      if (this.target)
        return this.target;
      if (this.external)
        return "_blank";
    },
    iconName() {
      if (this.icon !== !1) {
        if (this.icon && typeof this.icon == "string")
          return this.icon;
        if (this.external)
          return "external-link";
      }
    }
  }
}), vs = ["href", "rel", "target"];
function ws(e, t, i, s, l, d) {
  return k(), P("a", {
    class: R(["dps-link", {
      "dps-link--icon": e.iconName,
      "dps-link--darker": e.darker
    }]),
    href: e.hrefAttribute,
    rel: e.relAttribute,
    target: e.targetAttribute,
    onClick: t[0] || (t[0] = (n) => e.$emit("click", n))
  }, [
    e.iconName ? (k(), P(ae, { key: 0 }, [
      M("span", {
        class: R(["dps-icon", "dps-icon--" + e.iconName])
      }, null, 2),
      M("span", null, [
        $(e.$slots, "default")
      ])
    ], 64)) : $(e.$slots, "default", { key: 1 })
  ], 10, vs);
}
const Qa = /* @__PURE__ */ W(ys, [["render", ws]]), Ss = te({
  name: "DpsSortSelect",
  components: { DpsFormSelect: Br },
  props: {
    /**
     * Unique ID of the select (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Array of options to be displayed.
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * ModelValue of the select.
     */
    modelValue: {
      type: String,
      required: !0
    },
    /**
     * Title attribute of the select.
     * @default "Sortierung anpassen"
     */
    title: {
      type: String,
      default: "Sortierung anpassen",
      required: !1
    },
    /**
     * Disables the select.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-sort-select-");
    }
  },
  watch: {
    modelValue() {
      this.setSelectedOption();
    }
  },
  created() {
    this.setSelectedOption();
  },
  methods: {
    setSelectedOption() {
      let e = this.options[0];
      for (const t of this.options)
        t.value === this.modelValue && (e = t);
      this.selected = e;
    },
    handleChange(e) {
      this.$emit("update:modelValue", e.value);
    }
  }
});
function xs(e, t, i, s, l, d) {
  const n = se("DpsFormSelect");
  return k(), ie(n, {
    id: e.uniqueId,
    class: R(["dps-sort-select", { "dps-sort-select--disabled": e.disabled }]),
    "model-value": e.selected,
    options: e.options,
    disabled: e.disabled,
    title: e.title,
    required: "",
    "onUpdate:modelValue": e.handleChange
  }, null, 8, ["id", "class", "model-value", "options", "disabled", "title", "onUpdate:modelValue"]);
}
const Za = /* @__PURE__ */ W(Ss, [["render", xs]]), Es = te({
  name: "DpsAlert",
  props: {
    /**
     * The variant determines the color and icon of the alert.
     * @default undefined
     */
    variant: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Headline of the alert.
     * @default undefined
     */
    heading: {
      type: String,
      default: void 0,
      required: !1
    },
    /**
     * Hides the icon.
     * @default false
     */
    hideIcon: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  computed: {
    variantIcon() {
      return {
        info: "feedback-info",
        warning: "error",
        success: "feedback-success",
        error: "error"
      }[this.variant ?? "info"];
    }
  },
  methods: {
    sanitizeHtml: ou
  }
}), qs = {
  key: 0,
  class: "dps-alert__icon-wrapper"
}, As = { class: "dps-alert__content-wrapper" }, ks = ["innerHTML"];
function Ts(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-alert", { ["dps-alert--" + e.variant]: e.variant }])
  }, [
    e.hideIcon ? U("", !0) : (k(), P("div", qs, [
      M("span", {
        class: R(["dps-icon", "dps-icon--" + e.variantIcon])
      }, null, 2)
    ])),
    M("div", As, [
      e.heading ? (k(), P("header", {
        key: 0,
        class: "dps-alert__content-header",
        innerHTML: e.sanitizeHtml(e.heading)
      }, null, 8, ks)) : U("", !0),
      $(e.$slots, "default")
    ])
  ], 2);
}
const Ds = /* @__PURE__ */ W(Es, [["render", Ts]]), Cs = te({
  name: "DpsInputGroup",
  props: {
    /**
     * Whether there should be no gap between the
     * elements.
     */
    collapsed: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
}), Os = {
  key: 0,
  class: "dps-input-group__content dps-input-group__content--prepend"
}, Ps = { class: "dps-input-group__content dps-input-group__content--default" }, Ls = {
  key: 1,
  class: "dps-input-group__content dps-input-group__content--append"
};
function Is(e, t, i, s, l, d) {
  return k(), P("div", {
    role: "group",
    class: R(["dps-input-group", { "dps-input-group--collapsed": e.collapsed }])
  }, [
    e.$slots.prepend ? (k(), P("div", Os, [
      $(e.$slots, "prepend")
    ])) : U("", !0),
    M("div", Ps, [
      $(e.$slots, "default")
    ]),
    e.$slots.append ? (k(), P("div", Ls, [
      $(e.$slots, "append")
    ])) : U("", !0)
  ], 2);
}
const Ns = /* @__PURE__ */ W(Cs, [["render", Is]]), Ms = te({
  name: "DpsFormFile",
  props: {
    /**
     * The unique identifier for the input (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ModelValue of the input.
     * With inputs of type file, normally this is uni-directional.
     * However, you can clear the file input's selected files by setting the modelValue to either null
     * (for single mode) or an empty array [] (for multiple mode).
     * @default null
     */
    modelValue: {
      type: [File, Array, null],
      required: !1,
      default: null
    },
    /**
     * Which file formats to accept.
     * Can be either file extension or mime-type or mixed
     * e.g. '.pdf', 'application/pdf' or '.pdf, application/pdf'
     * @default ""
     */
    accept: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Allows selecting multiple files at once.
     * @default false
     */
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Title for the search button.
     * Defaults to "Datei auswählen" if no title is set.
     * @default undefined
     */
    title: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Changes the state to error.
     * @default false
     */
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Required attribute of the input.
     * @default false
     */
    required: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the file selection changes.
     * @event module:DpsFormFile#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      uniqID: this.id ?? de("dps-form-file-")
    };
  },
  computed: {
    fileSearchTitle() {
      return this.title ?? `Datei${this.multiple ? "en" : ""} auswählen`;
    }
  },
  watch: {
    modelValue: {
      handler(e) {
        (!e || this.multiple && !e.length) && (this.$refs.fileInput.value = "");
      }
    }
  },
  methods: {
    getUniqueId: de,
    handleSelectionChange() {
      const e = this.$refs.fileInput.files;
      e.length === 0 ? this.$emit("update:modelValue", this.multiple ? [] : null) : this.$emit("update:modelValue", this.multiple ? Array.from(e) : e[0]);
    },
    resetSelection() {
      this.$refs.fileInput.value = "", this.$emit("update:modelValue", this.multiple ? [] : null);
    }
  }
}), Bs = ["for", "title"], _s = { class: "sr-only" }, $s = ["id", "accept", "required", "multiple", "disabled"];
function Rs(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-form-file", {
      "dps-form-file--selected": e.multiple && Array.isArray(e.modelValue) ? e.modelValue.length : e.modelValue,
      "dps-form-file--disabled": e.disabled,
      "dps-form-file--error": e.error
    }])
  }, [
    M("label", {
      for: e.uniqID,
      title: e.fileSearchTitle
    }, [
      t[3] || (t[3] = M("span", {
        class: "dps-icon dps-icon--search",
        "aria-hidden": "true"
      }, null, -1)),
      M("span", _s, G(e.fileSearchTitle), 1)
    ], 8, Bs),
    M("input", {
      id: e.uniqID,
      ref: "fileInput",
      type: "file",
      class: "dps-form-file__input",
      accept: e.accept,
      required: e.required,
      multiple: e.multiple ? !0 : void 0,
      disabled: e.disabled,
      onChange: t[0] || (t[0] = (...n) => e.handleSelectionChange && e.handleSelectionChange(...n)),
      onCancel: t[1] || (t[1] = (...n) => e.resetSelection && e.resetSelection(...n)),
      onClick: t[2] || (t[2] = (n) => n.target.value = "")
    }, null, 40, $s)
  ], 2);
}
const Vs = /* @__PURE__ */ W(Ms, [["render", Rs]]), Fs = {
  name: "DpsPagination",
  components: {
    DpsFormGroup: Nr,
    DpsButton: it,
    DpsFormSelect: Br
  },
  props: {
    /**
     * Total Number of Elements
     * @required
     */
    numberOfElements: {
      type: Number,
      required: !0
    },
    /**
     * Label of pagination menu for accessibilty ("aria-label")
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of the HTML element the pagination is controlling for accessibility ("aria-controls")
     * @default undefined
     */
    ariaContentId: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Configure select options for "elements per page"
     * @default [25, 50, 100]
     */
    elementsPerPageOptions: {
      type: Array,
      required: !1,
      default() {
        return [25, 50, 100];
      }
    },
    /**
     * Configure maximum number of page buttons in pagination
     * @default 5
     */
    numberOfPageNumbers: {
      type: Number,
      required: !1,
      default: 5
    },
    /**
     * Set number of pages as prop if the calculation should not be handled automatically (e.g. for serverside pagination). A note for migration: Was "pagesFromServer"
     * @default null
     */
    numberOfPagesAsProp: {
      type: Number,
      required: !1,
      default: null
    },
    /**
     * Set current page as prop (e.g. for serverside pagination)
     * @default null
     */
    currentPageAsProp: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * Set default option for "elements per page". If not set the first option will be selected. This is useful e.g. when resetting the page size to default on removing filters.
     */
    elementsPerPageAsProp: {
      type: Number,
      required: !1,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the pagination is updated
     * @event module:DpsPagination#shownElements
     */
    "updatePagination"
    // TODO fix naming
  ],
  data() {
    return {
      elementsPerPage: this.elementsPerPageAsProp ? {
        value: this.elementsPerPageAsProp,
        label: this.elementsPerPageAsProp
      } : {
        value: this.elementsPerPageOptions[0],
        label: this.elementsPerPageOptions[0]
      },
      currentPage: this.currentPageAsProp ?? 1,
      paginationButtons: []
    };
  },
  computed: {
    uniqueId() {
      return de("dps-pagination-");
    },
    /**
     * Number of Pages
     * @return {number}
     */
    numberOfPages() {
      return this.numberOfPagesAsProp ?? Math.ceil(this.numberOfElements / this.elementsPerPage.value);
    },
    /**
     * calculates Page Numbers to be shown on the buttons,
     * shows all if numberOfPages is smaller than numberOfPageNumbers
     * @return {number|*[]}
     */
    shownPageNumbers() {
      if (this.numberOfPages <= this.numberOfPageNumbers)
        return this.numberOfPages;
      {
        let e = Math.ceil(this.numberOfPageNumbers / 2);
        const t = Math.floor(this.numberOfPageNumbers / 2), i = [];
        for (let s = -t; s < e; s++)
          this.currentPage + s > 0 && this.currentPage + s <= this.numberOfPages ? i.push(this.currentPage + s) : this.currentPage + e <= this.numberOfPages && e++;
        return i;
      }
    },
    /**
     * calculates which elements will be shown on the current page
     * @return {object} {elementsPerPage: default.elementsPerPageAsProp, start: (number|number), end: number, currentPage: number}
     */
    shownElements() {
      const t = (this.currentPage - 1) * this.elementsPerPage.value ?? 0, i = t + this.elementsPerPage.value < this.numberOfElements ? t + this.elementsPerPage.value - 1 : this.numberOfElements - 1;
      return {
        start: t,
        end: i,
        elementsPerPage: this.elementsPerPage.value,
        currentPage: this.currentPage
      };
    }
  },
  watch: {
    elementsPerPage() {
      this.currentPage = 1, this.$emit("updatePagination", this.shownElements);
    },
    currentPage() {
      this.$nextTick(() => {
        this.updatePaginationButtons(), this.paginationButtons.forEach((e) => {
          e.removeEventListener("keydown", this.onPageButtonKeydown), e.addEventListener("keydown", this.onPageButtonKeydown);
        });
      });
    },
    currentPageAsProp() {
      this.currentPageAsProp && (this.currentPage = this.currentPageAsProp, this.$emit("updatePagination", this.shownElements));
    }
  },
  async mounted() {
    this.updatePaginationButtons(), this.paginationButtons.forEach((e) => {
      e.addEventListener("keydown", this.onPageButtonKeydown);
    });
  },
  beforeUnmount() {
    this.paginationButtons.forEach((e) => {
      e.removeEventListener("keydown", this.onPageButtonKeydown);
    });
  },
  methods: {
    onPageButtonKeydown(e) {
      const { key: t, currentTarget: i } = e;
      let s = this.paginationButtons.indexOf(i), l;
      switch (t) {
        case "Left":
        case "ArrowLeft":
          s = s > 0 ? s - 1 : this.paginationButtons.length - 1, l = this.paginationButtons[s], this.setFocusToPaginationItem(l);
          break;
        case "Right":
        case "ArrowRight":
          s = s < this.paginationButtons.length - 1 ? s + 1 : 0, l = this.paginationButtons[s], this.setFocusToPaginationItem(l);
          break;
        case " ":
        case "Enter":
          i.click();
          break;
      }
    },
    isPrintableCharacter(e) {
      return e.length === 1 && e.match(/\S/);
    },
    updatePaginationButtons() {
      this.paginationButtons = this.$refs.paginationMenu ? Array.from(this.$refs.paginationMenu.getElementsByTagName("button")).filter(
        (e) => !e.disabled
      ) : [];
    },
    setFocusToPaginationItem(e) {
      this.paginationButtons.forEach((t) => {
        t.tabIndex = -1;
      }), e.tabIndex = 0, e.focus();
    },
    /**
     * updates value of current page
     * @param {Number|String} page number of page or inc/dec
     * @return void
     */
    updatePage(e) {
      e === "inc" ? this.currentPage < this.numberOfPages && this.currentPage++ : e === "dec" ? this.currentPage > 1 && this.currentPage-- : this.currentPage = e, this.$emit("updatePagination", this.shownElements);
    }
  }
}, js = { class: "dps-pagination" }, Us = ["aria-label"], Hs = { role: "presentation" }, zs = { role: "presentation" }, Gs = { role: "presentation" }, Ys = { role: "presentation" }, Ws = { class: "dps-pagination__select-container" };
function Ks(e, t, i, s, l, d) {
  const n = se("DpsButton"), f = se("DpsFormSelect"), h = se("DpsFormGroup");
  return k(), P("div", js, [
    M("ul", {
      ref: "paginationMenu",
      role: "menubar",
      "aria-label": i.ariaLabel ?? "Paginierung",
      class: "dps-pagination__buttons"
    }, [
      M("li", Hs, [
        pe(n, {
          role: "menuitem",
          "aria-controls": i.ariaContentId,
          title: "erste Seite",
          "aria-label": "erste Seite",
          "aria-disabled": l.currentPage === 1 || d.numberOfPages === 0,
          disabled: l.currentPage === 1 || d.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-left-double-small",
          squared: "",
          size: "lg",
          onClick: t[0] || (t[0] = (a) => d.updatePage(1))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      M("li", zs, [
        pe(n, {
          role: "menuitem",
          "aria-controls": i.ariaContentId,
          title: "Seite zurück",
          "aria-label": "Seite zurück",
          "aria-disabled": l.currentPage === 1 || d.numberOfPages === 0,
          disabled: l.currentPage === 1 || d.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-left-small",
          squared: "",
          size: "lg",
          onClick: t[1] || (t[1] = (a) => d.updatePage("dec"))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      (k(!0), P(ae, null, we(d.shownPageNumbers, (a) => (k(), P("li", {
        key: a,
        ref_for: !0,
        ref: "paginationItem",
        role: "presentation"
      }, [
        pe(n, {
          role: "menuitemradio",
          "aria-controls": i.ariaContentId,
          title: `Seite ${a}`,
          "aria-label": `Seite ${a}`,
          "aria-checked": a === l.currentPage,
          "aria-posinset": a,
          "aria-setsize": d.numberOfPages,
          tabindex: a === l.currentPage ? "0" : "-1",
          class: R(a === l.currentPage ? "active" : ""),
          variant: "secondary",
          squared: "",
          size: "lg",
          onClick: (o) => d.updatePage(a)
        }, {
          default: z(() => [
            Z(G(a), 1)
          ]),
          _: 2
        }, 1032, ["aria-controls", "title", "aria-label", "aria-checked", "aria-posinset", "aria-setsize", "tabindex", "class", "onClick"])
      ]))), 128)),
      M("li", Gs, [
        pe(n, {
          role: "menuitem",
          "aria-controls": i.ariaContentId,
          title: "nächste Seite",
          "aria-label": "nächste Seite",
          "aria-disabled": l.currentPage === d.numberOfPages || d.numberOfPages === 0,
          disabled: l.currentPage === d.numberOfPages || d.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-right-small",
          squared: "",
          size: "lg",
          onClick: t[2] || (t[2] = (a) => d.updatePage("inc"))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      M("li", Ys, [
        pe(n, {
          role: "menuitem",
          "aria-controls": i.ariaContentId,
          title: "letzte Seite",
          "aria-label": "letzte Seite",
          "aria-disabled": l.currentPage === d.numberOfPages || d.numberOfPages === 0,
          disabled: l.currentPage === d.numberOfPages || d.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-right-double-small",
          squared: "",
          size: "lg",
          onClick: t[3] || (t[3] = (a) => d.updatePage(d.numberOfPages))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ])
    ], 8, Us),
    M("div", Ws, [
      pe(h, {
        label: "Treffer pro Seite",
        "label-for": "pagination-select-" + d.uniqueId
      }, {
        default: z(() => [
          pe(f, {
            id: "pagination-select-" + d.uniqueId,
            modelValue: l.elementsPerPage,
            "onUpdate:modelValue": t[4] || (t[4] = (a) => l.elementsPerPage = a),
            "aria-label": "Treffer pro Seite",
            options: i.elementsPerPageOptions,
            required: "",
            title: "Treffer pro Seite"
          }, null, 8, ["id", "modelValue", "options"])
        ]),
        _: 1
      }, 8, ["label-for"])
    ])
  ]);
}
const el = /* @__PURE__ */ W(Fs, [["render", Ks]]), Js = {
  name: "DpsFormToggle",
  props: {
    /**
     * The unique identifier for the input element.
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The current value of the toggle switch (on/off).
     * @default false
     */
    modelValue: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The title attribute for the input element, shown as a tooltip on hover.
     * @default undefined
     */
    title: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Disables the toggle switch when set to true.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * An ARIA label for accessibility, describing the input element.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of an element that labels the input element.
     * @default undefined
     */
    ariaLabelledby: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * ID of an element that describes the input element.
     * @default undefined
     */
    ariaDescribedby: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The size of the component.
     * @default undefined
     */
    size: {
      type: String,
      required: !1,
      default: "md"
    }
  },
  emits: [
    /**
     * Emitted when the toggle switch's value changes.
     * @event update:modelValue
     * @type { boolean }
     */
    "update:modelValue"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : de("dps-form-toggle-");
    }
  },
  methods: {
    handleChange(e) {
      const t = e.target;
      this.$emit("update:modelValue", t.checked);
    }
  }
}, Xs = ["for", "title"], Qs = ["id", "checked", "disabled", "aria-label", "aria-describedby", "aria-labelledby"], Zs = {
  key: 0,
  class: "dps-form-toggle__label sr-only"
}, ea = {
  key: 1,
  class: "dps-form-toggle__label"
};
function ta(e, t, i, s, l, d) {
  return k(), P("div", {
    class: R(["dps-form-toggle dps-input-wrapper", ["dps-form-toggle--size-" + i.size, { "dps-form-toggle--disabled": i.disabled }]])
  }, [
    M("label", {
      for: d.uniqueId,
      title: i.title,
      class: "dps-form-toggle__container"
    }, [
      M("input", {
        id: d.uniqueId,
        ref: "input",
        class: "dps-toggle",
        type: "checkbox",
        checked: i.modelValue,
        disabled: i.disabled,
        "aria-label": i.ariaLabel,
        "aria-describedby": i.ariaDescribedby,
        "aria-labelledby": i.ariaLabelledby,
        onChange: t[0] || (t[0] = (...n) => d.handleChange && d.handleChange(...n))
      }, null, 40, Qs),
      t[1] || (t[1] = M("span", { class: "dps-form-toggle__slider" }, null, -1)),
      i.hideLabel ? (k(), P("span", Zs, [
        $(e.$slots, "default")
      ])) : (k(), P("span", ea, [
        $(e.$slots, "default")
      ]))
    ], 8, Xs)
  ], 2);
}
const tl = /* @__PURE__ */ W(Js, [["render", ta]]), ua = te({
  name: "DpsLogoutAlert",
  components: { DpsButton: it, DpsAlert: Ds },
  props: {
    /**
     * Defines when the current session expires (UNIX timestamp in seconds)
     */
    expirationTime: {
      type: Number,
      required: !0
    },
    /**
     * Defines how many minutes before the logout the alert should be visible
     * @default 3
     */
    threshold: {
      type: Number,
      default: 3,
      required: !1
    }
  },
  emits: [
    /**
     * Emitted when the user clicks the "Neu anmelden" button
     */
    "click"
  ],
  data() {
    return {
      interval: null,
      minutesToLogout: null
    };
  },
  computed: {
    showLogoutAlert() {
      return this.minutesToLogout <= this.threshold;
    }
  },
  watch: {
    expirationTime() {
      this.startInterval();
    }
  },
  created() {
    this.startInterval();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startInterval() {
      this.setMinutesToLogout(), clearInterval(this.interval), this.minutesToLogout > 0 && (this.interval = setInterval(this.setMinutesToLogout, 1e3));
    },
    setMinutesToLogout() {
      const e = this.expirationTime * 1e3, t = Date.now(), i = e - t;
      this.minutesToLogout = Math.ceil(i / 1e3 / 60), this.minutesToLogout <= 0 && clearInterval(this.interval);
    },
    handleClick() {
      this.$emit("click");
    }
  }
});
function ra(e, t, i, s, l, d) {
  const n = se("DpsButton"), f = se("DpsAlert");
  return e.showLogoutAlert ? (k(), ie(f, {
    key: 0,
    variant: "info",
    class: "dps-logout-alert"
  }, {
    default: z(() => [
      M("div", null, [
        t[1] || (t[1] = M("b", null, "Hinweis:", -1)),
        t[2] || (t[2] = Z(" Aus Sicherheitsgründen werden Sie in ")),
        M("b", null, [
          e.minutesToLogout > 0 ? (k(), P(ae, { key: 0 }, [
            Z(G(e.minutesToLogout) + " " + G(e.minutesToLogout === 1 ? "Minute" : "Minuten"), 1)
          ], 64)) : (k(), P(ae, { key: 1 }, [
            Z("Kürze")
          ], 64)),
          t[0] || (t[0] = Z(" automatisch ausgeloggt. "))
        ]),
        t[3] || (t[3] = Z(" Bitte melden Sie sich anschließend erneut an. "))
      ]),
      pe(n, {
        class: "dps-logout-alert__logout-button",
        variant: "secondary",
        size: "sm",
        onClick: e.handleClick
      }, {
        default: z(() => t[4] || (t[4] = [
          Z(" Neu anmelden ")
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  })) : U("", !0);
}
const ul = /* @__PURE__ */ W(ua, [["render", ra]]);
var ia = {
  months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  monthsShort: ["Jan", "Feb", "März", "Apr", "Mai", "Juni", "Juli", "Aug", "Sep", "Okt", "Nov", "Dez"],
  weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  weekdaysShort: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  weekdaysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  firstDayOfWeek: 1,
  firstWeekContainsDate: 4
};
const na = {
  formatLocale: ia,
  yearFormat: "YYYY",
  monthFormat: "MMM",
  monthBeforeYear: !0
};
Sr.locale("de", na);
const sa = {
  name: "DpsFormDatepicker",
  components: {
    DpsFormCheckbox: tu,
    DpsButton: it,
    DatePickerNext: Sr
  },
  inheritAttrs: !1,
  props: {
    /**
     * Sets the initial date in the format `YYYY-MM-DD`.
     * Example: `2024-10-02`.
     */
    initialDate: {
      type: String,
      default: ""
    },
    /**
     * Enables the checkbox next to the date picker.
     */
    hasCheckbox: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the initial state of the checkbox.
     */
    isCheckboxChecked: {
      type: Boolean,
      default: !1
    },
    /**
     * Title for the checkbox.
     */
    checkboxTitle: {
      type: String,
      default: ""
    },
    /**
     * An array of dates that should be grayed out.
     * Can either be an array of dates or an array of objects containing a "from" and "to" date and an optional title.
     * Example: `[new Date(2024, 9, 15)]` or `[{from: "01.02.2025", to: "10.02.2025", title: "Beispieltermin"}]`.
     */
    dateBlackList: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Watch for external updates.
     */
    watchForExternalUpdates: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the start and end dates for the range.
     * Example: `{ beginn: new Date(), ende: new Date() }`.
     */
    zeitraum: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Disables the date picker when true.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Disables the date picker with readonly styles
     * @default false
     */
    readonly: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Placeholder text for the input field.
     */
    placeholder: {
      type: String,
      default: "TT.MM.JJJJ"
    },
    /**
     * Enables range selection mode.
     */
    range: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Allows the date picker to be cleared when set to true.
     */
    clearable: {
      type: Boolean,
      default: !0
    },
    /**
     * Enables manual input in the date field when set to true.
     */
    editable: {
      type: Boolean,
      default: !0
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: !1,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the selected date value changes.
     * @event date-picker-value
     */
    "date-picker-value",
    /**
     * Emitted when the checkbox state changes.
     * @event is-checkbox-checked
     */
    "is-checkbox-checked",
    /**
     * Emitted when the date picker is opened.
     * @event date-picker-opened
     */
    "date-picker-opened",
    /**
     * Emitted when a date is selected.
     * @event pick-element
     */
    "pick-element",
    /**
     * Emitted when the date range is updated.
     * @event update-range
     */
    "update-range",
    /**
     * Emitted when the duration is updated.
     * @event update-termindauer
     */
    "update-termindauer",
    /**
     * Emitted when the start or end dates are changed.
     * @event start-end
     */
    "start-end"
  ],
  data() {
    return {
      KEY_ARROW_RIGHT: "ArrowRight",
      KEY_ARROW_LEFT: "ArrowLeft",
      KEY_ARROW_UP: "ArrowUp",
      KEY_ARROW_DOWN: "ArrowDown",
      KEY_ENTER: "Enter",
      KEY_ESCAPE: "Escape",
      KEY_TAB: "Tab",
      defaultDate: this.getDefaultDate(),
      dauer: null,
      dateBlackListFinal: [],
      startDate: this.zeitraum && this.zeitraum.beginn ? oe(this.zeitraum.beginn).format("DD.MM.YYYY") : "",
      endDate: this.zeitraum && this.zeitraum.ende ? oe(this.zeitraum.ende).format("DD.MM.YYYY") : "",
      datepicker: null,
      datepickerPopup: null,
      cssClasses: {
        popup: "mx-datepicker-popup",
        header: "mx-calendar-header",
        calendarContent: "mx-calendar-content",
        rows: "tr.mx-date-row:not(.d-none)",
        firstRow: "mx-date-row:first-of-type",
        lastRow: "mx-date-row:last-of-type",
        cellsInCurrentMonth: "td.cell:not(.not-current-month)",
        hidden: "d-none",
        blackDate: "black-date",
        dayView: "mx-calendar-panel-date",
        monthView: "mx-calendar-panel-month",
        yearView: "mx-calendar-panel-year"
      },
      heights: {
        contentHeightSm: 225,
        contentHeightMd: 268,
        contentHeightLg: 308
      },
      isOpenDatepicker: !1,
      isChecked: !1
    };
  },
  computed: {
    outerClass() {
      return this.class;
    }
  },
  watch: {
    initialDate: {
      deep: !0,
      handler(e) {
        this.watchForExternalUpdates && (this.defaultDate = e ? new Date(e) : "");
      }
    },
    zeitraum: {
      deep: !0,
      handler(e) {
        e && (this.startDate = e.beginn ? oe(e.beginn).format("DD.MM.YYYY") : "", this.endDate = e.ende ? oe(e.ende).format("DD.MM.YYYY") : "", this.defaultDate = this.getDefaultDate());
      }
    },
    defaultDate: {
      deep: !0,
      handler(e) {
        this.range && (this.startDate = e[0] ? oe(e[0]).format("DD.MM.YYYY") : "", this.endDate = e[1] ? oe(e[1]).format("DD.MM.YYYY") : "", e.length || (this.updateRange(), this.$emit("update-termindauer", "", "", 0)));
      }
    }
  },
  mounted() {
    this.datepicker = this.$refs.datepicker, this.isChecked = this.isCheckboxChecked, this.calculateFinalBlacklist(), this.range ? this.calcDateDifference() : this.defaultDate = new Date(this.initialDate);
  },
  methods: {
    /**
     * Handles the behavior when confirm button is clicked
     * Ensures popup doesn't reopen immediately after closing
     */
    handleConfirm() {
      this.isOpenDatepicker = !1, this.$nextTick(() => {
        this.$refs.datepicker.getElementsByTagName("input")[0].blur();
      });
    },
    /**
     * Toggles the datepicker open state.
     * Can be used for both click and keyup.enter events.
     * @returns {void}
     */
    toggleDatepicker() {
      this.isOpenDatepicker || (this.isOpenDatepicker = !0, this.$nextTick(() => {
        this.handleOpen();
      }));
    },
    /**
     * returns valid moment date or null
     * @param   {string} dateString string to parse
     * @returns {moment.Moment} date or null
     */
    getMomentDate(e) {
      return e ? oe(e, "DD.MM.YYYY") : null;
    },
    /**
     * calculates the duration between dates
     * @param {Array} datesArr selected date as Array or empty
     * @returns {void}
     */
    calcDateDifference(e = []) {
      if (e.length < 2 || e.some((s) => s === null)) return;
      const t = this.getMomentDate(e[0]), i = this.getMomentDate(e[1]);
      this.dauer = i.diff(t, "days") || 0, this.$emit("start-end", {
        beginn: t.format("YYYY-MM-DD"),
        ende: i.format("YYYY-MM-DD")
      }), this.$emit("update-termindauer", t, i, this.dauer);
    },
    /**
     * Check if the date changed in the datepicker range
     * @returns {void}
     */
    updateRange() {
      let e = "", t = "";
      if (this.startDate && this.endDate) {
        const i = this.getMomentDate(this.startDate), s = this.getMomentDate(this.endDate);
        this.dauer = s.diff(i, "days") || 0, e = i.format("YYYY-MM-DD"), t = s.format("YYYY-MM-DD");
      }
      this.$emit("update-range", {
        beginn: e,
        ende: t,
        dauer: this.dauer
      });
    },
    /**
     * function to get the defaultDate from zeitraum
     * @return {object}
     */
    getDefaultDate() {
      var e, t;
      return this.range ? (e = this.zeitraum) != null && e.beginn && ((t = this.zeitraum) != null && t.ende) ? [
        new Date(oe(this.zeitraum.beginn).format("MM.DD.YYYY")),
        new Date(oe(this.zeitraum.ende).format("MM.DD.YYYY"))
      ] : [] : this.initialDate ? new Date(this.initialDate) : "";
    },
    /**
     * Moves focus to a different cell in the datepicker based on the given offset.
     * @param {number} dayOffset - The number of days to move the focus by.
     * @param {HTMLElement} currentPanel - The currently active panel containing the date cells (day, month, or year view).
     * @returns {void}
     */
    moveFocus(e, t) {
      if (!t) return;
      const i = Array.from(t.querySelectorAll(".cell"));
      if (i.length === 0) return;
      const s = document.activeElement, l = i.findIndex((n) => n === s);
      if (l === -1) {
        this.setFocusOnCell(i[0]);
        return;
      }
      const d = l + e;
      d >= 0 && d < i.length && this.updateFocus(i[l], i[d]);
    },
    /**
     * Sets focus on a specific cell in the datepicker.
     * @param {HTMLElement} cell - The cell to focus.
     * @returns {void}
     */
    setFocusOnCell(e) {
      this.datepickerPopup.querySelectorAll(".cell").forEach((i) => i.classList.remove("focused")), e.tabIndex = 0, e.classList.add("focused"), e.focus();
    },
    /**
     * Updates focus by removing focus from the old cell and applying it to the new cell.
     * @param {HTMLElement} oldCell - The previously focused cell.
     * @param {HTMLElement} newCell - The new cell to focus on.
     * @returns {void}
     */
    updateFocus(e, t) {
      e && (e.classList.remove("focused"), e.tabIndex = -1), t && this.setFocusOnCell(t);
    },
    /**
     * Handles keydown events for navigating within the datepicker panels.
     *
     * This function manages navigation within day, month, and year views based on
     * arrow keys, handles the "Enter" key to simulate clicks, and ensures focus trapping
     * within the datepicker. It also manages specific transitions when navigating between
     * different calendar panels in range view.
     *
     * @param {KeyboardEvent} event - The keyboard event object containing information about the key pressed.
     *
     * @returns {void}
     */
    handleKeydown(e) {
      const t = document.activeElement, i = !!t.closest(".mx-calendar-panel-date"), s = !!t.closest(".mx-calendar-panel-month"), l = !!t.closest(".mx-calendar-panel-year"), d = i ? t.closest(".mx-calendar-panel-date") : s ? t.closest(".mx-calendar-panel-month") : l ? t.closest(".mx-calendar-panel-year") : null, n = {
        [this.KEY_ARROW_RIGHT]: i || s || l ? 1 : 0,
        [this.KEY_ARROW_LEFT]: i || s || l ? -1 : 0,
        [this.KEY_ARROW_UP]: i ? -7 : s ? -3 : l ? -2 : 0,
        [this.KEY_ARROW_DOWN]: i ? 7 : s ? 3 : l ? 2 : 0
      };
      (e.key === this.KEY_ARROW_UP || e.key === this.KEY_ARROW_DOWN) && e.preventDefault();
      const f = n[e.key] || 0;
      if (f !== 0 && d) {
        const h = e.key === this.KEY_ARROW_RIGHT ? "right" : e.key === this.KEY_ARROW_LEFT ? "left" : e.key === this.KEY_ARROW_UP ? "up" : e.key === this.KEY_ARROW_DOWN ? "down" : null;
        i && h ? this.handleDayViewBoundaryMove(f, d, h) : this.moveFocus(f, d);
      }
      e.key === this.KEY_ENTER && this.handleEnterKey(e), e.key === this.KEY_ESCAPE && (this.isOpenDatepicker = !1, this.resetFocusToCurrentDatepickerInput()), this.trapFocus(e);
    },
    /**
     * Handles focus movement in the day view, including crossing boundaries between calendar panels.
     * @param {number} moveStep - The number of steps to move the focus by (positive for forward, negative for backward).
     * @param {HTMLElement} currentPanel - The currently active panel (day view) containing the date cells.
     * @param {string} direction - The direction of movement (e.g., 'left', 'right', 'up', 'down').
     * @returns {void}
     */
    handleDayViewBoundaryMove(e, t, i) {
      const s = Array.from(
        t.querySelectorAll(".cell:not(.not-current-month)")
      );
      if (s.length === 0) return;
      const l = document.activeElement, d = s.findIndex((f) => f === l);
      if (d === -1) {
        this.setFocusOnCell(s[0]);
        return;
      }
      const n = d + e;
      switch (i) {
        case "down":
        case "up":
          n >= 0 && n < s.length && this.updateFocus(s[d], s[n]);
          break;
        case "right":
          if (n >= s.length) {
            const f = t.nextElementSibling;
            if (f) {
              const h = Array.from(
                f.querySelectorAll(".cell:not(.not-current-month)")
              );
              h.length > 0 && this.setFocusOnCell(h[0]);
            }
          } else
            this.updateFocus(s[d], s[n]);
          break;
        case "left":
          if (n < 0) {
            const f = t.previousElementSibling;
            if (f) {
              const h = Array.from(
                f.querySelectorAll(".cell:not(.not-current-month)")
              );
              h.length > 0 && this.setFocusOnCell(h[h.length - 1]);
            }
          } else
            this.updateFocus(s[d], s[n]);
          break;
      }
    },
    /**
     * Handles the behavior when the "Enter" key is pressed.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @returns {void}
     */
    handleEnterKey(e) {
      e.target.click(), this.$nextTick(() => {
        const t = document.querySelector(".mx-calendar-panel-year"), i = document.querySelector(".mx-calendar-panel-month"), s = t ? t.querySelector("td.cell.active") : i ? i.querySelector("td.cell.active") : null;
        s && (s.setAttribute("tabindex", "0"), s.focus());
      });
    },
    /**
     * Sets up an event listener for the datepicker popup.
     * @returns {void}
     */
    setPopupEventListener() {
      this.$nextTick(() => {
        this.datepickerPopup && this.datepickerPopup.addEventListener("keydown", this.handleKeydown);
      });
    },
    /**
     * Checks and sets the focus on either 'today' or 'active' cell after the DOM updates.
     * @returns {void}
     */
    checkAndSetCellFocus() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        const e = this.datepickerPopup.querySelectorAll(".mx-calendar-panel-year"), t = this.datepickerPopup.querySelectorAll(".mx-calendar-panel-month"), i = this.datepickerPopup.querySelectorAll(".mx-calendar-panel-date");
        if (e.length) {
          const s = e[0], l = s.querySelector("td.cell.active") || s.querySelector("td.cell");
          l && this.setFocusOnCell(l);
          return;
        }
        if (t.length) {
          const s = t[0], l = s.querySelector("td.cell.active") || s.querySelector("td.cell");
          l && this.setFocusOnCell(l);
          return;
        }
        if (i.length) {
          const s = i[0], l = s.querySelector(".cell.active") || s.querySelector(".cell.today") || s.querySelector(".cell:not(.not-current-month)");
          l && this.setFocusOnCell(l);
        }
      });
    },
    /**
     * Traps focus within the datepicker popup for improved accessibility.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @returns {void}
     */
    trapFocus(e) {
      const t = this.getFocusableElements();
      if (t.length === 0)
        return;
      const [i, s] = [
        t[0],
        t[t.length - 1]
      ];
      e.key === this.KEY_TAB && this.handleTabNavigation(e, i, s);
    },
    /**
     * Retrieves all focusable elements inside the datepickerPopup.
     * @returns {HTMLElement[]} Array of focusable elements.
     */
    getFocusableElements() {
      const e = this.datepickerPopup.querySelectorAll(
        'input, a, .mx-calendar-panel-month button, .mx-calendar-panel-year button, .mx-calendar-panel-date button:not(.mx-btn-icon-double-left), [tabindex]:not([tabindex="-1"]), .mx-datepicker-footer button'
      );
      return Array.from(e).filter((t) => {
        const i = window.getComputedStyle(t);
        return t.offsetWidth > 0 && t.offsetHeight > 0 && i.visibility !== "hidden" && i.display !== "none";
      });
    },
    /**
     * Handles Tab and Shift+Tab navigation for focus trapping.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @param {HTMLElement} firstElement - The first focusable element.
     * @param {HTMLElement} lastElement - The last focusable element.
     * @returns {void}
     */
    handleTabNavigation(e, t, i) {
      const s = e.shiftKey;
      s && document.activeElement === t ? (i.focus(), e.preventDefault()) : !s && document.activeElement === i && (t.focus(), e.preventDefault());
    },
    /**
     * Resets the focus back to the current datepicker input element.
     * @returns {void}
     */
    resetFocusToCurrentDatepickerInput() {
      this.$nextTick(() => {
        this.$refs.datepicker.getElementsByTagName("input")[0].select();
      });
    },
    /**
     * Improves the accessibility of navigation buttons in the datepicker.
     * Sets titles for previous, next, month, and year buttons for better understanding and accessibility.
     * @returns {void}
     */
    improveNavigationButtonAccessibility() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        Object.entries({
          ".mx-calendar-header .mx-btn-icon-left, .mx-calendar-header .mx-btn-icon-double-left": "Zurück",
          ".mx-calendar-header .mx-btn-icon-right, .mx-calendar-header .mx-btn-icon-double-right": "Weiter",
          ".mx-calendar-header .mx-btn-current-month": "Monat",
          ".mx-calendar-header .mx-btn-current-year": "Jahr"
        }).forEach(([t, i]) => {
          this.datepickerPopup.querySelectorAll(t).forEach((l) => {
            l.title = i;
          });
        });
      });
    },
    /**
     * Sets titles to each cell in the datepicker.
     * The title is set to the text content of the cell for better accessibility.
     * @returns {void}
     */
    setCellTitles() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        this.datepickerPopup.querySelectorAll(
          ".mx-calendar-panel-month .mx-calendar-content .cell, .mx-calendar-panel-year .mx-calendar-content .cell"
        ).forEach((t) => {
          t.title = t.textContent.trim();
        });
      });
    },
    /**
     * run functions to customize the datepicker
     * @returns {void}
     */
    customizeDatePicker() {
      this.setDateBlacklist(), this.hideRowsNotInCurrentMonth();
    },
    /**
     * Sets CSS classes and titles for black and white days based on the provided lists.
     * @param {Array} dateList - The list of dates to process.
     * @returns {void}
     */
    async setDateList(e) {
      if (await this.selectDatepickerPopup(), !this.datepickerPopup) return;
      const t = this.datepickerPopup.querySelectorAll(
        `.${this.cssClasses.calendarContent}`
      );
      t && (t.forEach((i) => {
        i.querySelectorAll(`.${this.cssClasses.blackDate}`).forEach((l) => {
          l.classList.remove(this.cssClasses.blackDate), l.removeAttribute("data-tooltip");
        });
      }), e.forEach((i) => {
        const l = (i instanceof Date ? oe(i) : i.date).format("YYYY-MM-DD");
        t.forEach((d) => {
          const n = d.querySelector(`.cell[title='${l}']`);
          n && this.addDateClass(n, i.title || "");
        });
      }));
    },
    /**
     * Adds the specified CSS class and updates attributes for the date cell.
     * @param {Element} dateCell - The cell element for the date.
     * @param {string} zusatz - Additional label for the date (if available).
     * @returns {void}
     */
    addDateClass(e, t) {
      e.classList.add(this.cssClasses.blackDate);
      const i = t || "";
      i && (e.setAttribute("aria-label", e.getAttribute("title")), e.setAttribute("title", i));
    },
    async setDateBlacklist() {
      this.setDateList(this.dateBlackListFinal);
    },
    /**
     * Hide first or last row if all days in the calendar row are in the new month
     * @returns {void}
     */
    async hideRowsNotInCurrentMonth() {
      if (await this.selectDatepickerPopup(), !this.datepickerPopup) return;
      const e = this.datepickerPopup.querySelectorAll(
        `.${this.cssClasses.calendarContent}`
      );
      for (const t of e) {
        const i = t.querySelectorAll("tr.mx-date-row");
        for (const d of i) {
          const f = d.querySelectorAll(
            this.cssClasses.cellsInCurrentMonth
          ).length > 0;
          d.classList.toggle(this.cssClasses.hidden, !f);
        }
        const l = t.querySelectorAll(
          `tr.mx-date-row:not(.${this.cssClasses.hidden})`
        ).length;
        l === 0 ? t.style.setProperty("--mx-content-height", "0px") : l < 5 ? t.style.setProperty("--mx-content-height", this.heights.contentHeightSm + "px") : l === 5 ? t.style.setProperty("--mx-content-height", this.heights.contentHeightMd + "px") : t.style.setProperty("--mx-content-height", this.heights.contentHeightLg + "px");
      }
    },
    /**
     * select popup element and customize the datepicker
     * @returns {void}
     */
    async handleOpen() {
      this.isChecked = this.isCheckboxChecked, await this.selectDatepickerPopup(), this.datepickerPopup && (this.customizeDatePicker(), this.improveNavigationButtonAccessibility(), this.setCellTitles(), this.checkAndSetCellFocus(), this.setPopupEventListener(), this.$emit("date-picker-opened"));
    },
    handleClose() {
      this.datepickerPopup.removeEventListener("keydown", this.handleKeydown), this.updateRange(), this.isOpenDatepicker = !1, this.resetFocusToCurrentDatepickerInput();
    },
    /**
     * function to handle the calendar change event. customize the popup element.
     * @returns {void}
     */
    handleCalendarChange() {
      this.customizeDatePicker(), this.improveNavigationButtonAccessibility(), this.setCellTitles(), this.$nextTick(() => {
        this.hideRowsNotInCurrentMonth();
      });
    },
    /**
     * function to select the popup element of the datepicker after it was opened
     * @returns {Promise}
     */
    selectDatepickerPopup() {
      return new Promise((e, t) => {
        this.datepickerPopup && e(), this.$nextTick(() => {
          this.datepickerPopup = document.querySelector(`.${this.cssClasses.popup}`), this.datepickerPopup && e(), t();
        });
      });
    },
    updateCheckbox(e) {
      this.$emit("is-checkbox-checked", e);
    },
    /**
     * function to handle the change event. set the start date and emits the date-picker-value event.
     * @emits date-picker-value
     * @returns {void}
     */
    handleChange(e) {
      if (!e) {
        this.$emit("date-picker-value", null);
        return;
      }
      const t = (i) => oe(i, oe.ISO_8601, !0).isValid() ? oe(i).format("DD.MM.YYYY") : oe(i, "DD.MM.YYYY").format("DD.MM.YYYY");
      if (this.range)
        e.length < 1 || e[0] === null ? (this.startDate = "", this.endDate = "") : (this.startDate = t(e[0]), this.endDate = this.startDate, e.length >= 2 && e[1] !== null && (this.endDate = t(e[1]), this.calcDateDifference(e)));
      else {
        const i = t(e);
        this.$emit("date-picker-value", i);
      }
      this.handleConfirm(), this.$nextTick(() => {
        this.checkAndSetCellFocus(), this.resetFocusToCurrentDatepickerInput();
      });
    },
    handlePanelChange() {
      this.$nextTick(() => {
        this.improveNavigationButtonAccessibility(), this.setCellTitles(), this.checkAndSetCellFocus(), this.setPopupEventListener();
      });
    },
    /**
     * creates a list of all blacklisted dates and the corresponding titles.
     */
    calculateFinalBlacklist() {
      Array.isArray(this.dateBlackList) ? this.dateBlackList[0] instanceof Date ? this.dateBlackListFinal = this.dateBlackList : this.dateBlackList.forEach((e) => {
        if (e.to && e.from) {
          const t = oe(e.from), s = oe(e.to).diff(t, "days");
          for (let l = 0; l <= s; l++)
            this.dateBlackListFinal.push({
              date: oe(e.from).add(l, "days"),
              title: e.title
            });
        }
      }) : this.dateBlackListFinal = [];
    }
  }
};
function aa(e, t, i, s, l, d) {
  const n = se("DpsFormCheckbox"), f = se("DpsButton"), h = se("DatePickerNext");
  return k(), ie(h, {
    ref: "datepicker",
    value: l.defaultDate,
    "onUpdate:value": t[1] || (t[1] = (a) => l.defaultDate = a),
    class: R(["dps-form-datepicker", {
      "dps-form-datepicker--range": i.range,
      [d.outerClass]: !0,
      "dps-form-datepicker--disabled": i.disabled,
      "dps-form-datepicker--readonly": i.readonly
    }]),
    format: "DD.MM.YYYY",
    type: "date",
    open: l.isOpenDatepicker,
    range: i.range,
    "popup-class": "dps-form-datepicker__popup" + (i.range ? " range" : ""),
    placeholder: i.range ? l.startDate && l.endDate ? `${l.startDate} - ${l.endDate}` : "TT.MM.JJJJ - TT.MM.JJJJ" : i.placeholder,
    separator: " - ",
    disabled: i.disabled || i.readonly,
    "input-attr": e.$attrs,
    clearable: i.clearable,
    editable: i.editable,
    confirm: i.range,
    "confirm-text": "Übernehmen",
    onClick: d.toggleDatepicker,
    onKeydown: he(ue(d.toggleDatepicker, ["stop", "prevent"]), ["enter"]),
    onClose: d.handleClose,
    onCalendarChange: d.handleCalendarChange,
    onChange: d.handleChange,
    onPick: t[2] || (t[2] = (a) => e.$emit("pick-element", a)),
    onPanelChange: d.handlePanelChange
  }, eu({
    "icon-calendar": z(() => [
      t[4] || (t[4] = M("span", { class: "dps-icon dps-icon--calendar" }, null, -1))
    ]),
    _: 2
  }, [
    i.range || i.hasCheckbox ? {
      name: "footer",
      fn: z(() => [
        i.hasCheckbox ? (k(), ie(n, {
          key: 0,
          modelValue: l.isChecked,
          "onUpdate:modelValue": [
            t[0] || (t[0] = (a) => l.isChecked = a),
            d.updateCheckbox
          ],
          title: i.checkboxTitle
        }, {
          default: z(() => [
            Z(G(i.checkboxTitle), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "title", "onUpdate:modelValue"])) : U("", !0),
        i.range ? (k(), ie(f, {
          key: 1,
          class: "dps-form-datepicker__button-cancel",
          variant: "secondary",
          title: "Abbrechen",
          size: "sm",
          onClick: d.handleClose
        }, {
          default: z(() => t[3] || (t[3] = [
            Z(" Abbrechen ")
          ])),
          _: 1
        }, 8, ["onClick"])) : U("", !0)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["value", "class", "open", "range", "popup-class", "placeholder", "disabled", "input-attr", "clearable", "editable", "confirm", "onClick", "onKeydown", "onClose", "onCalendarChange", "onChange", "onPanelChange"]);
}
const rl = /* @__PURE__ */ W(sa, [["render", aa]]), la = {
  name: "DpsUploadFormGroup",
  components: { DpsFormFile: Vs, DpsFormGroup: Nr, DpsButton: it, DpsInputGroup: Ns },
  props: {
    /**
     * The unique identifier for the input (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The label for the component.
     * @default ""
     */
    label: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The label for the upload button.
     * @default "Hochladen"
     */
    uploadButtonLabel: {
      type: String,
      required: !1,
      default: "Hochladen"
    },
    /**
     * The title for the upload button.
     * Defaults to the button label if no title is set.
     * @default undefined
     */
    uploadButtonTitle: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Which file formats to accept.
     * Can be either file extension or mime-type or mixed
     * e.g. ['.pdf'], ['application/pdf'] or ['.pdf', 'application/pdf']
     * @default []
     */
    fileAccept: {
      type: Array,
      required: !1,
      default: void 0
    },
    /**
     * Allows selecting multiple files at once.
     * @default false
     */
    fileMultiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Title for the search button.
     * Defaults to the label if no title is set.
     * @default undefined
     */
    title: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Disables the upload button.
     * @default false
     */
    disableUploadButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Displays the component without the upload button.
     * @default false
     */
    hideUploadButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Changes the state to error and displays the provided error message.
     * @default ""
     */
    uploadErrorMessage: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Required attribute of the input.
     * @default false
     */
    fileRequired: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * Emitted when the file selection changes.
     * @event module:DpsFormFile#input
     */
    "input",
    /**
     * Emitted when the upload button gets clicked.
     * @event module:DpsFormFile#upload
     */
    "upload"
  ],
  expose: ["resetSelection"],
  data() {
    return {
      hasError: !1,
      filesSelected: null,
      uniqID: this.id ?? de("dps-upload-form-group-"),
      rerenderCounter: 0
    };
  },
  computed: {
    fileSearchTitle() {
      return this.title ?? this.label;
    },
    acceptedFilesAsString() {
      if (Array.isArray(this.fileAccept))
        return this.fileAccept.join(", ");
    },
    acceptedFilesDescription() {
      var e;
      return this.acceptedFilesAsString ? `${((e = this.fileAccept) == null ? void 0 : e.length) > 1 ? "Erlaubte Dateiformate" : "Erlaubtes Dateiformat"}: ${this.acceptedFilesAsString}` : void 0;
    },
    acceptedFilesErrorMessage() {
      var e;
      return this.acceptedFilesAsString ? `Die ${this.fileMultiple ? "gewählten Dateien entsprechen" : "gewählte Datei entspricht"} nicht ${((e = this.fileAccept) == null ? void 0 : e.length) > 1 ? "den erlaubten Dateiformaten" : "dem erlaubten Dateiformat"}` : "";
    },
    errorMessage() {
      return this.uploadErrorMessage ? this.uploadErrorMessage : this.acceptedFilesErrorMessage;
    },
    isUploadButtonDisabled() {
      var e;
      return !(Array.isArray(this.filesSelected) ? (e = this.filesSelected) != null && e.length : this.filesSelected) || this.disabled || this.disableUploadButton;
    }
  },
  watch: {
    uploadErrorMessage(e) {
      e && (this.hasError = !0);
    }
  },
  mounted() {
    this.hasError = !!this.uploadErrorMessage;
  },
  methods: {
    validateFileType(e) {
      const t = "." + e.name.split(".").pop();
      return this.fileAccept.includes(e.type) || this.fileAccept.includes(t);
    },
    handleSelectionChange(e) {
      if (!e)
        return this.filesSelected = null, this.$emit("input", this.filesSelected), !1;
      if (this.filesSelected = Array.isArray(e) ? e : [e], this.acceptedFilesAsString && !Array.from(this.filesSelected).reduce(
        (i, s) => i && s && this.validateFileType(s),
        !0
      ))
        return this.resetSelection(!0), !1;
      this.hasError = !1, this.$emit("input", this.filesSelected);
    },
    // May be called as an API method from outside - do not remove!
    resetSelection(e = !1) {
      this.filesSelected = this.fileMultiple ? [] : null, this.rerenderCounter++, this.$emit("input", this.filesSelected), this.hasError = e;
    }
  }
};
function oa(e, t, i, s, l, d) {
  const n = se("DpsFormFile"), f = se("DpsButton"), h = se("DpsInputGroup"), a = se("DpsFormGroup");
  return k(), ie(a, {
    id: l.uniqID + "-form-group",
    class: R(["dps-upload-form-group", { "dps-upload-form-group--disabled": i.disabled }]),
    label: i.label,
    "hide-label": i.hideLabel,
    description: d.acceptedFilesDescription,
    "error-feedback": d.errorMessage,
    valid: !l.hasError,
    disabled: i.disabled
  }, {
    default: z(() => [
      pe(h, {
        id: l.uniqID + "-input-group",
        collapsed: "",
        class: "dps-upload-form-group__input-group"
      }, {
        default: z(() => [
          (k(), ie(n, {
            id: l.uniqID,
            key: "file-input-" + l.rerenderCounter,
            ref: "fileInput",
            "model-value": l.filesSelected,
            accept: d.acceptedFilesAsString,
            multiple: i.fileMultiple,
            disabled: i.disabled,
            error: l.hasError,
            title: d.fileSearchTitle,
            required: i.fileRequired,
            "onUpdate:modelValue": d.handleSelectionChange
          }, null, 8, ["id", "model-value", "accept", "multiple", "disabled", "error", "title", "required", "onUpdate:modelValue"]))
        ]),
        append: z(() => [
          i.hideUploadButton ? U("", !0) : (k(), ie(f, {
            key: 0,
            title: i.uploadButtonTitle ?? i.uploadButtonLabel,
            class: R(["dps-upload-form-group__upload-button", {
              "dps-upload-form-group__upload-button--error": l.hasError,
              "dps-upload-form-group__upload-button--all-disabled": i.disabled
            }]),
            squared: "",
            size: "lg",
            disabled: d.isUploadButtonDisabled,
            onClick: t[0] || (t[0] = (o) => e.$emit("upload", l.uniqID))
          }, {
            default: z(() => [
              Z(G(i.uploadButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["title", "class", "disabled"]))
        ]),
        _: 1
      }, 8, ["id"])
    ]),
    _: 1
  }, 8, ["id", "class", "label", "hide-label", "description", "error-feedback", "valid", "disabled"]);
}
const il = /* @__PURE__ */ W(la, [["render", oa]]), da = {
  name: "DpsListGroup",
  props: {
    /**
     * Adds a border around the list group.
     * @default false
     */
    bordered: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Specifies the HTML tag to use for the root element of the component.
     * @default "div"
     */
    tag: {
      type: String,
      default: "div",
      required: !1
    }
  }
}, ca = { class: "dps-list-group" }, fa = {
  key: 0,
  class: "dps-list-group__counter"
};
function ha(e, t, i, s, l, d) {
  return k(), P("div", ca, [
    e.$slots.counter ? (k(), P("div", fa, [
      $(e.$slots, "counter")
    ])) : U("", !0),
    (k(), ie(Re(i.tag), {
      class: R(["dps-list-group__content", {
        "dps-list-group__content--bordered": i.bordered
      }])
    }, {
      default: z(() => [
        $(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]))
  ]);
}
const nl = /* @__PURE__ */ W(da, [["render", ha]]), pa = te({
  name: "DpsListGroupItem",
  components: { DpsBadge: li, DpsIconButton: xr },
  props: {
    /**
     * The unique identifier for the collapsible element. This identifier is used to associate the
     * collapsible content with its corresponding trigger for accessibility and Bootstrap's collapse functionality.
     *
     * @default undefined
     */
    collapseId: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Specifies the HTML tag to use for the root element.
     * @default "div"
     */
    tag: {
      type: String,
      required: !1,
      default: "div"
    },
    /**
     * The URL that the hyperlink points to.
     * @default undefined
     */
    href: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Indicates whether the collapsible row content is initially expanded.
     * When set to true, the collapsible content will be visible by default.
     *
     * @default false
     */
    expanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * This event is fired immediately when the show method has been called.
     */
    "show",
    /**
     * This event is fired immediately when the hide method has been called.
     */
    "hide"
  ],
  data() {
    return {
      isExpanded: !1
    };
  },
  computed: {
    uniqueId() {
      return this.collapseId ? this.collapseId : de("dps-list-group-item-");
    },
    computedTag() {
      return this.href ? "a" : this.tag;
    },
    isCollapsible() {
      return !!this.$slots["collapsible-content"];
    }
  },
  watch: {
    expanded(e) {
      this.isExpanded = e;
    }
  },
  mounted() {
    const e = this.$refs.collapsible;
    this.isExpanded = this.expanded, e && (e.addEventListener("hide.bs.collapse", () => {
      this.isExpanded = !1, this.$emit("hide");
    }), e.addEventListener("show.bs.collapse", () => {
      this.isExpanded = !0, this.$emit("show");
    }));
  },
  methods: {
    handleEnter() {
      this.isCollapsible && this.$refs.trigger.click();
    }
  }
}), ba = ["data-bs-target", "aria-controls", "aria-expanded"], ma = { class: "dps-list-group-item__collapse" }, ga = ["id"], ya = { class: "dps-list-group-item__collapsible-content" };
function va(e, t, i, s, l, d) {
  return k(), ie(Re(e.computedTag), {
    class: R(["dps-list-group-item", {
      "dps-list-group-item--collapsible": e.isCollapsible,
      "dps-list-group-item--expanded": e.isCollapsible && e.isExpanded
    }]),
    href: e.href
  }, {
    default: z(() => [
      e.isCollapsible ? (k(), P(ae, { key: 0 }, [
        M("div", {
          ref: "trigger",
          class: "dps-list-group-item__trigger",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#" + e.uniqueId,
          "aria-controls": e.uniqueId,
          "aria-expanded": e.expanded,
          tabindex: "0",
          role: "button",
          onKeydown: t[0] || (t[0] = he((...n) => e.handleEnter && e.handleEnter(...n), ["enter"]))
        }, [
          $(e.$slots, "default")
        ], 40, ba),
        M("div", ma, [
          M("div", {
            id: e.uniqueId,
            ref: "collapsible",
            class: R(["collapse", { show: e.expanded }])
          }, [
            M("div", ya, [
              $(e.$slots, "collapsible-content")
            ])
          ], 10, ga)
        ])
      ], 64)) : $(e.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["class", "href"]);
}
const sl = /* @__PURE__ */ W(pa, [["render", va]]), wa = te({
  name: "DpsTableRow",
  props: {
    /**
     * The unique identifier for the collapsible element. This identifier is used to associate the
     * collapsible content with its corresponding trigger for accessibility and Bootstrap's collapse functionality.
     * @default undefined
     */
    collapseId: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The number of columns the collapsible content should span when expanded.
     * This controls the width of the collapsible content.
     *
     * @default undefined
     */
    collapseColspan: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * The starting position (column index) where the collapsible content should be displayed.
     * This can be used to create an offset within the row.
     *
     * @default 0
     */
    collapseColstart: {
      type: Number,
      required: !1,
      default: 0
    },
    /**
     * Indicates whether the collapsible row content is initially expanded.
     * When set to true, the collapsible content will be visible by default.
     *
     * @default false
     */
    expanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    /**
     * This event is fired immediately when the show method has been called.
     */
    "show",
    /**
     * This event is fired immediately when the hide method has been called.
     */
    "hide"
  ],
  data() {
    return {
      isExpanded: !1
    };
  },
  computed: {
    uniqueId() {
      return this.collapseId ? this.collapseId : de("dps-table-row-");
    },
    isCollapsible() {
      return !!this.$slots["collapsible-content"];
    }
  },
  watch: {
    expanded(e) {
      this.isExpanded = e;
    }
  },
  mounted() {
    const e = this.$refs.collapsible;
    this.isExpanded = this.expanded, e && (e.addEventListener("hide.bs.collapse", () => {
      this.isExpanded = !1, this.$emit("hide");
    }), e.addEventListener("show.bs.collapse", () => {
      this.isExpanded = !0, this.$emit("show");
    }));
  },
  methods: {
    handleEnter() {
      this.isCollapsible && this.$refs.mainElement.click();
    }
  }
}), Sa = ["data-bs-toggle", "data-bs-target", "aria-expanded", "aria-controls", "tabindex", "role"], xa = {
  key: 0,
  class: "dps-table-row dps-table-row--collapse"
}, Ea = ["colspan"], qa = ["colspan"], Aa = ["id"], ka = { class: "dps-table-row__collapsible-content" };
function Ta(e, t, i, s, l, d) {
  return k(), P(ae, null, [
    M("tr", {
      ref: "mainElement",
      class: R(["dps-table-row", {
        "dps-table-row--collapsible": e.isCollapsible,
        "dps-table-row--expanded": e.isCollapsible && e.isExpanded
      }]),
      "data-bs-toggle": e.isCollapsible ? "collapse" : void 0,
      "data-bs-target": e.isCollapsible ? "#" + e.uniqueId : void 0,
      "aria-expanded": e.isCollapsible ? e.expanded : void 0,
      "aria-controls": e.isCollapsible ? e.uniqueId : void 0,
      tabindex: e.isCollapsible ? "0" : void 0,
      role: e.isCollapsible ? "button" : void 0,
      onKeydown: t[0] || (t[0] = he((...n) => e.handleEnter && e.handleEnter(...n), ["enter"]))
    }, [
      $(e.$slots, "default")
    ], 42, Sa),
    e.isCollapsible ? (k(), P("tr", xa, [
      e.collapseColstart > 0 ? (k(), P("td", {
        key: 0,
        colspan: e.collapseColstart
      }, null, 8, Ea)) : U("", !0),
      M("td", { colspan: e.collapseColspan }, [
        M("div", {
          id: e.uniqueId,
          ref: "collapsible",
          class: R(["collapse", { show: e.expanded }])
        }, [
          M("div", ka, [
            $(e.$slots, "collapsible-content")
          ])
        ], 10, Aa)
      ], 8, qa)
    ])) : U("", !0)
  ], 64);
}
const Da = /* @__PURE__ */ W(wa, [["render", Ta]]), Ca = te({
  name: "DpsTable",
  components: { DpsTableRow: Da, DpsFormCheckbox: tu },
  props: {
    /**
     * An array of field definition objects, each defining the properties of a table column.
     *
     * @default []
     */
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * An array of data objects to be displayed in the table rows.
     * Each object should match the structure defined by the `fields` array.
     *
     * @default []
     */
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Whether to hide the table header while keeping it accessible for screen readers.
     * This is useful for visually minimalist tables while maintaining accessibility.
     *
     * @default false
     */
    hideHeader: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The key  of the field currently being used for sorting the table.
     * Should correspond to one of the `key` values defined in the `fields` array.
     *
     * @default undefined
     */
    sortBy: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Indicates whether the sorting is in descending order.
     * When set to `true`, the table will be sorted in descending order; otherwise, it will be in ascending order.
     *
     * @default false
     */
    sortDesc: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The starting column index where the collapsible content should be displayed.
     * This can create an offset within the table row for the collapsible section.
     *
     * @default undefined
     */
    collapseColstart: {
      type: Number,
      required: !1,
      default: void 0
    },
    /**
     * The number of columns the collapsible content should span when expanded.
     * Determines the width of the collapsible content section.
     *
     * @default undefined
     */
    collapseColspan: {
      type: Number,
      required: !1,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the sortBy property changes.
     *
     * @event update:sort-by
     * @property {string} - The key of the field being sorted. Corresponds to the `key` property in the `fields` array.
     */
    "update:sort-by",
    /**
     * Emitted when the sortDesc property changes.
     *
     * @event update:sort-desc
     * @property {boolean} - Indicates the sort direction. `true` for descending order, `false` for ascending order.
     */
    "update:sort-desc",
    /**
     * Emitted when the status of a header checkbox changes.
     *
     * @event change-checked
     * @property {number} - The key of the field whose checkbox status was changed.
     */
    "change-checked"
  ],
  data() {
    return {
      isScrollable: !1,
      isScrolledToRight: !1,
      isScrolledToLeft: !0
    };
  },
  computed: {
    hasCustomTemplate() {
      return !!this.$slots["table-row"];
    },
    stickyColumns() {
      return this.fields.reduce((e, t, i) => (t.sticky && e.push(i), e), []);
    },
    sortedItems() {
      const e = this.fields.map((i) => i.key);
      if (this.sortBy === void 0 || !e.includes(this.sortBy))
        return this.items;
      const t = (i) => {
        const s = new Date(i);
        return !isNaN(s.getTime());
      };
      return this.items.slice().sort((i, s) => {
        const l = this.sortBy, d = i[l], n = s[l];
        if (t(d) && t(n)) {
          const a = String(d), o = String(n);
          return this.sortDesc ? new Date(o).getTime() - new Date(a).getTime() : new Date(a).getTime() - new Date(o).getTime();
        }
        const f = (d || "").toString().toLowerCase(), h = (n || "").toString().toLowerCase();
        return this.sortDesc ? h.localeCompare(f) : f.localeCompare(h);
      });
    },
    ariaSort() {
      return this.fields.reduce(
        (e, t) => (e[t.key] = t.sortable ? this.sortBy === t.key ? this.sortDesc ? "descending" : "ascending" : "none" : void 0, e),
        {}
      );
    }
  },
  watch: {
    items: {
      handler() {
        Vr(this.setStickyStyles);
      },
      deep: !0
    },
    isScrollable() {
      this.setStickyStyles();
    }
  },
  mounted() {
    this.observeTableWidth(), this.observeScrollPos();
  },
  methods: {
    updateSorting(e) {
      e.sortable && (e.key !== this.sortBy ? (this.$emit("update:sort-by", e.key), this.$emit("update:sort-desc", !1)) : this.$emit("update:sort-desc", !this.sortDesc));
    },
    observeTableWidth() {
      const e = this.$refs.table, t = this.$refs.tableWrapper, i = new ResizeObserver(() => {
        e.clientWidth && t.clientWidth && (this.isScrollable = e.clientWidth > t.clientWidth);
      });
      i.observe(t), i.observe(e);
    },
    observeScrollPos() {
      const e = this.$refs.tableWrapper;
      e.addEventListener("scroll", () => {
        this.isScrolledToRight = e.scrollWidth - e.scrollLeft - e.clientWidth < 2, this.isScrolledToLeft = e.scrollLeft < 2;
      });
    },
    setStickyStyles() {
      const e = this.$refs.table, t = this.$refs.tableWrapper;
      if (this.stickyColumns.length === 0)
        return;
      t.scrollLeft = 0;
      const i = e.querySelectorAll("tr");
      for (const s of Array.from(i)) {
        const l = s.querySelectorAll("th, td");
        for (const [d, n] of Array.from(l).entries())
          n.style.removeProperty("left"), n.removeAttribute("data-sticky"), this.stickyColumns.includes(+d) && (n.setAttribute("data-sticky", ""), n.style.left = +d !== this.stickyColumns[0] ? `${l[d - 1].getBoundingClientRect().width + 1}px` : `${n.offsetLeft}px`);
      }
    }
  }
}), Oa = {
  ref: "tableWrapper",
  class: "table-responsive"
}, Pa = {
  ref: "table",
  class: "table"
}, La = ["title", "aria-colindex", "aria-sort", "tabindex", "onClick"], Ia = {
  key: 1,
  class: "dps-table__header-label"
}, Na = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}, Ma = ["fill"], Ba = ["fill"];
function _a(e, t, i, s, l, d) {
  const n = se("DpsFormCheckbox"), f = se("DpsTableRow");
  return k(), P("div", {
    class: R(["dps-table", {
      "dps-table--scroll-shadow-right": e.isScrollable && !e.isScrolledToRight,
      "dps-table--scroll-shadow-left": e.isScrollable && !e.isScrolledToLeft,
      "dps-table--sticky": e.stickyColumns.length > 0
    }])
  }, [
    M("div", Oa, [
      M("table", Pa, [
        M("thead", {
          class: R({ "visually-hidden": e.hideHeader })
        }, [
          M("tr", null, [
            (k(!0), P(ae, null, we(e.fields, (h, a) => (k(), P("th", {
              key: "th-" + a,
              class: R(h.class),
              title: h.sortable ? `Reihenfolge der Spalte "${h.label}" ändern` : void 0,
              scope: "col",
              "aria-colindex": a + 1,
              "aria-sort": e.ariaSort[h.key],
              tabindex: h.sortable ? "0" : void 0,
              onClick: (o) => e.updateSorting(h)
            }, [
              h.checkbox ? (k(), ie(n, {
                key: 0,
                modelValue: h.checkboxChecked,
                "onUpdate:modelValue": [(o) => h.checkboxChecked = o, (o) => e.$emit("change-checked", a)],
                tooltip: h.label,
                "hide-label": !0,
                disabled: h.checkboxDisabled
              }, {
                default: z(() => [
                  Z(G(h.label), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "tooltip", "disabled"])) : (k(), P("div", Ia, [
                Z(G(h.label) + " ", 1),
                h.sortable ? (k(), P("svg", Na, [
                  M("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M4.19526 6.0286C3.93491 6.28895 3.93491 6.71106 4.19526 6.97141C4.45561 7.23175 4.87772 7.23175 5.13807 6.97141L8 4.10948L10.8619 6.97141C11.1223 7.23175 11.5444 7.23176 11.8047 6.97141C12.0651 6.71106 12.0651 6.28895 11.8047 6.0286L8.47141 2.69526C8.34638 2.57024 8.17681 2.5 8 2.5C7.82319 2.5 7.65362 2.57024 7.5286 2.69526L4.19526 6.0286Z",
                    fill: e.sortBy === h.key && !e.sortDesc ? "#04071A" : "#C8CACC"
                  }, null, 8, Ma),
                  M("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M11.8047 10.9714C12.0651 10.7111 12.0651 10.289 11.8047 10.0286C11.5444 9.76829 11.1223 9.76829 10.8619 10.0286L8 12.8906L5.13807 10.0286C4.87772 9.76829 4.45561 9.76829 4.19526 10.0286C3.93491 10.289 3.93491 10.7111 4.19526 10.9714L7.5286 14.3048C7.78895 14.5651 8.21106 14.5651 8.47141 14.3048L11.8047 10.9714Z",
                    fill: e.sortBy === h.key && e.sortDesc ? "#04071A" : "#C8CACC"
                  }, null, 8, Ba)
                ])) : U("", !0)
              ]))
            ], 10, La))), 128))
          ])
        ], 2),
        M("tbody", null, [
          e.hasCustomTemplate ? (k(!0), P(ae, { key: 0 }, we(e.sortedItems, (h, a) => (k(), ie(f, {
            key: "table-row-" + a,
            "collapse-colspan": e.collapseColspan ?? e.fields.length,
            "collapse-colstart": e.collapseColstart
          }, eu({
            default: z(() => [
              $(e.$slots, "table-row", { content: h })
            ]),
            _: 2
          }, [
            e.$slots["table-row-collapsible-content"] ? {
              name: "collapsible-content",
              fn: z(() => [
                $(e.$slots, "table-row-collapsible-content", { content: h })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["collapse-colspan", "collapse-colstart"]))), 128)) : (k(!0), P(ae, { key: 1 }, we(e.sortedItems, (h, a) => (k(), P("tr", { key: a }, [
            (k(!0), P(ae, null, we(e.fields, (o, m) => (k(), P("td", {
              key: a + "-" + m
            }, G(h[o.key] ?? "-"), 1))), 128))
          ]))), 128))
        ])
      ], 512)
    ], 512)
  ], 2);
}
const al = /* @__PURE__ */ W(Ca, [["render", _a]]), $a = te({
  name: "DpsLoadingSpinner",
  props: {
    /**
     * Aria label for the spinner.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: !1,
      default: "Laden"
    }
  }
}), Ra = ["aria-label"];
function Va(e, t, i, s, l, d) {
  return k(), P("div", {
    class: "dps-loading-spinner align-content-center d-flex gap-2",
    "aria-busy": "true",
    "aria-label": e.ariaLabel
  }, [
    $(e.$slots, "default"),
    t[0] || (t[0] = M("span", { class: "dps-icon dps-icon--loading-circle" }, null, -1))
  ], 8, Ra);
}
const ll = /* @__PURE__ */ W($a, [["render", Va]]);
function ol(e) {
  const t = e.querySelectorAll("[data-sticky]");
  for (const i of Array.from(t)) {
    const { width: s, height: l } = i.getBoundingClientRect(), d = i.closest("tr");
    i.style.width = `${s}px`, i.style.minWidth = `${s}px`, i.style.height = `${l}px`, d && (d.style.height = `${l}px`);
  }
}
window.Bootstrap = Rr;
export {
  Ha as DpsActionMenu,
  za as DpsActionMenuItem,
  Ds as DpsAlert,
  Ga as DpsAlphabeticFilter,
  li as DpsBadge,
  it as DpsButton,
  Ya as DpsCollapsible,
  qi as DpsFilterButton,
  tu as DpsFormCheckbox,
  Wa as DpsFormCheckboxGroup,
  rl as DpsFormDatepicker,
  Vs as DpsFormFile,
  Nr as DpsFormGroup,
  Ka as DpsFormInput,
  Tn as DpsFormRadio,
  Ja as DpsFormRadioGroup,
  Br as DpsFormSelect,
  Xa as DpsFormTextarea,
  tl as DpsFormToggle,
  xr as DpsIconButton,
  Ns as DpsInputGroup,
  Qa as DpsLink,
  nl as DpsListGroup,
  sl as DpsListGroupItem,
  ll as DpsLoadingSpinner,
  ul as DpsLogoutAlert,
  el as DpsPagination,
  Za as DpsSortSelect,
  al as DpsTable,
  Da as DpsTableRow,
  il as DpsUploadFormGroup,
  de as getUniqueId,
  ol as setStickyColumnStyles
};
